var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// build/index.ts
var build_exports = {};
__export(build_exports, {
  Ab: () => Ab_default,
  Ad: () => Ad_default,
  Ae: () => Ae_default,
  Af: () => Af_default,
  Ag: () => Ag_default,
  Ai: () => Ai_default,
  Al: () => Al_default,
  Am: () => Am_default,
  Ao: () => Ao_default,
  Ar: () => Ar_default,
  As: () => As_default,
  At: () => At_default,
  Au: () => Au_default,
  Aw: () => Aw_default,
  Ax: () => Ax_default,
  Az: () => Az_default,
  Ba: () => Ba_default,
  Bb: () => Bb_default,
  Bc: () => Bc_default,
  Bd: () => Bd_default,
  Be: () => Be_default,
  Bf: () => Bf_default,
  Bg: () => Bg_default,
  Bh: () => Bh_default,
  Bi: () => Bi_default,
  Bj: () => Bj_default,
  Bl: () => Bl_default,
  Bm: () => Bm_default,
  Bn: () => Bn_default,
  Bo: () => Bo_default,
  Bq: () => Bq_default,
  Br: () => Br_default,
  Bs: () => Bs_default,
  Bt: () => Bt_default,
  Bv: () => Bv_default,
  Bw: () => Bw_default,
  By: () => By_default,
  Bz: () => Bz_default,
  Ca: () => Ca_default,
  Cc: () => Cc_default,
  Cd: () => Cd_default,
  Ce: () => Ce_default,
  Cf: () => Cf_default,
  Cg: () => Cg_default,
  Ch: () => Ch_default,
  Ci: () => Ci_default,
  Ck: () => Ck_default,
  Cl: () => Cl_default,
  Cm: () => Cm_default,
  Cn: () => Cn_default,
  Co: () => Co_default,
  Cr: () => Cr_default,
  Ct: () => Ct_default,
  Cu: () => Cu_default,
  Cv: () => Cv_default,
  Cw: () => Cw_default,
  Cx: () => Cx_default,
  Cy: () => Cy_default,
  Cz: () => Cz_default,
  De: () => De_default,
  Dj: () => Dj_default,
  Dk: () => Dk_default,
  Dm: () => Dm_default,
  Do: () => Do_default,
  Dz: () => Dz_default,
  Ec: () => Ec_default,
  Ee: () => Ee_default,
  Eg: () => Eg_default,
  Eh: () => Eh_default,
  Er: () => Er_default,
  Es: () => Es_default,
  Et: () => Et_default,
  Eu: () => Eu_default,
  Fi: () => Fi_default,
  Fj: () => Fj_default,
  Fk: () => Fk_default,
  Fm: () => Fm_default,
  Fo: () => Fo_default,
  Fr: () => Fr_default,
  Ga: () => Ga_default,
  Gb: () => Gb_default,
  Gd: () => Gd_default,
  Ge: () => Ge_default,
  Gf: () => Gf_default,
  Gg: () => Gg_default,
  Gh: () => Gh_default,
  Gi: () => Gi_default,
  Gl: () => Gl_default,
  Gm: () => Gm_default,
  Gn: () => Gn_default,
  Gp: () => Gp_default,
  Gq: () => Gq_default,
  Gr: () => Gr_default,
  Gs: () => Gs_default,
  Gt: () => Gt_default,
  Gu: () => Gu_default,
  Gw: () => Gw_default,
  Gy: () => Gy_default,
  Hi: () => Hi_default,
  Hk: () => Hk_default,
  Hm: () => Hm_default,
  Hn: () => Hn_default,
  Hr: () => Hr_default,
  Ht: () => Ht_default,
  Hu: () => Hu_default,
  Ib: () => Ib_default,
  Ic: () => Ic_default,
  Id: () => Id_default,
  Ie: () => Ie_default,
  Il: () => Il_default,
  Im: () => Im_default,
  In: () => In_default,
  Io: () => Io_default,
  Iq: () => Iq_default,
  Ir: () => Ir_default,
  Is: () => Is_default,
  It: () => It_default,
  Je: () => Je_default,
  Jm: () => Jm_default,
  Jo: () => Jo_default,
  Jp: () => Jp_default,
  Ke: () => Ke_default,
  Kg: () => Kg_default,
  Kh: () => Kh_default,
  Ki: () => Ki_default,
  Km: () => Km_default,
  Kn: () => Kn_default,
  Kp: () => Kp_default,
  Kr: () => Kr_default,
  Kw: () => Kw_default,
  Ky: () => Ky_default,
  Kz: () => Kz_default,
  La: () => La_default,
  Lb: () => Lb_default,
  Lc: () => Lc_default,
  Li: () => Li_default,
  Lk: () => Lk_default,
  Lr: () => Lr_default,
  Ls: () => Ls_default,
  Lt: () => Lt_default,
  Lu: () => Lu_default,
  Lv: () => Lv_default,
  Ly: () => Ly_default,
  Ma: () => Ma_default,
  Mc: () => Mc_default,
  Md: () => Md_default,
  Me: () => Me_default,
  Mf: () => Mf_default,
  Mg: () => Mg_default,
  Mh: () => Mh_default,
  Mk: () => Mk_default,
  Ml: () => Ml_default,
  Mm: () => Mm_default,
  Mn: () => Mn_default,
  Mo: () => Mo_default,
  Mp: () => Mp_default,
  Mq: () => Mq_default,
  Mr: () => Mr_default,
  Ms: () => Ms_default,
  Mt: () => Mt_default,
  Mu: () => Mu_default,
  Mv: () => Mv_default,
  Mw: () => Mw_default,
  Mx: () => Mx_default,
  My: () => My_default,
  Mz: () => Mz_default,
  Na: () => Na_default,
  Nc: () => Nc_default,
  Ne: () => Ne_default,
  Nf: () => Nf_default,
  Ng: () => Ng_default,
  Ni: () => Ni_default,
  Nl: () => Nl_default,
  No: () => No_default,
  Np: () => Np_default,
  Nr: () => Nr_default,
  Nu: () => Nu_default,
  Nz: () => Nz_default,
  Om: () => Om_default,
  Or: () => Or_default,
  Pa: () => Pa_default,
  Pe: () => Pe_default,
  Pf: () => Pf_default,
  Pg: () => Pg_default,
  Ph: () => Ph_default,
  Pk: () => Pk_default,
  Pl: () => Pl_default,
  Pm: () => Pm_default,
  Pn: () => Pn_default,
  Pr: () => Pr_default,
  Ps: () => Ps_default,
  Pt: () => Pt_default,
  Pw: () => Pw_default,
  Py: () => Py_default,
  Qa: () => Qa_default,
  Re: () => Re_default,
  Rk: () => Rk_default,
  Ro: () => Ro_default,
  Rs: () => Rs_default,
  Ru: () => Ru_default,
  Rw: () => Rw_default,
  Sa: () => Sa_default,
  Sb: () => Sb_default,
  Sc: () => Sc_default,
  Sd: () => Sd_default,
  Se: () => Se_default,
  Sg: () => Sg_default,
  Sh: () => Sh_default,
  Si: () => Si_default,
  Sj: () => Sj_default,
  Sk: () => Sk_default,
  Sl: () => Sl_default,
  Sm: () => Sm_default,
  Sn: () => Sn_default,
  So: () => So_default,
  Sr: () => Sr_default,
  Ss: () => Ss_default,
  St: () => St_default,
  Sv: () => Sv_default,
  Sx: () => Sx_default,
  Sy: () => Sy_default,
  Sz: () => Sz_default,
  Tc: () => Tc_default,
  Td: () => Td_default,
  Tf: () => Tf_default,
  Tg: () => Tg_default,
  Th: () => Th_default,
  Tj: () => Tj_default,
  Tk: () => Tk_default,
  Tl: () => Tl_default,
  Tm: () => Tm_default,
  Tn: () => Tn_default,
  To: () => To_default,
  Tr: () => Tr_default,
  Tt: () => Tt_default,
  Tv: () => Tv_default,
  Tw: () => Tw_default,
  Tz: () => Tz_default,
  Ua: () => Ua_default,
  Ug: () => Ug_default,
  Um: () => Um_default,
  Un: () => Un_default,
  Us: () => Us_default,
  Uy: () => Uy_default,
  Uz: () => Uz_default,
  Va: () => Va_default,
  Vc: () => Vc_default,
  Ve: () => Ve_default,
  Vg: () => Vg_default,
  Vi: () => Vi_default,
  Vn: () => Vn_default,
  Vu: () => Vu_default,
  Wf: () => Wf_default,
  Ws: () => Ws_default,
  Xz: () => Xz_default,
  Ye: () => Ye_default,
  Yt: () => Yt_default,
  Za: () => Za_default,
  Zm: () => Zm_default,
  Zw: () => Zw_default
});

// build/Ab.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var SvgAb = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#6DA544",
          d: "M31 1H1v2.857h30V1ZM31 6.714H1v2.857h30V6.714ZM31 12.429H1v2.857h30v-2.857ZM31 18.142H1V21h30v-2.857Z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#D80027", d: "M16 1H1v8.571h15V1Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m7.847 7.706-.435-.87V5.097l1.087-.87 1.087.87v1.304l.435-.434v.87l-.87.869H7.847ZM5.509 5.04l.115.353h.373l-.302.22.116.354-.302-.22-.301.22.115-.355-.302-.219h.373l.115-.354ZM6.378 4.17l.115.354h.373l-.301.219.115.354-.302-.219-.301.22.115-.355-.301-.22h.372l.115-.353ZM7.25 3.3l.114.354h.373l-.301.22.115.354-.302-.22-.301.22.115-.355-.301-.219h.372L7.25 3.3ZM11.492 5.04l-.116.353h-.372l.301.22-.115.354.302-.22.3.22-.114-.355.301-.219h-.372l-.115-.354ZM10.62 4.17l-.115.354h-.372l.301.219-.115.354.301-.219.302.22-.115-.355.301-.22h-.373l-.115-.353ZM9.751 3.3l-.115.354h-.372l.301.22-.115.354.301-.22.302.22-.115-.355.301-.219h-.373L9.751 3.3ZM8.5 2.865l-.116.355h-.372l.301.218-.115.355.301-.22.302.22-.115-.355.301-.218h-.372l-.116-.355Z"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ab_default = SvgAb;

// build/Ad.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var SvgAd = (props) => /* @__PURE__ */ jsxs2(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx2("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx2("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx2(
        "path",
        {
          fill: "#D80027",
          d: "M31 1H21v20h10V1ZM16 14.478V11h2.609v1.304c0 .227-.435 1.057-1.508 1.74-.407.258-.827.34-1.101.434ZM16 8.391h-2.61V11H16V8.39Z"
        }
      ),
      /* @__PURE__ */ jsx2(
        "path",
        {
          fill: "#FF9811",
          d: "M17.304 7.521A.87.87 0 0 0 16 6.77a.87.87 0 0 0-1.304.752H12.52v4.348c0 1.619 1.286 2.555 2.294 3.04A.87.87 0 0 0 16 16.099a.87.87 0 0 0 1.185-1.19c1.007-.485 2.293-1.421 2.293-3.04V7.521h-2.174Zm.87 4.348c0 .227 0 .916-1.073 1.599a5.262 5.262 0 0 1-1.101.519 5.265 5.265 0 0 1-1.101-.52c-1.073-.682-1.073-1.371-1.073-1.598V8.826h4.348v3.043Z"
        }
      ),
      /* @__PURE__ */ jsx2("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ad_default = SvgAd;

// build/Ae.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var SvgAe = (props) => /* @__PURE__ */ jsxs3(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx3("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx3("path", { fill: "#6DA544", d: "M31 1H1v6.666h30V1Z" }),
      /* @__PURE__ */ jsx3("path", { fill: "#000", d: "M31 14.333H1v6.666h30v-6.666Z" }),
      /* @__PURE__ */ jsx3("path", { fill: "#A2001D", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx3("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ae_default = SvgAe;

// build/Af.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var SvgAf = (props) => /* @__PURE__ */ jsxs4(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx4("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx4("path", { fill: "#496E2D", d: "M31 1H20.348v20H31V1Z" }),
      /* @__PURE__ */ jsx4("path", { fill: "#000", d: "M11.652 1H1v20h10.652V1Z" }),
      /* @__PURE__ */ jsx4(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 7.521a3.478 3.478 0 1 0 0 6.957 3.478 3.478 0 0 0 0-6.957Zm0 5.653a2.174 2.174 0 1 1 0-4.348 2.174 2.174 0 0 1 0 4.348Z"
        }
      ),
      /* @__PURE__ */ jsx4(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 9.695a.87.87 0 0 0-.87.87v1.304h1.74v-1.304a.87.87 0 0 0-.87-.87Z"
        }
      ),
      /* @__PURE__ */ jsx4("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Af_default = SvgAf;

// build/Ag.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var SvgAg = (props) => /* @__PURE__ */ jsxs5(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx5("path", { fill: "#000", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx5(
        "path",
        {
          fill: "#0052B4",
          d: "M6.2 9a10.045 10.045 0 0 0 0 4l9.8.609 9.8-.61a10.044 10.044 0 0 0 0-4"
        }
      ),
      /* @__PURE__ */ jsx5(
        "path",
        {
          fill: "#FCFCFC",
          d: "M25.8 13H6.202c.927 4.564 4.962 8 9.8 8 4.838 0 8.873-3.436 9.8-8Z"
        }
      ),
      /* @__PURE__ */ jsx5(
        "path",
        {
          fill: "#FFDA44",
          d: "M20.348 9h-8.696l1.777-.836-.946-1.72 1.929.369.244-1.95L16 6.298l1.344-1.433.244 1.949 1.93-.37-.947 1.721L20.349 9Z"
        }
      ),
      /* @__PURE__ */ jsx5("path", { fill: "#A2001D", d: "M16 21 1 1v20h15ZM31 21V1L16 21h15Z" }),
      /* @__PURE__ */ jsx5("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ag_default = SvgAg;

// build/Ai.tsx
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var SvgAi = (props) => /* @__PURE__ */ jsxs6(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx6("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx6(
        "path",
        {
          fill: "#F3F3F3",
          d: "M26.064 13.333c.288-.396.48-.879.48-1.464V7.521a2.17 2.17 0 0 1-3.044-.435 2.17 2.17 0 0 1-3.043.436v4.347c0 .585.192 1.069.48 1.464h5.127Z"
        }
      ),
      /* @__PURE__ */ jsx6(
        "path",
        {
          fill: "#FF9811",
          d: "M25.16 11.063c.139-.338.246-.832.246-1.077 0-.395-.514-.715-.514-.715s-.515.32-.515.715c0 .245.108.739.246 1.077l-.297.67a1.498 1.498 0 0 0 1.131 0l-.297-.67ZM23.148 8.89c-.362.05-.843.203-1.056.326-.342.198-.361.803-.361.803s.534.286.876.089c.213-.123.586-.463.81-.752l.729-.078a1.501 1.501 0 0 0-.566-.98l-.432.593ZM22.273 11.719c.223.288.596.628.81.751.341.197.875-.088.875-.088s-.02-.606-.361-.803c-.213-.123-.694-.277-1.056-.326l-.432-.592a1.501 1.501 0 0 0-.566.98l.73.078Z"
        }
      ),
      /* @__PURE__ */ jsx6(
        "path",
        {
          fill: "#338AF3",
          d: "M20.828 13.174c.812 1.303 2.672 1.739 2.672 1.739s1.859-.437 2.67-1.74h-5.342Z"
        }
      ),
      /* @__PURE__ */ jsx6(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 6.937H9.437V11h.938V8.133L14.674 11H16l-4.688-3.125h1.326L16 10.116v-.441l-2.7-1.8H16v-.938ZM11.312 4.125 16 1h-1.326l-4.3 2.866V1h-.937v4.062H16v-.937h-2.7l2.7-1.8v-.441l-3.362 2.24h-1.326ZM6.625 1v2.866L2.325 1H1l4.688 3.125H4.362L1 1.884v.441l2.7 1.8H1v.937h6.562V1h-.937ZM1 6.937v.938h2.7L1 9.675v.441l3.362-2.241h1.326L1 11h1.326l4.299-2.867V11h.937V6.937H1Z"
        }
      ),
      /* @__PURE__ */ jsx6(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx6(
        "path",
        {
          fill: "#D80027",
          d: "M5.688 4.125 1 1v.884l3.362 2.24h1.325ZM11.313 4.125h1.325L16 1.884V1l-4.688 3.125ZM4.362 7.875 1 10.116V11l4.688-3.125H4.361ZM11.313 7.875 16 11v-.884l-3.362-2.241h-1.325Z"
        }
      ),
      /* @__PURE__ */ jsx6("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ai_default = SvgAi;

// build/Al.tsx
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var SvgAl = (props) => /* @__PURE__ */ jsxs7(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx7("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx7(
        "path",
        {
          fill: "#000",
          d: "M21.652 8.422H18.03A1.304 1.304 0 1 0 16 6.8a1.303 1.303 0 0 0-2.391.72c0 .35.137.667.36.9h-3.621c0 .961.836 1.74 1.797 1.74h-.058c0 .96.779 1.74 1.739 1.74 0 .31.082.602.225.854l-1.442 1.443 1.106 1.107 1.57-1.57c.062.022.125.04.191.053l-.949 2.142L16 17.52l1.472-1.591-.948-2.142c.065-.013.129-.03.19-.053l1.57 1.57 1.107-1.107-1.442-1.443c.143-.252.225-.544.225-.855.96 0 1.739-.779 1.739-1.739h-.058c.96 0 1.797-.779 1.797-1.74Z"
        }
      ),
      /* @__PURE__ */ jsx7("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Al_default = SvgAl;

// build/Am.tsx
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var SvgAm = (props) => /* @__PURE__ */ jsxs8(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx8("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx8("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx8("path", { fill: "#FF9811", d: "M31 14.334H1V21h30v-6.666Z" }),
      /* @__PURE__ */ jsx8("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Am_default = SvgAm;

// build/Ao.tsx
import { jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var SvgAo = (props) => /* @__PURE__ */ jsxs9(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx9("path", { fill: "#000", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx9("path", { fill: "#D80027", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx9(
        "path",
        {
          fill: "#FFDA44",
          d: "m14.629 8.953.848.616-.323.996.847-.616.848.615-.325-.996.847-.616h-1.047l-.325-.996-.323.997H14.63Z"
        }
      ),
      /* @__PURE__ */ jsx9(
        "path",
        {
          fill: "#FFDA44",
          d: "M18.5 6.67A4.968 4.968 0 0 0 16 6v1.304a3.672 3.672 0 0 1 1.848.494 3.7 3.7 0 0 1 1.353 5.048 3.7 3.7 0 0 1-5.049 1.353c-.514-.297-.929-.7-1.235-1.165l-1.089.72A4.97 4.97 0 0 0 13.5 15.33a5.006 5.006 0 0 0 6.83-1.83 5.006 5.006 0 0 0-1.83-6.83Z"
        }
      ),
      /* @__PURE__ */ jsx9(
        "path",
        {
          fill: "#FFDA44",
          d: "M13.117 10.13a1.304 1.304 0 0 0 .519 1.77l4.236 2.315c-.288.527-.135 1.168.391 1.456l1.145.626a1.087 1.087 0 0 0 1.475-.432l.626-1.144-8.392-4.59Z"
        }
      ),
      /* @__PURE__ */ jsx9("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ao_default = SvgAo;

// build/Ar.tsx
import { jsx as jsx10, jsxs as jsxs10 } from "react/jsx-runtime";
var SvgAr = (props) => /* @__PURE__ */ jsxs10(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx10("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx10("path", { fill: "#338AF3", d: "M31 1H1v6.667h30V1ZM31 14.334H1V21h30v-6.666Z" }),
      /* @__PURE__ */ jsx10(
        "path",
        {
          fill: "#FFDA44",
          d: "m18.392 11-.977.46.52.946-1.061-.203-.134 1.072-.74-.789-.739.789-.134-1.072-1.06.203.52-.946-.978-.46.977-.46-.52-.946 1.061.203.134-1.072.74.789.738-.789.135 1.072 1.06-.203-.52.947.978.46Z"
        }
      ),
      /* @__PURE__ */ jsx10("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ar_default = SvgAr;

// build/As.tsx
import { jsx as jsx11, jsxs as jsxs11 } from "react/jsx-runtime";
var SvgAs = (props) => /* @__PURE__ */ jsxs11(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx11("path", { fill: "#0052B4", d: "M31 1H1v19.836h30V1Z" }),
      /* @__PURE__ */ jsx11(
        "path",
        {
          fill: "#D80027",
          d: "M31 2.431 4.498 11.133 31 19.836V21L1 11.133l30-9.866V2.43Z"
        }
      ),
      /* @__PURE__ */ jsx11("path", { fill: "#FCFCFC", d: "M31 17.87v1.966L4.498 11.133 31 2.431v1.966" }),
      /* @__PURE__ */ jsx11(
        "path",
        {
          fill: "#A2001D",
          d: "M29.905 10.854H28.19a1.343 1.343 0 0 0-.084-1.82 1.344 1.344 0 0 0 0-1.91l-.032.031c.532-.528.564-1.415.032-1.943l-7.71 7.646c.533.528 1.38.522 1.913-.006l.148-.135 3.692-.333v1.575H27.4v-1.688l1.878-.169.626-1.248Z"
        }
      ),
      /* @__PURE__ */ jsx11(
        "path",
        {
          fill: "#FFDA44",
          d: "m20.514 14.492-1.252-.621 1.252-.621h8.14v1.242h-8.14Z"
        }
      ),
      /* @__PURE__ */ jsx11("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var As_default = SvgAs;

// build/At.tsx
import { jsx as jsx12, jsxs as jsxs12 } from "react/jsx-runtime";
var SvgAt = (props) => /* @__PURE__ */ jsxs12(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx12("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx12("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1ZM31 14.334H1V21h30v-6.666Z" }),
      /* @__PURE__ */ jsx12("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var At_default = SvgAt;

// build/Au.tsx
import { jsx as jsx13, jsxs as jsxs13 } from "react/jsx-runtime";
var SvgAu = (props) => /* @__PURE__ */ jsxs13(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx13("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx13(
        "path",
        {
          fill: "#FCFCFC",
          d: "m14.09 11 .048-.054-.048.054ZM12.087 13.456l.642 1.343 1.45-.335-.65 1.339 1.167.924-1.452.328.004 1.488-1.16-.931-1.162.93.004-1.487-1.451-.328 1.166-.924-.65-1.34 1.45.336.642-1.343ZM23.68 15.124l.306.64.692-.16-.31.64.556.44-.692.156.002.71-.554-.444-.554.444.002-.71-.692-.156.556-.44-.31-.64.692.16.306-.64ZM20.832 8.33l.306.641.692-.16-.31.64.556.44-.692.156.002.71-.554-.444-.554.444.002-.71-.692-.156.556-.44-.31-.64.692.16.306-.64ZM23.68 4.45l.306.64.692-.16-.31.638.556.441-.692.156.002.71-.554-.444-.554.444.002-.71-.692-.156.556-.44-.31-.64.692.16.306-.64ZM26.168 7.36l.306.64.692-.159-.31.639.556.44-.692.157.002.71-.554-.444-.554.444.002-.71-.692-.156.556-.441-.31-.639.692.16.306-.64ZM24.39 10.757l.24.741h.78l-.63.459.24.74-.63-.457-.631.458.24-.741-.63-.459h.78l.24-.74ZM16 1v1.79l-2.646 1.47H16V7.74h-3.463L16 9.663V11h-1.563L10.13 8.608V11H6.87V8.154L1.747 11H1V9.21l2.647-1.471H1V4.26h3.463L1 2.336V1h1.563L6.87 3.392V1h3.26v2.846L15.253 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx13(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx13("path", { fill: "#0052B4", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.34h-1.66Z" }),
      /* @__PURE__ */ jsx13("path", { fill: "#FCFCFC", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.34h-1.66Z" }),
      /* @__PURE__ */ jsx13(
        "path",
        {
          fill: "#D80027",
          d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.34h-1.66ZM5.21 7.739 1 10.078V11l5.87-3.261H5.21Z"
        }
      ),
      /* @__PURE__ */ jsx13("path", { fill: "#0052B4", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx13("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx13(
        "path",
        {
          fill: "#D80027",
          d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66ZM11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z"
        }
      ),
      /* @__PURE__ */ jsx13("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Au_default = SvgAu;

// build/Aw.tsx
import { jsx as jsx14, jsxs as jsxs14 } from "react/jsx-runtime";
var SvgAw = (props) => /* @__PURE__ */ jsxs14(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx14("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx14(
        "path",
        {
          fill: "#FCFCFC",
          d: "M3.845 5.786 1.89 4.923l1.954-.862.862-1.954.862 1.954 1.954.862-1.954.863-.862 1.953-.862-1.953Z"
        }
      ),
      /* @__PURE__ */ jsx14(
        "path",
        {
          fill: "#D80027",
          d: "m4.706 3.184.532 1.207 1.207.532-1.207.533-.532 1.207-.532-1.207-1.207-.533 1.207-.532.532-1.207Z"
        }
      ),
      /* @__PURE__ */ jsx14(
        "path",
        {
          fill: "#FFDA44",
          d: "M31 13.61H1v1.304h30v-1.305ZM31 16.218H1v1.305h30v-1.305Z"
        }
      ),
      /* @__PURE__ */ jsx14("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Aw_default = SvgAw;

// build/Ax.tsx
import { jsx as jsx15, jsxs as jsxs15 } from "react/jsx-runtime";
var SvgAx = (props) => /* @__PURE__ */ jsxs15(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx15("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx15(
        "path",
        {
          fill: "#FFDA44",
          d: "M31 13.337H12.847V21H8.174v-7.663H1V8.663h7.174V1h4.673v7.663H31V13.337Z"
        }
      ),
      /* @__PURE__ */ jsx15(
        "path",
        {
          fill: "#D80027",
          d: "M31 9.75v2.5H11.76V21h-2.5v-8.75H1v-2.5h8.26V1h2.5v8.75H31Z"
        }
      ),
      /* @__PURE__ */ jsx15("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ax_default = SvgAx;

// build/Az.tsx
import { jsx as jsx16, jsxs as jsxs16 } from "react/jsx-runtime";
var SvgAz = (props) => /* @__PURE__ */ jsxs16(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx16("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx16("path", { fill: "#338AF3", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx16("path", { fill: "#6DA544", d: "M31 14.334H1V21h30v-6.666Z" }),
      /* @__PURE__ */ jsx16(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16.188 13.438a2.438 2.438 0 1 1 1.159-4.582 3 3 0 1 0 0 4.29c-.345.186-.74.292-1.16.292Z"
        }
      ),
      /* @__PURE__ */ jsx16(
        "path",
        {
          fill: "#FCFCFC",
          d: "m18.063 9.313.322.908.87-.414-.413.87.908.323-.908.323.414.87-.87-.413-.323.908-.323-.908-.87.413.413-.87-.908-.323.908-.323-.414-.87.87.414.323-.908Z"
        }
      ),
      /* @__PURE__ */ jsx16("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Az_default = SvgAz;

// build/Ba.tsx
import { jsx as jsx17, jsxs as jsxs17 } from "react/jsx-runtime";
var SvgBa = (props) => /* @__PURE__ */ jsxs17(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx17("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx17("path", { fill: "#FFDA44", d: "M6.854 1h20v20" }),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "m3.143 1.897.87-.633.87.633L4.592 1H3.433l-.29.897Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "M6.175 2.072 5.842 1.05 5.51 2.072l-1.076.001.87.633-.331 1.023.87-.634.87.633-.332-1.024.87-.632H6.175Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "M8.007 3.904 7.674 2.88l-.332 1.024H6.266l.87.633-.331 1.023.87-.633.87.632-.332-1.023.87-.633H8.007Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "m9.84 5.735-.334-1.024-.332 1.024H8.098l.87.633-.331 1.023.87-.633.87.633-.332-1.024.87-.633-1.076.001Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "m11.67 7.567-.334-1.024-.332 1.024H9.928l.87.633-.33 1.023.869-.633.87.632-.332-1.024.87-.632H11.67Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "m13.501 9.398-.333-1.024-.332 1.024H11.76l.87.633-.33 1.023.869-.633.87.633-.332-1.024.87-.633h-1.076Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "M15.333 11.23 15 10.205l-.332 1.023-1.076.001.87.633-.33 1.023.869-.633.871.632-.333-1.024.87-.632h-1.076Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "m17.165 13.06-.333-1.023-.332 1.024h-1.076l.87.633-.33 1.023.869-.633.871.632-.333-1.023.87-.633h-1.076Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "m18.995 14.892-.333-1.024-.332 1.024h-1.076l.871.633-.332 1.023.87-.633.871.633-.333-1.024.87-.632h-1.076Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "m20.827 16.724-.333-1.024-.332 1.024h-1.076l.871.633-.332 1.023.87-.633.871.632-.333-1.024.87-.632h-1.076Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "m22.66 18.555-.334-1.024-.332 1.024h-1.076l.871.633-.332 1.023.87-.633.871.633-.333-1.024.87-.633H22.66Z"
        }
      ),
      /* @__PURE__ */ jsx17(
        "path",
        {
          fill: "#FCFCFC",
          d: "m24.157 19.363-.333 1.023-1.076.001.843.613h1.13l.845-.614H24.49l-.333-1.023Z"
        }
      ),
      /* @__PURE__ */ jsx17("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ba_default = SvgBa;

// build/Bb.tsx
import { jsx as jsx18, jsxs as jsxs18 } from "react/jsx-runtime";
var SvgBb = (props) => /* @__PURE__ */ jsxs18(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx18("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx18("path", { fill: "#0052B4", d: "M11 1H1v20h10V1ZM31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx18(
        "path",
        {
          fill: "#000",
          d: "m19.043 7.087-.583-.292c-.035.07-.797 1.62-.921 3.987h-.887V7.087L16 6.217l-.652.87v3.695h-.887c-.125-2.367-.886-3.917-.921-3.987l-1.167.583c.008.016.8 1.63.8 4.057v.652h2.175v3.695h1.304v-3.695h2.174v-.652c0-1.255.217-2.29.4-2.936.198-.706.4-1.118.401-1.122l-.584-.29Z"
        }
      ),
      /* @__PURE__ */ jsx18("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bb_default = SvgBb;

// build/Bc.tsx
import { jsx as jsx19, jsxs as jsxs19 } from "react/jsx-runtime";
var SvgBc = (props) => /* @__PURE__ */ jsxs19(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx19("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx19("path", { fill: "#FCFCFC", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx19("path", { fill: "#D80027", d: "M31 5.063H1v1.875h30V5.063Z" }),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#0052B4",
          d: "M23.305 7.739 31 9.663V7.739h-7.696ZM17.957 7.739 31 10.999v-.921l-9.355-2.34h-3.688ZM27.526 11l-9.569-2.393V11h9.57Z"
        }
      ),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#FCFCFC",
          d: "M17.957 7.739 31 10.999v-.921l-9.355-2.34h-3.688Z"
        }
      ),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#D80027",
          d: "M17.957 7.739 31 10.999v-.921l-9.355-2.34h-3.688Z"
        }
      ),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#0052B4",
          d: "M6.882 7.739 1 9.209V7.74h5.882ZM14.044 8.153V11H2.66l11.384-2.847Z"
        }
      ),
      /* @__PURE__ */ jsx19("path", { fill: "#D80027", d: "M10.355 7.739 1 10.078V11l13.043-3.261h-3.688Z" }),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#0052B4",
          d: "M8.696 4.26 1 2.338V4.26h7.696ZM14.044 4.26 1 1v.922l9.355 2.339h3.689ZM4.475 1l9.569 2.392V1h-9.57Z"
        }
      ),
      /* @__PURE__ */ jsx19("path", { fill: "#FCFCFC", d: "M14.044 4.26 1 1v.922l9.355 2.339h3.689Z" }),
      /* @__PURE__ */ jsx19("path", { fill: "#D80027", d: "M14.044 4.26 1 1v.922l9.355 2.339h3.689Z" }),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#0052B4",
          d: "M25.12 4.26 31 2.79v1.47h-5.88ZM17.957 3.846V1h11.384L17.957 3.846Z"
        }
      ),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#D80027",
          d: "M21.645 4.26 31 1.923V1L17.957 4.26h3.688ZM16.937 1h-1.875v10h1.875V1Z"
        }
      ),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#0052B4",
          d: "M31 11.928v1.308c-.26.044-.753.323-1.121.533-.642.364-1.249.709-1.828.709-.58 0-1.187-.345-1.83-.71-.4-.227-.948-.538-1.183-.538-.236 0-.784.311-1.185.539-.642.364-1.248.709-1.828.709-.58 0-1.186-.345-1.828-.71-.4-.227-.95-.538-1.185-.538-.235 0-.783.311-1.184.539-.642.364-1.248.709-1.828.709-.58 0-1.187-.345-1.829-.71-.4-.227-.949-.538-1.184-.538s-.784.311-1.184.539c-.642.364-1.249.709-1.829.709-.58 0-1.186-.345-1.828-.71-.4-.227-.949-.538-1.184-.538s-.784.311-1.184.539c-.643.364-1.249.709-1.83.709-.579 0-1.185-.345-1.827-.71-.368-.208-.861-.488-1.121-.532v-1.308c.56.023 1.147.355 1.765.707.4.227.95.539 1.184.539.236 0 .784-.312 1.184-.54.643-.364 1.25-.708 1.83-.708.579 0 1.185.344 1.827.709.4.227.95.539 1.185.539.235 0 .784-.312 1.184-.54.642-.364 1.248-.708 1.829-.708.58 0 1.186.344 1.828.709.4.227.949.539 1.184.539s.784-.312 1.184-.54c.642-.364 1.249-.708 1.828-.708.58 0 1.187.344 1.83.709.4.227.948.539 1.183.539.236 0 .784-.312 1.185-.54.642-.364 1.248-.708 1.828-.708.58 0 1.186.344 1.828.709.4.227.95.539 1.185.539.235 0 .783-.312 1.184-.54.618-.35 1.204-.683 1.765-.706ZM31 15.189v1.308c-.26.044-.753.323-1.121.533-.642.364-1.248.709-1.828.709-.58 0-1.186-.345-1.829-.71-.4-.227-.949-.538-1.184-.538-.236 0-.784.311-1.184.539-.642.364-1.249.709-1.829.709-.58 0-1.186-.345-1.828-.71-.4-.227-.95-.538-1.185-.538-.234 0-.783.311-1.183.539-.643.364-1.25.709-1.829.709-.58 0-1.186-.345-1.829-.71-.4-.227-.949-.538-1.183-.538-.236 0-.784.311-1.185.539-.642.364-1.249.709-1.828.709-.58 0-1.187-.345-1.828-.71-.4-.227-.95-.538-1.185-.538-.235 0-.784.311-1.184.539-.643.364-1.248.709-1.829.709-.58 0-1.186-.345-1.828-.71-.368-.209-.861-.488-1.121-.532v-1.308c.56.022 1.147.355 1.765.707.4.227.95.538 1.184.538.236 0 .784-.311 1.184-.538.643-.365 1.25-.71 1.83-.71.579 0 1.185.345 1.827.71.4.227.95.538 1.185.538.235 0 .784-.311 1.184-.538.642-.365 1.248-.71 1.829-.71.58 0 1.186.345 1.828.71.4.227.949.538 1.184.538s.784-.311 1.184-.538c.642-.365 1.249-.71 1.828-.71.58 0 1.187.345 1.83.71.4.227.948.538 1.183.538.236 0 .784-.311 1.185-.538.642-.365 1.248-.71 1.828-.71.58 0 1.186.345 1.828.71.4.227.95.538 1.185.538.235 0 .783-.311 1.184-.538.619-.352 1.205-.685 1.765-.707ZM31 18.45v1.308c-.26.043-.753.323-1.121.533-.642.364-1.248.708-1.828.708-.58 0-1.186-.344-1.829-.708-.4-.228-.949-.54-1.184-.54-.236 0-.784.312-1.184.54-.642.364-1.249.708-1.829.708-.58 0-1.186-.344-1.828-.708-.4-.228-.95-.54-1.185-.54-.234 0-.783.312-1.183.54-.643.364-1.25.708-1.829.708-.58 0-1.186-.344-1.829-.708-.4-.228-.949-.54-1.183-.54-.236 0-.784.312-1.185.54-.642.364-1.249.708-1.828.708-.58 0-1.187-.344-1.828-.708-.4-.228-.95-.54-1.185-.54-.235 0-.784.312-1.184.54-.643.364-1.248.708-1.829.708-.58 0-1.186-.344-1.828-.708-.368-.21-.861-.49-1.121-.533v-1.309c.56.023 1.147.356 1.765.707.4.227.95.54 1.184.54.236 0 .784-.313 1.184-.54.643-.364 1.25-.708 1.83-.708.579 0 1.185.344 1.827.708.4.227.95.54 1.185.54.235 0 .784-.313 1.184-.54.642-.364 1.248-.708 1.829-.708.58 0 1.186.344 1.828.708.4.227.949.54 1.184.54s.784-.313 1.184-.54c.642-.364 1.249-.708 1.828-.708.58 0 1.187.344 1.83.708.4.227.948.54 1.183.54.236 0 .784-.313 1.185-.54.642-.364 1.248-.708 1.828-.708.58 0 1.186.344 1.828.708.4.227.95.54 1.185.54.235 0 .783-.313 1.184-.54.619-.351 1.205-.684 1.765-.707Z"
        }
      ),
      /* @__PURE__ */ jsx19(
        "path",
        {
          fill: "#FFDA44",
          d: "m19.033 18.833 1.116-2.029-2.275.435-.289-2.298-1.584 1.69-1.585-1.69-.288 2.298-2.275-.435 1.115 2.03-2.095.985 2.095.985-.107.196h6.28l-.108-.196 2.095-.985-2.095-.986Z"
        }
      ),
      /* @__PURE__ */ jsx19("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bc_default = SvgBc;

// build/Bd.tsx
import { jsx as jsx20, jsxs as jsxs20 } from "react/jsx-runtime";
var SvgBd = (props) => /* @__PURE__ */ jsxs20(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx20("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx20(
        "path",
        {
          fill: "#D80027",
          d: "M13.827 15.348a4.348 4.348 0 1 0 0-8.696 4.348 4.348 0 0 0 0 8.696Z"
        }
      ),
      /* @__PURE__ */ jsx20("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bd_default = SvgBd;

// build/Be.tsx
import { jsx as jsx21, jsxs as jsxs21 } from "react/jsx-runtime";
var SvgBe = (props) => /* @__PURE__ */ jsxs21(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx21("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx21("path", { fill: "#000", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx21("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx21("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Be_default = SvgBe;

// build/Bf.tsx
import { jsx as jsx22, jsxs as jsxs22 } from "react/jsx-runtime";
var SvgBf = (props) => /* @__PURE__ */ jsxs22(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx22("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx22("path", { fill: "#D80027", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx22(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 7.521.756 2.325h2.445l-1.978 1.437.756 2.325L16 12.171l-1.978 1.437.756-2.325L12.8 9.846h2.444l.756-2.325Z"
        }
      ),
      /* @__PURE__ */ jsx22("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bf_default = SvgBf;

// build/Bg.tsx
import { jsx as jsx23, jsxs as jsxs23 } from "react/jsx-runtime";
var SvgBg = (props) => /* @__PURE__ */ jsxs23(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx23("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx23("path", { fill: "#FCFCFC", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx23("path", { fill: "#D80027", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx23("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bg_default = SvgBg;

// build/Bh.tsx
import { jsx as jsx24, jsxs as jsxs24 } from "react/jsx-runtime";
var SvgBh = (props) => /* @__PURE__ */ jsxs24(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx24("path", { fill: "#D80027", d: "M31.001 1H1.131v20H31V1Z" }),
      /* @__PURE__ */ jsx24(
        "path",
        {
          fill: "#FCFCFC",
          d: "m13.273 5.055-2.944 1.487 2.944 1.486-2.944 1.487L13.273 11l-2.944 1.487 2.944 1.486-2.944 1.487 2.944 1.487-2.944 1.486 2.944 1.487-2.136 1.08H1V1h10.133l2.14 1.08-2.944 1.487 2.944 1.487Z"
        }
      ),
      /* @__PURE__ */ jsx24("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bh_default = SvgBh;

// build/Bi.tsx
import { jsx as jsx25, jsxs as jsxs25 } from "react/jsx-runtime";
var SvgBi = (props) => /* @__PURE__ */ jsxs25(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx25("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx25(
        "path",
        {
          fill: "#6DA544",
          d: "M13.648 11 1 19.432V2.568L13.648 11ZM31 2.568v16.864L18.352 11 31 2.568Z"
        }
      ),
      /* @__PURE__ */ jsx25(
        "path",
        {
          fill: "#0052B4",
          d: "M31 2.568 18.352 11 31 19.432V21h-2.351L16 12.568 3.351 21H1v-1.568L13.648 11 1 2.568V1h2.351L16 9.432 28.649 1H31v1.568Z"
        }
      ),
      /* @__PURE__ */ jsx25(
        "path",
        {
          fill: "#FCFCFC",
          d: "M31 2.568 18.352 11 31 19.432V21h-2.351L16 12.568 3.351 21H1v-1.568L13.648 11 1 2.568V1h2.351L16 9.432 28.649 1H31v1.568Z"
        }
      ),
      /* @__PURE__ */ jsx25(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 15.348a4.348 4.348 0 1 0 0-8.696 4.348 4.348 0 0 0 0 8.696Z"
        }
      ),
      /* @__PURE__ */ jsx25(
        "path",
        {
          fill: "#D80027",
          d: "m16 7.957.377.652h.753l-.376.652.376.652h-.753l-.376.652-.377-.652h-.753l.377-.652-.377-.652h.753l.377-.652ZM14.087 11l.376.652h.753l-.376.652.376.652h-.753l-.376.653-.377-.652h-.753l.377-.653-.377-.652h.753l.377-.652ZM17.915 11l.376.652h.753l-.376.652.376.652h-.753l-.376.653-.377-.652h-.753l.377-.653-.377-.652h.753l.377-.652Z"
        }
      ),
      /* @__PURE__ */ jsx25("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bi_default = SvgBi;

// build/Bj.tsx
import { jsx as jsx26, jsxs as jsxs26 } from "react/jsx-runtime";
var SvgBj = (props) => /* @__PURE__ */ jsxs26(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx26("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx26("path", { fill: "#FFDA44", d: "M31 1H12.52v10H31V1Z" }),
      /* @__PURE__ */ jsx26("path", { fill: "#D80027", d: "M31 11H12.52v10H31V11Z" }),
      /* @__PURE__ */ jsx26("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bj_default = SvgBj;

// build/Bl.tsx
import { jsx as jsx27, jsxs as jsxs27 } from "react/jsx-runtime";
var SvgBl = (props) => /* @__PURE__ */ jsxs27(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx27("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx27("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx27("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx27("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bl_default = SvgBl;

// build/Bm.tsx
import { jsx as jsx28, jsxs as jsxs28 } from "react/jsx-runtime";
var SvgBm = (props) => /* @__PURE__ */ jsxs28(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx28("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx28("path", { fill: "#FCFCFC", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx28("path", { fill: "#D80027", d: "M1 1v.884l3.362 2.24h1.325L1 1Z" }),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#2E52B2",
          d: "M1 2.325v1.8h2.7L1 2.325ZM6.625 1v2.866L2.326 1h4.3Z"
        }
      ),
      /* @__PURE__ */ jsx28("path", { fill: "#D80027", d: "M16 1v.884l-3.362 2.24h-1.325L16 1Z" }),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#2E52B2",
          d: "M16 2.325v1.8h-2.7l2.7-1.8ZM10.375 1v2.866L14.675 1h-4.3Z"
        }
      ),
      /* @__PURE__ */ jsx28("path", { fill: "#D80027", d: "M1 1v.884l3.362 2.24h1.325L1 1Z" }),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#2E52B2",
          d: "M1 2.325v1.8h2.7L1 2.325ZM6.625 1v2.866L2.326 1h4.3Z"
        }
      ),
      /* @__PURE__ */ jsx28("path", { fill: "#D80027", d: "M16 1v.884l-3.362 2.24h-1.325L16 1Z" }),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#2E52B2",
          d: "M16 2.325v1.8h-2.7l2.7-1.8ZM10.375 1v2.866L14.675 1h-4.3Z"
        }
      ),
      /* @__PURE__ */ jsx28("path", { fill: "#D80027", d: "M1 11v-.884l3.362-2.241h1.325L1 11Z" }),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#2E52B2",
          d: "M1 9.674v-1.8h2.7L1 9.675ZM6.625 11V8.133l-4.299 2.865h4.3Z"
        }
      ),
      /* @__PURE__ */ jsx28("path", { fill: "#D80027", d: "M16 11v-.884l-3.362-2.241h-1.325L16 11Z" }),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#2E52B2",
          d: "M16 9.674v-1.8h-2.7l2.7 1.8ZM10.375 11V8.133l4.3 2.865h-4.3Z"
        }
      ),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#F3F3F3",
          d: "M20.457 7.087v4.782c0 2.33 6.087 2.33 6.087 0V7.087h-6.087Z"
        }
      ),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#6DA544",
          d: "M20.457 11.87c0 2.329 3.043 3.043 3.043 3.043s3.044-.714 3.044-3.044h-6.087Z"
        }
      ),
      /* @__PURE__ */ jsx28(
        "path",
        {
          fill: "#A2001D",
          d: "m23.5 9.956-1.412.609v1.304l1.413.87 1.413-.87v-1.304l-1.413-.609Z"
        }
      ),
      /* @__PURE__ */ jsx28("path", { fill: "#338AF3", d: "M24.912 9.26h-2.826v1.305h2.826V9.26Z" }),
      /* @__PURE__ */ jsx28("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bm_default = SvgBm;

// build/Bn.tsx
import { jsx as jsx29, jsxs as jsxs29 } from "react/jsx-runtime";
var SvgBn = (props) => /* @__PURE__ */ jsxs29(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx29("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx29("path", { fill: "#000", d: "m1 7.665 30 12.14V17.07l-13.99-5.531L1 4.93v2.735Z" }),
      /* @__PURE__ */ jsx29("path", { fill: "#FCFCFC", d: "M31 17.07v-2.735L1 2.195V4.93" }),
      /* @__PURE__ */ jsx29(
        "path",
        {
          fill: "#D80027",
          d: "M18.825 9.913a2.826 2.826 0 1 1-5.312-1.344 3.478 3.478 0 1 0 4.972 0c.217.4.34.858.34 1.344Z"
        }
      ),
      /* @__PURE__ */ jsx29("path", { fill: "#D80027", d: "M16.652 6.653h-1.304v6.52h1.304v-6.52Z" }),
      /* @__PURE__ */ jsx29(
        "path",
        {
          fill: "#D80027",
          d: "M18.173 7.957h-4.347c0 .3.262.543.562.543h-.018c0 .3.243.544.543.544 0 .3.243.543.543.543h1.087c.3 0 .544-.243.544-.543.3 0 .543-.244.543-.544h-.018a.56.56 0 0 0 .561-.543ZM19.043 13.608h-6.086v1.304h6.086v-1.304Z"
        }
      ),
      /* @__PURE__ */ jsx29(
        "path",
        {
          fill: "#D80027",
          d: "M19.913 14.043h-2.608v1.304h2.608v-1.304ZM14.696 14.043h-2.608v1.304h2.608v-1.304Z"
        }
      ),
      /* @__PURE__ */ jsx29("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bn_default = SvgBn;

// build/Bo.tsx
import { jsx as jsx30, jsxs as jsxs30 } from "react/jsx-runtime";
var SvgBo = (props) => /* @__PURE__ */ jsxs30(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx30("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx30("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx30("path", { fill: "#6DA544", d: "M31 14.334H1V21h30v-6.666Z" }),
      /* @__PURE__ */ jsx30("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bo_default = SvgBo;

// build/Bq.tsx
import { jsx as jsx31, jsxs as jsxs31 } from "react/jsx-runtime";
var SvgBq = (props) => /* @__PURE__ */ jsxs31(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx31("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx31("path", { fill: "#0052B4", d: "M1 21h30V1L1 21Z" }),
      /* @__PURE__ */ jsx31("path", { fill: "#FFDA44", d: "M15.674 1H1v9.782L15.674 1Z" }),
      /* @__PURE__ */ jsx31(
        "path",
        {
          fill: "#000",
          d: "m12.018 10.663.862-.467-.862-.467a3.045 3.045 0 0 0-2.541-2.541l-.467-.862-.467.862a3.046 3.046 0 0 0-2.54 2.54l-.862.468.861.467a3.045 3.045 0 0 0 2.541 2.54l.467.862.467-.861a3.045 3.045 0 0 0 2.54-2.541ZM9.01 11.935a1.74 1.74 0 1 1 0-3.479 1.74 1.74 0 0 1 0 3.479Z"
        }
      ),
      /* @__PURE__ */ jsx31(
        "path",
        {
          fill: "#D80027",
          d: "m9.01 8.891.377.653h.753l-.377.652.377.652h-.753l-.377.652-.376-.652H7.88l.376-.652-.376-.652h.753l.376-.653Z"
        }
      ),
      /* @__PURE__ */ jsx31("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bq_default = SvgBq;

// build/Br.tsx
import { jsx as jsx32, jsxs as jsxs32 } from "react/jsx-runtime";
var SvgBr = (props) => /* @__PURE__ */ jsxs32(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx32("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx32("path", { fill: "#FFDA44", d: "M16 5.473 23.5 11 16 16.526 8.5 11 16 5.473Z" }),
      /* @__PURE__ */ jsx32(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 14.158a3.158 3.158 0 1 0 0-6.316 3.158 3.158 0 0 0 0 6.316Z"
        }
      ),
      /* @__PURE__ */ jsx32(
        "path",
        {
          fill: "#0052B4",
          d: "M14.422 10.802c-.55 0-1.08.084-1.578.239a3.157 3.157 0 0 0 5.743 1.77 5.321 5.321 0 0 0-4.165-2.009ZM19.099 11.605a3.158 3.158 0 0 0-6.001-1.851 6.494 6.494 0 0 1 6.001 1.851Z"
        }
      ),
      /* @__PURE__ */ jsx32("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Br_default = SvgBr;

// build/Bs.tsx
import { jsx as jsx33, jsxs as jsxs33 } from "react/jsx-runtime";
var SvgBs = (props) => /* @__PURE__ */ jsxs33(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx33("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx33("path", { fill: "#338AF3", d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx33("path", { fill: "#000", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx33("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bs_default = SvgBs;

// build/Bt.tsx
import { jsx as jsx34, jsxs as jsxs34 } from "react/jsx-runtime";
var SvgBt = (props) => /* @__PURE__ */ jsxs34(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx34("path", { fill: "#FF9811", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx34("path", { fill: "#FFDA44", d: "M31 1H1v20" }),
      /* @__PURE__ */ jsx34(
        "path",
        {
          fill: "#FCFCFC",
          d: "M21.658 6.652v-1.74h-3.334l-.255.255c-.905.906-.753 1.963-.642 2.734.104.716.116.99-.15 1.256-.266.267-.54.254-1.256.151-.772-.111-1.829-.264-2.734.642-.906.906-.754 1.963-.642 2.734.103.716.115.99-.15 1.256-.267.266-.541.254-1.257.15a6.528 6.528 0 0 0-.875-.085l-.02 1.74c.194.001.414.033.647.067.276.04.589.085.918.085.34 0 .7-.049 1.054-.202v1.391h2.609v-1.304h-1.305v-.87h.87v-1.304h-.695c.033-.422-.025-.826-.075-1.172-.103-.716-.116-.99.15-1.256.267-.266.54-.254 1.256-.15.563.08 1.276.183 1.973-.118v1.392h2.608v-1.305H19.05v-.869h.87V8.826h-.695c.032-.422-.025-.826-.075-1.173-.073-.5-.1-.784-.02-1.001h2.529Z"
        }
      ),
      /* @__PURE__ */ jsx34("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bt_default = SvgBt;

// build/Bv.tsx
import { jsx as jsx35, jsxs as jsxs35 } from "react/jsx-runtime";
var SvgBv = (props) => /* @__PURE__ */ jsxs35(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx35("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx35(
        "path",
        {
          fill: "#496E2D",
          d: "M18.652 11 31 2.768V1h-2.652L16 9.232 3.652 1H1v1.768L13.348 11 1 19.232v1.767h2.652L16 12.767 28.348 21H31v-1.767L18.652 11Z"
        }
      ),
      /* @__PURE__ */ jsx35(
        "path",
        {
          fill: "#FCFCFC",
          d: "M17.304 9.695V1h-2.608v8.695H1v2.609H14.696v8.695h2.608v-8.695H31V9.695H17.304Z"
        }
      ),
      /* @__PURE__ */ jsx35("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bv_default = SvgBv;

// build/Bw.tsx
import { jsx as jsx36, jsxs as jsxs36 } from "react/jsx-runtime";
var SvgBw = (props) => /* @__PURE__ */ jsxs36(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx36("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx36("path", { fill: "#338AF3", d: "M31 14.913H1V21h30v-6.087ZM31 1H1v6.124h30V1Z" }),
      /* @__PURE__ */ jsx36("path", { fill: "#000", d: "M31 8.356H1v5.254h30V8.356Z" }),
      /* @__PURE__ */ jsx36("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bw_default = SvgBw;

// build/By.tsx
import { jsx as jsx37, jsxs as jsxs37 } from "react/jsx-runtime";
var SvgBy = (props) => /* @__PURE__ */ jsxs37(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx37("path", { fill: "#6DA544", d: "M31 1H1.034v20h29.968V1Z" }),
      /* @__PURE__ */ jsx37("path", { fill: "#A2001D", d: "M1 14.478h29.967V1H1" }),
      /* @__PURE__ */ jsx37("path", { fill: "#FCFCFC", d: "M6.863 14.478V1H1v20h29.967H6.863v-6.522Z" }),
      /* @__PURE__ */ jsx37(
        "path",
        {
          fill: "#A2001D",
          d: "M5.017 10.275 3.932 8.303l1.085-1.94 1.086 1.94-1.086 1.972ZM2.846 10.275 1.76 8.303l1.086-1.94 1.085 1.94-1.085 1.972ZM5.017 15.638l-1.085-1.972 1.085-1.941 1.086 1.94-1.086 1.973ZM2.846 15.638 1.76 13.666l1.086-1.941 1.085 1.94-1.085 1.973ZM5.017 21l-1.085-1.972 1.085-1.941 1.086 1.94L5.017 21ZM2.846 21 1.76 19.028l1.086-1.941 1.085 1.94L2.846 21ZM5.017 4.913 3.932 2.941 5.017 1 6.103 2.94 5.017 4.913ZM2.846 4.913 1.76 2.941 2.846 1 3.93 2.94 2.846 4.913Z"
        }
      ),
      /* @__PURE__ */ jsx37("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var By_default = SvgBy;

// build/Bz.tsx
import { jsx as jsx38, jsxs as jsxs38 } from "react/jsx-runtime";
var SvgBz = (props) => /* @__PURE__ */ jsxs38(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx38("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx38(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 15.782a4.782 4.782 0 1 0 0-9.565 4.782 4.782 0 0 0 0 9.565Z"
        }
      ),
      /* @__PURE__ */ jsx38(
        "path",
        {
          fill: "#6DA544",
          d: "M16.001 14.913a3.913 3.913 0 1 0 0-7.826 3.913 3.913 0 0 0 0 7.826Z"
        }
      ),
      /* @__PURE__ */ jsx38(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 13.608a2.609 2.609 0 1 0 0-5.217 2.609 2.609 0 0 0 0 5.217Z"
        }
      ),
      /* @__PURE__ */ jsx38(
        "path",
        {
          fill: "#0052B4",
          d: "M16 10.348 14.589 11v1.087l1.413.87 1.413-.87V11l-1.413-.652Z"
        }
      ),
      /* @__PURE__ */ jsx38("path", { fill: "#FFDA44", d: "M17.412 9.695h-2.826V11h2.826V9.695Z" }),
      /* @__PURE__ */ jsx38("path", { fill: "#A2001D", d: "M31 1H1v1.739h30V1ZM31 19.26H1V21h30v-1.74Z" }),
      /* @__PURE__ */ jsx38("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Bz_default = SvgBz;

// build/Ca.tsx
import { jsx as jsx39, jsxs as jsxs39 } from "react/jsx-runtime";
var SvgCa = (props) => /* @__PURE__ */ jsxs39(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx39("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx39(
        "path",
        {
          fill: "#D80027",
          d: "M11 1H1v20h10V1ZM31 1H21v20h10V1ZM17.875 12.389l1.875-.938-.938-.468v-.938l-1.875.938.938-1.875h-.938L16 7.7l-.938 1.407h-.937l.938 1.875-1.876-.938v.938l-.937.468 1.875.938-.469.937h1.875v1.407h.938v-1.407h1.875l-.469-.937Z"
        }
      ),
      /* @__PURE__ */ jsx39("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ca_default = SvgCa;

// build/Cc.tsx
import { jsx as jsx40, jsxs as jsxs40 } from "react/jsx-runtime";
var SvgCc = (props) => /* @__PURE__ */ jsxs40(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx40("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx40(
        "path",
        {
          fill: "#FFDA44",
          d: "m21.351 15.348.275.573.62-.143-.278.572.498.396-.62.14.001.635-.496-.398-.496.398.002-.636-.62-.14.498-.395-.278-.572.62.143.274-.573ZM18.799 9.26l.274.574.62-.143-.278.572.498.396-.62.14.002.636-.497-.399-.496.399.002-.636-.62-.14.498-.396-.278-.572.62.143.274-.573ZM21.351 5.782l.275.574.62-.143-.278.572.498.395-.62.14.001.636-.496-.398-.496.398.002-.636-.62-.14.498-.395-.278-.572.62.143.274-.574ZM23.58 8.391l.274.574.62-.143-.278.572.499.395-.62.14v.636l-.495-.398-.496.398.001-.636-.62-.14.498-.395-.277-.572.62.143.274-.574ZM21.987 11.434l.215.665h.699l-.565.41.216.665-.565-.411-.565.41.215-.664-.565-.41h.699l.216-.665Z"
        }
      ),
      /* @__PURE__ */ jsx40(
        "path",
        {
          fill: "#FFDA44",
          d: "M17.087 13.826a2.826 2.826 0 1 1 1.344-5.313 3.478 3.478 0 1 0 0 4.973c-.4.217-.858.34-1.344.34ZM12.29 4.913a1.738 1.738 0 0 0-3.013 0h3.012ZM12.294 4.923l-1.512 1.512L9.27 4.923a1.74 1.74 0 1 0 3.023 0Z"
        }
      ),
      /* @__PURE__ */ jsx40("path", { fill: "#A2001D", d: "M10.348 6v1.467a1.742 1.742 0 0 0 .87 0V6h-.87Z" }),
      /* @__PURE__ */ jsx40("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cc_default = SvgCc;

// build/Cd.tsx
import { jsx as jsx41, jsxs as jsxs41 } from "react/jsx-runtime";
var SvgCd = (props) => /* @__PURE__ */ jsxs41(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx41("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx41("path", { fill: "#FFDA44", d: "M31 4.92V1h-5.879L1 17.08V21h5.879L31 4.92Z" }),
      /* @__PURE__ */ jsx41("path", { fill: "#D80027", d: "M31 1v2.351L4.527 21H1v-2.351L27.473 1H31Z" }),
      /* @__PURE__ */ jsx41(
        "path",
        {
          fill: "#FFDA44",
          d: "m11.329 4.043.54 1.661h1.745l-1.412 1.027.54 1.66-1.413-1.026L9.916 8.39l.54-1.66-1.413-1.027h1.746l.54-1.66Z"
        }
      ),
      /* @__PURE__ */ jsx41("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cd_default = SvgCd;

// build/Ce.tsx
import { jsx as jsx42, jsxs as jsxs42 } from "react/jsx-runtime";
var SvgCe = (props) => /* @__PURE__ */ jsxs42(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx42("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx42(
        "path",
        {
          fill: "#000",
          d: "m6 1 10 10V1H6ZM1 21h5l10-10H1v10ZM26 21 16 11v10h10ZM26 1 16 11h15V1h-5Z"
        }
      ),
      /* @__PURE__ */ jsx42(
        "path",
        {
          fill: "#FFDA44",
          d: "M12.521 7.956 16 8.391l3.478-.435V5.87l-1.391.696L16 4.478l-2.087 2.087-1.392-.696v2.087Z"
        }
      ),
      /* @__PURE__ */ jsx42(
        "path",
        {
          fill: "#D80027",
          d: "M16 16.217a3.482 3.482 0 0 1-3.479-3.478V9.26l1.305-1.305h4.348l1.304 1.305v3.478A3.482 3.482 0 0 1 16 16.217Z"
        }
      ),
      /* @__PURE__ */ jsx42(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 14.913a2.176 2.176 0 0 1-2.174-2.174V9.26h4.348v3.478A2.176 2.176 0 0 1 16 14.913Z"
        }
      ),
      /* @__PURE__ */ jsx42(
        "path",
        {
          fill: "#FFDA44",
          d: "M13.826 7.956H12.52V9.26h1.305V7.956ZM19.478 7.956h-1.304V9.26h1.304V7.956ZM19.478 10.783h-1.304v1.304h1.304v-1.304ZM13.826 10.783H12.52v1.304h1.305v-1.304ZM16 14.913c-.227 0-.446-.036-.652-.1v1.342a3.478 3.478 0 0 0 1.304 0v-1.342c-.206.064-.425.1-.652.1ZM13.855 13.092l-1.04 1.04c.18.412.437.781.754 1.09l.922-.921a2.17 2.17 0 0 1-.636-1.21ZM19.186 14.133l-1.04-1.041a2.17 2.17 0 0 1-.636 1.209l.922.922c.316-.31.574-.68.754-1.09Z"
        }
      ),
      /* @__PURE__ */ jsx42(
        "path",
        {
          fill: "#0052B4",
          d: "M15.565 9.985v.725a.435.435 0 1 0 .87 0v-.725h-.87ZM15.565 12.884v.724a.435.435 0 1 0 .87 0v-.724h-.87ZM16.87 11.434v.725a.435.435 0 0 0 .869 0v-.725h-.87ZM15.565 11.434v.725a.435.435 0 0 0 .87 0v-.725h-.87ZM14.262 11.434v.725a.435.435 0 0 0 .87 0v-.725h-.87Z"
        }
      ),
      /* @__PURE__ */ jsx42("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ce_default = SvgCe;

// build/Cf.tsx
import { jsx as jsx43, jsxs as jsxs43 } from "react/jsx-runtime";
var SvgCf = (props) => /* @__PURE__ */ jsxs43(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx43("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx43("path", { fill: "#6DA544", d: "M13.391 11H1v5h12.391v-5ZM31 11H18.61v5H31v-5Z" }),
      /* @__PURE__ */ jsx43("path", { fill: "#0052B4", d: "M1 1v5h12.391V1h5.218v5H31V1H1Z" }),
      /* @__PURE__ */ jsx43("path", { fill: "#FCFCFC", d: "M31 6H18.61v5H31V6ZM13.391 6H1v5h12.391V6Z" }),
      /* @__PURE__ */ jsx43(
        "path",
        {
          fill: "#FFDA44",
          d: "M18.609 21H13.39v-5H1v5h30v-5H18.609v5ZM8.012 2.522l.27.83h.873l-.706.513.27.83-.707-.513-.706.513.27-.83-.707-.513h.873l.27-.83Z"
        }
      ),
      /* @__PURE__ */ jsx43("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cf_default = SvgCf;

// build/Cg.tsx
import { jsx as jsx44, jsxs as jsxs44 } from "react/jsx-runtime";
var SvgCg = (props) => /* @__PURE__ */ jsxs44(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx44("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx44("path", { fill: "#6DA544", d: "M27 1 7 21H1V1h26Z" }),
      /* @__PURE__ */ jsx44("path", { fill: "#FFDA44", d: "m30.304 1-20 20H1.695l20-20h8.609Z" }),
      /* @__PURE__ */ jsx44("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cg_default = SvgCg;

// build/Ch.tsx
import { jsx as jsx45, jsxs as jsxs45 } from "react/jsx-runtime";
var SvgCh = (props) => /* @__PURE__ */ jsxs45(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx45("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx45(
        "path",
        {
          fill: "#FCFCFC",
          d: "M21.87 9.043h-3.913V5.13h-3.913v3.913H10.13v3.914h3.913v3.913h3.913v-3.913h3.913V9.043Z"
        }
      ),
      /* @__PURE__ */ jsx45("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ch_default = SvgCh;

// build/Ci.tsx
import { jsx as jsx46, jsxs as jsxs46 } from "react/jsx-runtime";
var SvgCi = (props) => /* @__PURE__ */ jsxs46(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx46("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx46("path", { fill: "#6DA544", d: "M31 1H20.348v20H31V1Z" }),
      /* @__PURE__ */ jsx46("path", { fill: "#FF9811", d: "M11.652 1H1v20h10.652V1Z" }),
      /* @__PURE__ */ jsx46("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ci_default = SvgCi;

// build/Ck.tsx
import { jsx as jsx47, jsxs as jsxs47 } from "react/jsx-runtime";
var SvgCk = (props) => /* @__PURE__ */ jsxs47(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx47("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx47(
        "path",
        {
          fill: "#FCFCFC",
          d: "m23.5 5.182.31.952h1.001l-.81.589.31.952-.81-.588-.81.588.309-.952-.81-.589h1l.31-.952ZM19.386 6.886l.893.455.707-.708-.156.989.892.454-.989.157-.157.989-.454-.892-.99.156.709-.708-.455-.892ZM17.682 11l.952-.31V9.69l.589.81.952-.31-.589.81.589.81-.952-.309-.589.81v-1l-.952-.31ZM19.386 15.114l.455-.893-.708-.708.989.157.454-.892.157.989.99.156-.893.455.157.989-.708-.708-.893.454ZM23.5 16.817l-.31-.952h-1l.81-.588-.31-.953.81.589.81-.589-.309.953.81.588H23.81l-.31.952ZM27.613 15.114l-.892-.455-.708.708.157-.99-.893-.454.99-.156.156-.99.455.893.989-.157-.709.708.455.893ZM29.318 11l-.953.31v1l-.588-.81-.953.31.589-.81-.589-.81.953.309.588-.81v1.001l.953.31ZM27.613 6.886l-.454.892.708.708-.99-.156-.454.892-.157-.99-.989-.156.893-.454-.157-.99.708.709.892-.455ZM1 6.937v.938h2.7L1 9.675v.441l3.362-2.241h1.325L1 11h6.563V6.937H1ZM6.625 11h-4.3l4.3-2.866V11ZM11.313 4.125 16 1H9.437v4.062H16v-.937h-2.7l2.7-1.8v-.441l-3.362 2.24h-1.325v.001ZM10.374 1h4.3l-4.3 2.866V1ZM9.438 11H16l-4.688-3.125h1.326L16 10.116v-.441l-2.7-1.8H16v-.938H9.437V11Zm.937-2.866 4.3 2.866h-4.3V8.134ZM7.563 1H1l4.688 3.125H4.361L1 1.884v.441l2.7 1.8H1v.937h6.563V1Zm-.938 2.866L2.325 1h4.3v2.866Z"
        }
      ),
      /* @__PURE__ */ jsx47(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx47(
        "path",
        {
          fill: "#D80027",
          d: "M5.688 4.125 1 1v.884l3.362 2.241h1.325ZM11.313 4.125h1.325L16 1.884V1l-4.688 3.125ZM4.362 7.875 1 10.116V11l4.688-3.125H4.361ZM11.313 7.875 16 11v-.884l-3.362-2.241h-1.325Z"
        }
      ),
      /* @__PURE__ */ jsx47("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ck_default = SvgCk;

// build/Cl.tsx
import { jsx as jsx48, jsxs as jsxs48 } from "react/jsx-runtime";
var SvgCl = (props) => /* @__PURE__ */ jsxs48(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx48("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx48("path", { fill: "#FCFCFC", d: "M31 1H16v10h15V1Z" }),
      /* @__PURE__ */ jsx48("path", { fill: "#0052B4", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx48(
        "path",
        {
          fill: "#FCFCFC",
          d: "m8.5 2.433.885 2.725h2.865L9.932 6.842l.886 2.724L8.5 7.883 6.182 9.566l.886-2.724L4.75 5.158h2.865L8.5 2.433Z"
        }
      ),
      /* @__PURE__ */ jsx48("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cl_default = SvgCl;

// build/Cm.tsx
import { jsx as jsx49, jsxs as jsxs49 } from "react/jsx-runtime";
var SvgCm = (props) => /* @__PURE__ */ jsxs49(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx49("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx49("path", { fill: "#496E2D", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx49(
        "path",
        {
          fill: "#FFDA44",
          d: "M31 1H21v20h10V1ZM16 8.217l.69 2.126h2.236l-1.808 1.313.69 2.126L16 12.468l-1.808 1.314.69-2.126-1.808-1.313h2.235L16 8.217Z"
        }
      ),
      /* @__PURE__ */ jsx49("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cm_default = SvgCm;

// build/Cn.tsx
import { jsx as jsx50, jsxs as jsxs50 } from "react/jsx-runtime";
var SvgCn = (props) => /* @__PURE__ */ jsxs50(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx50("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx50(
        "path",
        {
          fill: "#FFDA44",
          d: "m11.484 7.108.858 2.642h2.78l-2.249 1.634.859 2.643-2.248-1.633-2.249 1.633.859-2.643L7.846 9.75h2.779l.859-2.642ZM16.897 15.898l-.843-.613-.843.613.322-.991-.843-.613h1.042l.322-.99.322.99h1.042l-.843.613.322.991ZM19.096 12.87h-1.043l-.322.992-.322-.991h-1.042l.843-.613-.322-.991.843.613.843-.613-.322.991.844.613ZM19.096 9.129l-.843.612.322.991-.844-.612-.843.613.322-.992-.843-.612h1.043l.321-.991.322.99h1.043ZM16.897 6.101l-.322.992.843.612h-1.042l-.322.991-.322-.99H14.69l.843-.613-.322-.992.843.613.843-.613Z"
        }
      ),
      /* @__PURE__ */ jsx50("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cn_default = SvgCn;

// build/Co.tsx
import { jsx as jsx51, jsxs as jsxs51 } from "react/jsx-runtime";
var SvgCo = (props) => /* @__PURE__ */ jsxs51(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx51("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx51("path", { fill: "#D80027", d: "M31 16.103H1V21h30v-4.897Z" }),
      /* @__PURE__ */ jsx51("path", { fill: "#0052B4", d: "M31 11H1v5.103h30V11Z" }),
      /* @__PURE__ */ jsx51("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Co_default = SvgCo;

// build/Cr.tsx
import { jsx as jsx52, jsxs as jsxs52 } from "react/jsx-runtime";
var SvgCr = (props) => /* @__PURE__ */ jsxs52(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx52("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx52("path", { fill: "#D80027", d: "M31 8.391H1v5.217h30V8.391Z" }),
      /* @__PURE__ */ jsx52("path", { fill: "#0052B4", d: "M31 16.652H1V21h30v-4.348ZM31 1H1v4.348h30V1Z" }),
      /* @__PURE__ */ jsx52("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cr_default = SvgCr;

// build/Ct.tsx
import { jsx as jsx53, jsxs as jsxs53 } from "react/jsx-runtime";
var SvgCt = (props) => /* @__PURE__ */ jsxs53(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx53("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx53("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx53(
        "path",
        {
          fill: "#FCFCFC",
          d: "M18.652 11 31 2.768V1h-2.652L16 9.232 3.652 1H1v1.768L13.348 11 1 19.232V21h2.652L16 12.768 28.348 21H31v-1.768L18.652 11Z"
        }
      ),
      /* @__PURE__ */ jsx53("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ct_default = SvgCt;

// build/Cu.tsx
import { jsx as jsx54, jsxs as jsxs54 } from "react/jsx-runtime";
var SvgCu = (props) => /* @__PURE__ */ jsxs54(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx54("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx54("path", { fill: "#0052B4", d: "M31 1H1v4h30V1ZM31 9H1v4h30V9ZM31 17H1v4h30v-4Z" }),
      /* @__PURE__ */ jsx54("path", { fill: "#D80027", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx54(
        "path",
        {
          fill: "#FCFCFC",
          d: "m5.891 8.391.648 1.993h2.095L6.94 11.616l.647 1.993-1.695-1.232-1.695 1.232.648-1.993-1.696-1.232h2.096l.647-1.993Z"
        }
      ),
      /* @__PURE__ */ jsx54("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cu_default = SvgCu;

// build/Cv.tsx
import { jsx as jsx55, jsxs as jsxs55 } from "react/jsx-runtime";
var SvgCv = (props) => /* @__PURE__ */ jsxs55(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx55("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx55("path", { fill: "#D80027", d: "M31 14.913H1v1.304h30v-1.304Z" }),
      /* @__PURE__ */ jsx55(
        "path",
        {
          fill: "#FCFCFC",
          d: "M31 13.608H1v1.305h30v-1.305ZM31 16.217H1v1.304h30v-1.304Z"
        }
      ),
      /* @__PURE__ */ jsx55(
        "path",
        {
          fill: "#FFDA44",
          d: "m11.57 11.309.176.542h.57l-.461.335.176.541-.461-.334-.461.334.176-.541-.46-.335h.569l.176-.542ZM11.57 18.402l.176.542h.57l-.461.335.176.542-.461-.335-.461.335.176-.542-.46-.335h.569l.176-.542ZM8.267 16.003l.176.542h.57l-.46.335.175.542-.46-.335-.462.335.176-.542-.46-.335h.57l.175-.542ZM9.529 12.018l.176.542h.57l-.461.335.176.542-.461-.335-.46.335.175-.542-.46-.335h.569l.176-.542ZM7.521 14.25h.57l.176-.542.176.542h.57l-.46.335.175.541-.46-.334-.462.334.176-.541-.46-.335ZM9.068 19.008l.176-.542-.46-.335h.569l.176-.542.176.542h.57l-.461.335.176.542-.461-.335-.46.335ZM14.87 16.003l-.175.542h-.57l.46.335-.175.542.46-.335.462.335-.176-.542.46-.335h-.57l-.175-.542ZM13.61 12.018l-.177.542h-.57l.461.335-.176.542.461-.335.461.335-.176-.542.461-.335h-.57l-.176-.542ZM15.617 14.25h-.57l-.176-.542-.176.542h-.57l.461.335-.176.541.46-.334.462.334-.176-.541.46-.335ZM14.07 19.008l-.176-.542.461-.335h-.57l-.176-.542-.176.542h-.57l.461.335-.176.542.461-.335.461.335Z"
        }
      ),
      /* @__PURE__ */ jsx55("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cv_default = SvgCv;

// build/Cw.tsx
import { jsx as jsx56, jsxs as jsxs56 } from "react/jsx-runtime";
var SvgCw = (props) => /* @__PURE__ */ jsxs56(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx56("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx56("path", { fill: "#FFDA44", d: "M31 15.063H1v1.874h30v-1.875Z" }),
      /* @__PURE__ */ jsx56(
        "path",
        {
          fill: "#FCFCFC",
          d: "m9.542 4.696.54 1.66h1.745l-1.412 1.027.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.027h1.746l.54-1.66ZM6.543 2.957l.324.996h1.048l-.848.616.324.996-.848-.616-.847.616.323-.996-.847-.616H6.22l.323-.996Z"
        }
      ),
      /* @__PURE__ */ jsx56("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cw_default = SvgCw;

// build/Cx.tsx
import { jsx as jsx57, jsxs as jsxs57 } from "react/jsx-runtime";
var SvgCx = (props) => /* @__PURE__ */ jsxs57(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx57("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx57("path", { fill: "#6DA544", d: "M1 1h30v20" }),
      /* @__PURE__ */ jsx57(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 13.608a2.609 2.609 0 1 0 0-5.217 2.609 2.609 0 0 0 0 5.217Z"
        }
      ),
      /* @__PURE__ */ jsx57(
        "path",
        {
          fill: "#FCFCFC",
          d: "m8.474 16.652.275.574.62-.144-.278.573.498.395-.62.14.002.636-.497-.398-.496.398.002-.636-.62-.14.498-.395-.278-.573.62.144.274-.574ZM6.68 11.87l.274.573.62-.143-.278.572.498.395-.62.14.002.636-.497-.398-.496.398.002-.636-.62-.14.498-.395-.278-.572.62.143.274-.574ZM8.474 7.956l.275.574.62-.143-.278.572.498.395-.62.14.001.636-.496-.398-.496.398.002-.636-.62-.14.498-.395-.278-.572.62.143.274-.574ZM10.705 11l.274.574.62-.144-.278.573.499.395-.62.14v.636l-.495-.398-.496.398.001-.636-.62-.14.498-.395-.277-.573.62.144.274-.574ZM9.11 13.608l.215.665h.699l-.565.41.216.665-.565-.411-.565.41.215-.664-.565-.41h.699l.216-.665Z"
        }
      ),
      /* @__PURE__ */ jsx57(
        "path",
        {
          fill: "#6DA544",
          d: "M15.999 12.739h.87s.376-.667 0-1.304l.87-.87-.436-.87h-.434s-.218.653-1.088.653c-.87 0-1.086-.653-1.086-.653h-.435l.435.87-.435.87.435.434s.434-.87 1.304-.434c0 0 .37.543 0 1.304Z"
        }
      ),
      /* @__PURE__ */ jsx57(
        "path",
        {
          fill: "#FFDA44",
          d: "M24.23 7.767a1.74 1.74 0 0 0-1.172-1.984 3.246 3.246 0 0 1 .293 1.948 1.785 1.785 0 0 0-2.502-.546c.484.105.952.32 1.367.65.324.258.586.607.787.944l-2.655.832c2.608.435 4.782-1.305 4.782-1.305-.24-.481-.615-.562-.9-.54Z"
        }
      ),
      /* @__PURE__ */ jsx57("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cx_default = SvgCx;

// build/Cy.tsx
import { jsx as jsx58, jsxs as jsxs58 } from "react/jsx-runtime";
var SvgCy = (props) => /* @__PURE__ */ jsxs58(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx58("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx58(
        "path",
        {
          fill: "#6DA544",
          d: "M21.625 9.704h-1.298a4.327 4.327 0 0 1-8.654 0h-1.298a5.627 5.627 0 0 0 4.09 5.413 1.44 1.44 0 0 0 .15 1.571l1.414-1.133 1.414 1.133a1.44 1.44 0 0 0 .143-1.586 5.627 5.627 0 0 0 4.039-5.398Z"
        }
      ),
      /* @__PURE__ */ jsx58(
        "path",
        {
          fill: "#FFDA44",
          d: "M12.54 9.271s0 2.164 2.163 2.164l.432.432h.866s.432-1.298 1.298-1.298c0 0 0-.865.865-.865h1.298s-.433-1.73 1.73-3.029l-.864-.432s-3.03 2.163-5.193 1.73v.866h-.865l-.433-.433-1.298.865Z"
        }
      ),
      /* @__PURE__ */ jsx58("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cy_default = SvgCy;

// build/Cz.tsx
import { jsx as jsx59, jsxs as jsxs59 } from "react/jsx-runtime";
var SvgCz = (props) => /* @__PURE__ */ jsxs59(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx59("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx59("path", { fill: "#D80027", d: "M31 11v10H1l12.608-10H31Z" }),
      /* @__PURE__ */ jsx59("path", { fill: "#FCFCFC", d: "M31 1v10H13.608L1 1h30Z" }),
      /* @__PURE__ */ jsx59("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Cz_default = SvgCz;

// build/De.tsx
import { jsx as jsx60, jsxs as jsxs60 } from "react/jsx-runtime";
var SvgDe = (props) => /* @__PURE__ */ jsxs60(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx60("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx60("path", { fill: "#000", d: "M31 1H1v6.666h30V1Z" }),
      /* @__PURE__ */ jsx60("path", { fill: "#FFDA44", d: "M31 14.333H1v6.666h30v-6.666Z" }),
      /* @__PURE__ */ jsx60("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var De_default = SvgDe;

// build/Dj.tsx
import { jsx as jsx61, jsxs as jsxs61 } from "react/jsx-runtime";
var SvgDj = (props) => /* @__PURE__ */ jsxs61(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx61("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx61("path", { fill: "#338AF3", d: "M31 1v9.767L1 11.01V1h30Z" }),
      /* @__PURE__ */ jsx61("path", { fill: "#FCFCFC", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx61(
        "path",
        {
          fill: "#D80027",
          d: "m6.544 8.391.647 1.993h2.096L7.59 11.616l.648 1.993-1.695-1.232-1.696 1.232.648-1.993-1.695-1.232h2.095l.648-1.993Z"
        }
      ),
      /* @__PURE__ */ jsx61("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Dj_default = SvgDj;

// build/Dk.tsx
import { jsx as jsx62, jsxs as jsxs62 } from "react/jsx-runtime";
var SvgDk = (props) => /* @__PURE__ */ jsxs62(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx62("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx62(
        "path",
        {
          fill: "#FCFCFC",
          d: "M12.25 1H8.5v8.125H1v3.75h7.5V21h3.75v-8.125H31v-3.75H12.25V1Z"
        }
      ),
      /* @__PURE__ */ jsx62("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Dk_default = SvgDk;

// build/Dm.tsx
import { jsx as jsx63, jsxs as jsxs63 } from "react/jsx-runtime";
var SvgDm = (props) => /* @__PURE__ */ jsxs63(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx63("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx63("path", { fill: "#000", d: "M1 9.125v3.75h30v-3.75H1Z" }),
      /* @__PURE__ */ jsx63("path", { fill: "#FFDA44", d: "M31 9.125H1v1.25h30v-1.25Z" }),
      /* @__PURE__ */ jsx63("path", { fill: "#FCFCFC", d: "M31 11.625H1v1.25h30v-1.25Z" }),
      /* @__PURE__ */ jsx63("path", { fill: "#000", d: "M17.875 1h-3.75v20h3.75V1Z" }),
      /* @__PURE__ */ jsx63("path", { fill: "#FFDA44", d: "M15.375 1h-1.25v20h1.25V1Z" }),
      /* @__PURE__ */ jsx63("path", { fill: "#FCFCFC", d: "M17.875 1h-1.25v20h1.25V1Z" }),
      /* @__PURE__ */ jsx63(
        "path",
        {
          fill: "#D80027",
          d: "M16 15.783a4.782 4.782 0 1 0 0-9.565 4.782 4.782 0 0 0 0 9.565Z"
        }
      ),
      /* @__PURE__ */ jsx63(
        "path",
        {
          fill: "#496E2D",
          d: "M17.09 11.534c-.356-.712-.818-1.433-.818-1.433s.011-.328.011-.524a.534.534 0 0 0-1.065-.046.42.42 0 0 0-.166.793.606.606 0 0 1 .36-.334.53.53 0 0 0 .084.057l.069.033s-.254.714-.254 1.098c0 1.079.712 1.412.712 1.412v.01l-.356.357h.711v-.712l.356.356c.003-.007.674-.431.356-1.067ZM16 7.087l.162.498h.524l-.424.308.162.498L16 8.083l-.424.308.162-.498-.423-.308h.523L16 7.087ZM13.7 7.834l.424.308.424-.308-.162.498.424.308h-.524l-.162.499-.162-.499h-.524l.424-.308-.162-.498ZM12.278 9.79h.524l.162-.497.162.498h.524l-.424.308.162.498-.424-.308-.424.308.162-.498-.424-.308ZM12.278 12.21l.424-.309-.162-.498.424.308.424-.308-.162.498.424.308h-.524l-.162.498-.162-.498h-.524ZM13.7 14.166l.162-.498-.424-.308h.524l.162-.499.162.499h.524l-.424.308.162.498-.424-.308-.424.308ZM16 14.913l-.162-.498h-.523l.423-.308-.162-.498.424.308.424-.308-.162.498.424.308h-.524l-.162.498ZM18.3 14.166l-.424-.308-.424.308.162-.498-.424-.308h.524l.162-.499.162.499h.524l-.424.308.162.498ZM19.721 12.21h-.524l-.162.497-.162-.498h-.523l.423-.308-.162-.498.424.308.424-.308-.162.498.424.308ZM19.721 9.79l-.424.309.162.498-.424-.308-.423.308.162-.498-.424-.308h.523l.162-.498.162.498h.524ZM18.3 7.834l-.162.498.424.308h-.524l-.162.499-.162-.499h-.524l.424-.308-.162-.498.424.308.424-.308Z"
        }
      ),
      /* @__PURE__ */ jsx63("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Dm_default = SvgDm;

// build/Do.tsx
import { jsx as jsx64, jsxs as jsxs64 } from "react/jsx-runtime";
var SvgDo = (props) => /* @__PURE__ */ jsxs64(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx64("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx64("path", { fill: "#D80027", d: "M13.391 13.609H1V21h12.391v-7.391Z" }),
      /* @__PURE__ */ jsx64("path", { fill: "#0052B4", d: "M13.391 1H1v7.392h12.391V1Z" }),
      /* @__PURE__ */ jsx64("path", { fill: "#D80027", d: "M31 1H18.61v7.392H31V1Z" }),
      /* @__PURE__ */ jsx64("path", { fill: "#0052B4", d: "M31 13.609H18.61V21H31v-7.391Z" }),
      /* @__PURE__ */ jsx64(
        "path",
        {
          fill: "#496E2D",
          d: "M18.608 11a2.609 2.609 0 1 1-5.217 0c0-1.44 2.608-2.608 2.608-2.608S18.608 9.56 18.608 11Z"
        }
      ),
      /* @__PURE__ */ jsx64("path", { fill: "#0052B4", d: "M13.39 11a2.609 2.609 0 1 1 5.218 0" }),
      /* @__PURE__ */ jsx64(
        "path",
        {
          fill: "#D80027",
          d: "M14.533 9.696v1.63a1.467 1.467 0 0 0 2.935 0v-1.63h-2.935Z"
        }
      ),
      /* @__PURE__ */ jsx64("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Do_default = SvgDo;

// build/Dz.tsx
import { jsx as jsx65, jsxs as jsxs65 } from "react/jsx-runtime";
var SvgDz = (props) => /* @__PURE__ */ jsxs65(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx65("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx65("path", { fill: "#FCFCFC", d: "M31 1H16v20h15V1Z" }),
      /* @__PURE__ */ jsx65(
        "path",
        {
          fill: "#D80027",
          d: "m18.15 9.082-.821 1.13L16 9.782l.822 1.129-.82 1.13 1.328-.432.821 1.13v-1.397l1.328-.433-1.329-.43V9.082Z"
        }
      ),
      /* @__PURE__ */ jsx65(
        "path",
        {
          fill: "#D80027",
          d: "M16.829 13.826a2.826 2.826 0 1 1 1.344-5.313 3.478 3.478 0 1 0 0 4.973c-.4.217-.858.34-1.344.34Z"
        }
      ),
      /* @__PURE__ */ jsx65("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Dz_default = SvgDz;

// build/Ec.tsx
import { jsx as jsx66, jsxs as jsxs66 } from "react/jsx-runtime";
var SvgEc = (props) => /* @__PURE__ */ jsxs66(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx66("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx66("path", { fill: "#0052B4", d: "M31 11H1v5h30v-5Z" }),
      /* @__PURE__ */ jsx66("path", { fill: "#D80027", d: "M31 16H1v5h30v-5Z" }),
      /* @__PURE__ */ jsx66(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 14.478a3.478 3.478 0 1 0 0-6.956 3.478 3.478 0 0 0 0 6.956Z"
        }
      ),
      /* @__PURE__ */ jsx66(
        "path",
        {
          fill: "#338AF3",
          d: "M16 13.303a2.244 2.244 0 0 1-2.242-2.242V9.716A2.244 2.244 0 0 1 16 7.474a2.244 2.244 0 0 1 2.241 2.242v1.345A2.244 2.244 0 0 1 16 13.303Z"
        }
      ),
      /* @__PURE__ */ jsx66(
        "path",
        {
          fill: "#000",
          d: "M19.586 5.68h-2.69a.897.897 0 0 0-1.794 0h-2.69c0 .496.431.897.927.897h-.03c0 .496.401.897.897.897 0 .495.401.897.896.897h1.794a.897.897 0 0 0 .896-.897.897.897 0 0 0 .897-.897h-.03c.496 0 .927-.401.927-.896Z"
        }
      ),
      /* @__PURE__ */ jsx66("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ec_default = SvgEc;

// build/Ee.tsx
import { jsx as jsx67, jsxs as jsxs67 } from "react/jsx-runtime";
var SvgEe = (props) => /* @__PURE__ */ jsxs67(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx67("path", { fill: "#000", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx67("path", { fill: "#0052B4", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx67("path", { fill: "#FCFCFC", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx67("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ee_default = SvgEe;

// build/Eg.tsx
import { jsx as jsx68, jsxs as jsxs68 } from "react/jsx-runtime";
var SvgEg = (props) => /* @__PURE__ */ jsxs68(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx68("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx68("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx68("path", { fill: "#000", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx68(
        "path",
        {
          fill: "#FF9811",
          d: "M19.75 9.845h-2.813a.938.938 0 0 0-1.875 0H12.25c0 .518.451.938.969.938h-.031c0 .517.42.937.937.937 0 .518.42.938.938.938h1.874c.518 0 .938-.42.938-.938.518 0 .938-.42.938-.937h-.032c.518 0 .969-.42.969-.938Z"
        }
      ),
      /* @__PURE__ */ jsx68("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Eg_default = SvgEg;

// build/Eh.tsx
import { jsx as jsx69, jsxs as jsxs69 } from "react/jsx-runtime";
var SvgEh = (props) => /* @__PURE__ */ jsxs69(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx69("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx69("path", { fill: "#000", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx69("path", { fill: "#496E2D", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx69(
        "path",
        {
          fill: "#D80027",
          d: "M16 11 1 21V1l15 10ZM18.913 11c0-1.166.819-2.14 1.913-2.378a2.435 2.435 0 1 0 0 4.756A2.435 2.435 0 0 1 18.913 11Z"
        }
      ),
      /* @__PURE__ */ jsx69(
        "path",
        {
          fill: "#D80027",
          d: "m20.928 9.435.345 1.063h1.118l-.904.657.345 1.062-.904-.656-.904.656.345-1.062-.904-.657h1.117l.346-1.063Z"
        }
      ),
      /* @__PURE__ */ jsx69("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Eh_default = SvgEh;

// build/Er.tsx
import { jsx as jsx70, jsxs as jsxs70 } from "react/jsx-runtime";
var SvgEr = (props) => /* @__PURE__ */ jsxs70(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx70("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx70("path", { fill: "#6DA544", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx70("path", { fill: "#D80027", d: "M1 21c0 .002 30-10 30-10L1 1v20Z" }),
      /* @__PURE__ */ jsx70(
        "path",
        {
          fill: "#FFDA44",
          d: "M9.261 7.25a3.161 3.161 0 0 0-3.157 3.158v1.184A3.162 3.162 0 0 0 9.26 14.75a3.161 3.161 0 0 0 3.158-3.158v-1.184A3.162 3.162 0 0 0 9.261 7.25Zm1.974 4.342c0 .882-.582 1.63-1.381 1.883v-1.291l.837-.838-.837-.837V9.816H8.669V11l-.837.837.837.837v.8c-.8-.251-1.381-1-1.381-1.882v-1.184c0-1.089.885-1.974 1.973-1.974 1.089 0 1.974.885 1.974 1.974v1.184Z"
        }
      ),
      /* @__PURE__ */ jsx70("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Er_default = SvgEr;

// build/Es.tsx
import { jsx as jsx71, jsxs as jsxs71 } from "react/jsx-runtime";
var SvgEs = (props) => /* @__PURE__ */ jsxs71(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx71("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx71("path", { fill: "#D80027", d: "M31 1H1v6.666h30V1ZM31 14.333H1v6.666h30v-6.666Z" }),
      /* @__PURE__ */ jsx71("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Es_default = SvgEs;

// build/Et.tsx
import { jsx as jsx72, jsxs as jsxs72 } from "react/jsx-runtime";
var SvgEt = (props) => /* @__PURE__ */ jsxs72(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx72("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx72("path", { fill: "#6DA544", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx72("path", { fill: "#D80027", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx72(
        "path",
        {
          fill: "#0052B4",
          d: "M16 15.783a4.782 4.782 0 1 0-.001-9.565 4.782 4.782 0 0 0 0 9.565Z"
        }
      ),
      /* @__PURE__ */ jsx72(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 7.297.863 2.657h2.798l-2.265 1.642.87 2.665L16 12.61l-2.263 1.647.866-2.662-2.262-1.642h2.796L16 7.297Z"
        }
      ),
      /* @__PURE__ */ jsx72(
        "path",
        {
          fill: "#FFDA44",
          d: "m19.443 11.661-2.739-.89 1.693-2.33-.703-.51L16 10.26l-1.693-2.33-.703.51 1.692 2.33-2.738.89.268.827 2.739-.89v2.88h.87v-2.88l2.738.89.27-.827Z"
        }
      ),
      /* @__PURE__ */ jsx72("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Et_default = SvgEt;

// build/Eu.tsx
import { jsx as jsx73, jsxs as jsxs73 } from "react/jsx-runtime";
var SvgEu = (props) => /* @__PURE__ */ jsxs73(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx73("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx73(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 5.375.299.92h.968l-.783.57.3.92L16 7.216l-.784.57.3-.921-.784-.57h.969l.299-.92ZM12.022 7.022l.863.44.685-.685-.152.956.863.44-.956.151-.152.957-.44-.863-.956.152.685-.685-.44-.863ZM10.375 11l.92-.3v-.968l.57.784.92-.3-.568.784.569.783-.921-.3-.57.784v-.968l-.92-.3ZM12.022 14.977l.44-.863-.685-.684.957.151.44-.862.15.956.957.151-.863.44.152.956-.685-.684-.863.44ZM16 16.625l-.3-.921h-.968l.784-.57-.3-.92.784.569.783-.569-.3.92.784.57H16.3l-.3.92ZM19.977 14.977l-.863-.44-.684.685.151-.956-.862-.44.956-.151.151-.956.44.862.956-.151-.684.684.44.863ZM21.626 11l-.921.299v.968l-.57-.783-.92.299.569-.783-.57-.784.922.3.569-.784v.969l.92.299ZM19.977 7.022l-.44.863.685.685-.956-.152-.44.863-.151-.957-.956-.151.862-.44-.151-.956.684.685.863-.44Z"
        }
      ),
      /* @__PURE__ */ jsx73("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Eu_default = SvgEu;

// build/Fi.tsx
import { jsx as jsx74, jsxs as jsxs74 } from "react/jsx-runtime";
var SvgFi = (props) => /* @__PURE__ */ jsxs74(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx74("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx74(
        "path",
        {
          fill: "#2E52B2",
          d: "M31 9.75v2.5H11.76V21h-2.5v-8.75H1v-2.5h8.26V1h2.5v8.75H31Z"
        }
      ),
      /* @__PURE__ */ jsx74("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Fi_default = SvgFi;

// build/Fj.tsx
import { jsx as jsx75, jsxs as jsxs75 } from "react/jsx-runtime";
var SvgFj = (props) => /* @__PURE__ */ jsxs75(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx75("path", { fill: "#2E52B2", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx75(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 1v1.325l-2.7 1.8H16v3.75h-2.7l2.7 1.8V11h-1.326l-4.299-2.866V11h-3.75V8.134L2.325 11H1V9.675l2.7-1.8H1v-3.75h2.7L1 2.325V1h1.326l4.299 2.866V1h3.75v2.866L14.675 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          fill: "#D80027",
          d: "M1 1v.884l3.362 2.241h1.325L1 1ZM16 1v.884l-3.362 2.241h-1.325L16 1Z"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          fill: "#D80027",
          d: "M1 1v.884l3.362 2.241h1.325L1 1ZM16 1v.884l-3.362 2.241h-1.325L16 1ZM1 11v-.884l3.362-2.241h1.325L1 11ZM16 11v-.884l-3.362-2.241h-1.325L16 11Z"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          fill: "#F3F3F3",
          d: "M20.457 8.174v3.478c0 2.33 3.043 3.043 3.043 3.043s3.044-.713 3.044-3.043V8.174l-3.044-.87-3.043.87Z"
        }
      ),
      /* @__PURE__ */ jsx75(
        "path",
        {
          fill: "#D80027",
          d: "M26.544 8.391V7.087h-6.087V8.39h2.609V11h-2.609v.87h2.609v2.91c.262.092.434.133.434.133s.173-.04.435-.134v-2.91h2.609V11h-2.609V8.392h2.609Z"
        }
      ),
      /* @__PURE__ */ jsx75("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Fj_default = SvgFj;

// build/Fk.tsx
import { jsx as jsx76, jsxs as jsxs76 } from "react/jsx-runtime";
var SvgFk = (props) => /* @__PURE__ */ jsxs76(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx76("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx76(
        "path",
        {
          fill: "#FFDA44",
          d: "M25.24 13.174v.434H21.76v-.434h-1.304v1.739h.87v.434h4.347v-.434h.87v-1.74H25.24Z"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          fill: "#338AF3",
          d: "M20.457 6.652v4.782c0 2.33 3.043 3.044 3.043 3.044s3.044-.714 3.044-3.043V6.651h-6.087Z"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          fill: "#F3F3F3",
          d: "M23.5 10.22c-.76 0-.76.695-1.521.695-.761 0-.761-.696-1.522-.696v1.218c.76 0 .76.695 1.522.695.76 0 .76-.695 1.521-.695.761 0 .761.695 1.522.695s.761-.695 1.522-.695v-1.218c-.76 0-.76.696-1.522.696-.76 0-.76-.696-1.522-.696ZM23.5 7.782c-.76 0-.76.696-1.521.696-.761 0-.761-.696-1.522-.696V9c.76 0 .76.695 1.522.695.76 0 .76-.695 1.521-.695.761 0 .761.695 1.522.695S25.783 9 26.544 9V7.782c-.76 0-.76.696-1.522.696-.76 0-.76-.696-1.522-.696Z"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 1v1.79l-2.646 1.471H16v3.478h-3.463L16 9.663V11h-1.563L10.13 8.608V11H6.87V8.154L1.747 11H1V9.21l2.647-1.471H1V4.261h3.463L1 2.336V1h1.563L6.87 3.392V1h3.26v2.846L15.253 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx76(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx76("path", { fill: "#0052B4", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx76("path", { fill: "#FCFCFC", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx76(
        "path",
        {
          fill: "#D80027",
          d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66ZM5.21 7.739 1 10.078V11l5.87-3.261H5.21Z"
        }
      ),
      /* @__PURE__ */ jsx76("path", { fill: "#0052B4", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx76("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx76(
        "path",
        {
          fill: "#D80027",
          d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66ZM11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z"
        }
      ),
      /* @__PURE__ */ jsx76("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Fk_default = SvgFk;

// build/Fm.tsx
import { jsx as jsx77, jsxs as jsxs77 } from "react/jsx-runtime";
var SvgFm = (props) => /* @__PURE__ */ jsxs77(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx77("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx77(
        "path",
        {
          fill: "#FCFCFC",
          d: "m16 5.348.432 1.328h1.397l-1.13.821.432 1.329L16 8.005l-1.13.82.431-1.328-1.13-.82h1.397L16 5.346ZM10.348 11l1.328-.432V9.171l.821 1.13 1.329-.431-.821 1.13.821 1.13-1.329-.432-.82 1.13v-1.397L10.346 11ZM16 16.652l-.431-1.329h-1.397l1.13-.82-.432-1.33 1.13.822 1.13-.821-.431 1.328 1.13.821h-1.397l-.431 1.329ZM21.652 11l-1.328.431v1.397l-.822-1.13-1.328.432.82-1.13-.82-1.13 1.328.431.822-1.13v1.397l1.328.432Z"
        }
      ),
      /* @__PURE__ */ jsx77("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Fm_default = SvgFm;

// build/Fo.tsx
import { jsx as jsx78, jsxs as jsxs78 } from "react/jsx-runtime";
var SvgFo = (props) => /* @__PURE__ */ jsxs78(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx78("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx78(
        "path",
        {
          fill: "#0052B4",
          d: "M31 13.337H12.847V21H8.174v-7.663H1V8.663h7.174V1h4.673v7.663H31V13.337Z"
        }
      ),
      /* @__PURE__ */ jsx78(
        "path",
        {
          fill: "#D80027",
          d: "M31 9.75v2.5H11.76V21h-2.5v-8.75H1v-2.5h8.26V1h2.5v8.75H31Z"
        }
      ),
      /* @__PURE__ */ jsx78("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Fo_default = SvgFo;

// build/Fr.tsx
import { jsx as jsx79, jsxs as jsxs79 } from "react/jsx-runtime";
var SvgFr = (props) => /* @__PURE__ */ jsxs79(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx79("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx79("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx79("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx79("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Fr_default = SvgFr;

// build/Ga.tsx
import { jsx as jsx80, jsxs as jsxs80 } from "react/jsx-runtime";
var SvgGa = (props) => /* @__PURE__ */ jsxs80(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx80("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx80("path", { fill: "#6DA544", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx80("path", { fill: "#0052B4", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx80("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ga_default = SvgGa;

// build/Gb.tsx
import { jsx as jsx81, jsxs as jsxs81 } from "react/jsx-runtime";
var SvgGb = (props) => /* @__PURE__ */ jsxs81(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx81("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx81(
        "path",
        {
          fill: "#D80027",
          d: "M17.875 1h-3.75v8.125H1v3.75h13.125V21h3.75v-8.125H31v-3.75H17.875V1Z"
        }
      ),
      /* @__PURE__ */ jsx81(
        "path",
        {
          fill: "#0052B4",
          d: "m24.074 14.478 6.927 3.848v-3.848h-6.927ZM19.262 14.478 31 21v-1.845l-8.42-4.677h-3.32ZM27.874 21l-8.612-4.785V21h8.612Z"
        }
      ),
      /* @__PURE__ */ jsx81("path", { fill: "#FCFCFC", d: "M19.262 14.478 31 21v-1.845l-8.42-4.677h-3.32Z" }),
      /* @__PURE__ */ jsx81("path", { fill: "#D80027", d: "M19.262 14.478 31 21v-1.845l-8.42-4.677h-3.32Z" }),
      /* @__PURE__ */ jsx81(
        "path",
        {
          fill: "#0052B4",
          d: "M6.293 14.478 1 17.418v-2.94h5.293ZM12.74 15.307V21H2.494l10.246-5.693Z"
        }
      ),
      /* @__PURE__ */ jsx81("path", { fill: "#D80027", d: "M9.42 14.478 1 19.155V21l11.74-6.522H9.42Z" }),
      /* @__PURE__ */ jsx81(
        "path",
        {
          fill: "#0052B4",
          d: "M7.927 7.522 1 3.673v3.849h6.927ZM12.74 7.522 1 1v1.844l8.42 4.678h3.32ZM4.127 1l8.612 4.785V1H4.127Z"
        }
      ),
      /* @__PURE__ */ jsx81("path", { fill: "#FCFCFC", d: "M12.74 7.522 1 1v1.844l8.42 4.678h3.32Z" }),
      /* @__PURE__ */ jsx81("path", { fill: "#D80027", d: "M12.74 7.522 1 1v1.844l8.42 4.678h3.32Z" }),
      /* @__PURE__ */ jsx81(
        "path",
        {
          fill: "#0052B4",
          d: "M25.707 7.522 31 4.58v2.94h-5.293ZM19.262 6.692V1h10.245L19.262 6.692Z"
        }
      ),
      /* @__PURE__ */ jsx81("path", { fill: "#D80027", d: "m22.581 7.522 8.42-4.678V1L19.26 7.522h3.32Z" }),
      /* @__PURE__ */ jsx81("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gb_default = SvgGb;

// build/Gd.tsx
import { jsx as jsx82, jsxs as jsxs82 } from "react/jsx-runtime";
var SvgGd = (props) => /* @__PURE__ */ jsxs82(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx82("path", { fill: "#A2001D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx82("path", { fill: "#496E2D", d: "M16 11 3.61 18.391V3.61L16 11Z" }),
      /* @__PURE__ */ jsx82(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 11 12.392 7.391H3.609L16.001 11ZM28.392 3.609 16.001 11 3.609 3.609h24.783Z"
        }
      ),
      /* @__PURE__ */ jsx82("path", { fill: "#496E2D", d: "M28.391 3.609V18.39L16 11l12.391-7.391Z" }),
      /* @__PURE__ */ jsx82(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 1.609.195.597h.628l-.508.37.194.598-.508-.37-.509.37.194-.598-.508-.37h.628l.195-.597ZM10.967 1.609l.195.597h.628l-.508.37.194.598-.509-.37-.508.37.194-.598-.508-.37h.628l.194-.597ZM21.034 1.609l.194.597h.629l-.509.37.194.598-.508-.37-.509.37.195-.598-.51-.37h.63l.194-.597ZM16 18.826l.195.598h.628l-.508.37.194.598-.508-.37-.509.37.194-.598-.508-.37h.628l.195-.598ZM10.967 18.826l.195.598h.628l-.508.37.194.598-.509-.37-.508.37.194-.598-.508-.37h.628l.194-.598ZM21.034 18.826l.194.598h.629l-.509.37.194.598-.508-.37-.509.37.195-.598-.51-.37h.63l.194-.598Z"
        }
      ),
      /* @__PURE__ */ jsx82(
        "path",
        {
          fill: "#A2001D",
          d: "M16 13.226a2.226 2.226 0 1 0 0-4.452 2.226 2.226 0 0 0 0 4.452Z"
        }
      ),
      /* @__PURE__ */ jsx82(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 8.774.5 1.536h1.614l-1.306.949.499 1.536-1.306-.95-1.307.95.5-1.536-1.307-.95h1.615L16 8.775ZM7.307 10.835a.87.87 0 0 1-1.47.93c-.464-.735-.195-1.935-.195-1.935s1.2.27 1.665 1.005Z"
        }
      ),
      /* @__PURE__ */ jsx82(
        "path",
        {
          fill: "#A2001D",
          d: "M6.806 12.102a.435.435 0 1 0 0-.87.435.435 0 0 0 0 .87Z"
        }
      ),
      /* @__PURE__ */ jsx82("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gd_default = SvgGd;

// build/Ge.tsx
import { jsx as jsx83, jsxs as jsxs83 } from "react/jsx-runtime";
var SvgGe = (props) => /* @__PURE__ */ jsxs83(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx83("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx83(
        "path",
        {
          fill: "#D80027",
          d: "M17.875 1h-3.75v8.125H1v3.75h13.125V21h3.75v-8.125H31v-3.75H17.875V1Z"
        }
      ),
      /* @__PURE__ */ jsx83(
        "path",
        {
          fill: "#D80027",
          d: "M8.214 4.41V3.106H6.91V4.41H5.605v1.305H6.91v1.304h1.304V5.715h1.304V4.41H8.214ZM25.09 4.41V3.106h-1.305V4.41H22.48v1.305h1.305v1.304h1.304V5.715h1.305V4.41h-1.305ZM8.214 16.285V14.98H6.91v1.304H5.605v1.304H6.91v1.305h1.304v-1.305h1.304v-1.304H8.214ZM25.09 16.285V14.98h-1.305v1.304H22.48v1.304h1.305v1.305h1.304v-1.305h1.305v-1.304h-1.305Z"
        }
      ),
      /* @__PURE__ */ jsx83("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ge_default = SvgGe;

// build/Gf.tsx
import { jsx as jsx84, jsxs as jsxs84 } from "react/jsx-runtime";
var SvgGf = (props) => /* @__PURE__ */ jsxs84(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx84("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx84("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx84("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx84("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gf_default = SvgGf;

// build/Gg.tsx
import { jsx as jsx85, jsxs as jsxs85 } from "react/jsx-runtime";
var SvgGg = (props) => /* @__PURE__ */ jsxs85(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx85("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx85(
        "path",
        {
          fill: "#D80027",
          d: "M17.875 1h-3.75v8.125H1v3.75h13.125V21h3.75v-8.125H31v-3.75H17.875V1Z"
        }
      ),
      /* @__PURE__ */ jsx85(
        "path",
        {
          fill: "#FFDA44",
          d: "m19.71 11.57.856.571V9.858l-.856.571h-3.139V7.291l.571-.856H14.86l.57.856v3.138h-3.139l-.856-.57v2.282l.856-.57h3.14v3.138l-.571.856h2.282l-.57-.856V11.57h3.138Z"
        }
      ),
      /* @__PURE__ */ jsx85("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gg_default = SvgGg;

// build/Gh.tsx
import { jsx as jsx86, jsxs as jsxs86 } from "react/jsx-runtime";
var SvgGh = (props) => /* @__PURE__ */ jsxs86(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx86("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx86("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx86("path", { fill: "#496E2D", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx86(
        "path",
        {
          fill: "#000",
          d: "m15.993 7.667.827 2.546 2.366.188-2.166 1.573 1.14 2.36-2.167-1.574-2.166 1.573.827-2.546-2.166-1.574h2.678l.827-2.546Z"
        }
      ),
      /* @__PURE__ */ jsx86("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gh_default = SvgGh;

// build/Gi.tsx
import { jsx as jsx87, jsxs as jsxs87 } from "react/jsx-runtime";
var SvgGi = (props) => /* @__PURE__ */ jsxs87(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx87("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx87(
        "path",
        {
          fill: "#D80027",
          d: "M31 14.333H1v6.666h30v-6.666ZM19.913 9.26V7.957h.434v-.87h-.87v.435h-.869v-.434h-.87v.87h.435V9.26h-.87V6.217h.436v-.87h-.87v.435h-.435v-.434h-.87v.434h-.434v-.434h-.87v.87h.435V9.26h-.87V7.956h.435v-.87h-.87v.435h-.869v-.434h-.87v.87h.435V9.26h-.87v3.478h9.566V9.26h-.87Z"
        }
      ),
      /* @__PURE__ */ jsx87(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 12.304a1.304 1.304 0 0 0-.434 2.534v1.814h-1.304v1.739h2.174v-3.553A1.304 1.304 0 0 0 16 12.304Zm0 1.74a.435.435 0 1 1 0-.87.435.435 0 0 1 0 .87Z"
        }
      ),
      /* @__PURE__ */ jsx87("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gi_default = SvgGi;

// build/Gl.tsx
import { jsx as jsx88, jsxs as jsxs88 } from "react/jsx-runtime";
var SvgGl = (props) => /* @__PURE__ */ jsxs88(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx88("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx88("path", { fill: "#FCFCFC", d: "M31 1v9.767L1 11.01V1h30Z" }),
      /* @__PURE__ */ jsx88(
        "path",
        {
          fill: "#FCFCFC",
          d: "M12.956 15.783a4.782 4.782 0 1 0 0-9.565 4.782 4.782 0 0 0 0 9.565Z"
        }
      ),
      /* @__PURE__ */ jsx88("path", { fill: "#D80027", d: "M8.174 11a4.783 4.783 0 0 1 9.565 0" }),
      /* @__PURE__ */ jsx88("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gl_default = SvgGl;

// build/Gm.tsx
import { jsx as jsx89, jsxs as jsxs89 } from "react/jsx-runtime";
var SvgGm = (props) => /* @__PURE__ */ jsxs89(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx89("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx89("path", { fill: "#496E2D", d: "M31 14.913H1V21h30v-6.087Z" }),
      /* @__PURE__ */ jsx89("path", { fill: "#A2001D", d: "M31 1H1v6.124h30V1Z" }),
      /* @__PURE__ */ jsx89("path", { fill: "#0052B4", d: "M31 8.356H1v5.253h30V8.356Z" }),
      /* @__PURE__ */ jsx89("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gm_default = SvgGm;

// build/Gn.tsx
import { jsx as jsx90, jsxs as jsxs90 } from "react/jsx-runtime";
var SvgGn = (props) => /* @__PURE__ */ jsxs90(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx90("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx90("path", { fill: "#6DA544", d: "M31 1H20.348v20H31V1Z" }),
      /* @__PURE__ */ jsx90("path", { fill: "#D80027", d: "M11.652 1H1v20h10.652V1Z" }),
      /* @__PURE__ */ jsx90("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gn_default = SvgGn;

// build/Gp.tsx
import { jsx as jsx91, jsxs as jsxs91 } from "react/jsx-runtime";
var SvgGp = (props) => /* @__PURE__ */ jsxs91(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx91("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx91("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx91("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx91("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gp_default = SvgGp;

// build/Gq.tsx
import { jsx as jsx92, jsxs as jsxs92 } from "react/jsx-runtime";
var SvgGq = (props) => /* @__PURE__ */ jsxs92(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx92("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx92("path", { fill: "#6DA544", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx92("path", { fill: "#D80027", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx92("path", { fill: "#0052B4", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx92(
        "path",
        {
          fill: "#DEDDE0",
          d: "M17.395 8.874v2.604c0 1.595 2.083 2.083 2.083 2.083s2.083-.489 2.083-2.083V8.874h-4.166Z"
        }
      ),
      /* @__PURE__ */ jsx92("path", { fill: "#786145", d: "M19.999 11.01h-1.042v1.51h1.042v-1.51Z" }),
      /* @__PURE__ */ jsx92(
        "path",
        {
          fill: "#6DA544",
          d: "M20.52 10.436a1.042 1.042 0 1 0-2.083 0 .52.52 0 1 0 0 1.042h2.083a.52.52 0 1 0 0-1.042Z"
        }
      ),
      /* @__PURE__ */ jsx92("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gq_default = SvgGq;

// build/Gr.tsx
import { jsx as jsx93, jsxs as jsxs93 } from "react/jsx-runtime";
var SvgGr = (props) => /* @__PURE__ */ jsxs93(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx93("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx93(
        "path",
        {
          fill: "#338AF3",
          d: "M31 1H1v2.5h30V1ZM31 6H1v2.5h30V6ZM31 11H1v2.5h30V11ZM31 16H1v2.5h30V16Z"
        }
      ),
      /* @__PURE__ */ jsx93("path", { fill: "#338AF3", d: "M12.087 1H1v10h11.087V1Z" }),
      /* @__PURE__ */ jsx93("path", { fill: "#FCFCFC", d: "M12.087 4.89H1V7.11h11.087V4.89Z" }),
      /* @__PURE__ */ jsx93("path", { fill: "#FCFCFC", d: "M7.654 1H5.432v10h2.222V1Z" }),
      /* @__PURE__ */ jsx93("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gr_default = SvgGr;

// build/Gs.tsx
import { jsx as jsx94, jsxs as jsxs94 } from "react/jsx-runtime";
var SvgGs = (props) => /* @__PURE__ */ jsxs94(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx94("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx94(
        "path",
        {
          fill: "#FFDA44",
          d: "M25.24 13.174v.434H21.76v-.434h-1.304v1.739h.87v.434h4.347v-.434h.87v-1.74H25.24Z"
        }
      ),
      /* @__PURE__ */ jsx94(
        "path",
        {
          fill: "#338AF3",
          d: "M22 9v2.444C22 12.635 23.5 13 23.5 13s1.5-.365 1.5-1.556V9h-3Z"
        }
      ),
      /* @__PURE__ */ jsx94(
        "path",
        {
          fill: "#ACABB1",
          d: "m25 8.457-1.286.5-1.285-.5L22 7.207l.428-1.25H25l-.429 1.25.429 1.25ZM22 12.167l-.857.833-.857-.833L20 10.083 20.286 8H22l-.286 2.083.286 2.084ZM27 12.167l-.857.833-.857-.833L25 10.083 25.286 8H27l-.286 2.083.286 2.084Z"
        }
      ),
      /* @__PURE__ */ jsx94(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 1v1.79l-2.646 1.471H16v3.478h-3.463L16 9.663V11h-1.563L10.13 8.608V11H6.87V8.154L1.747 11H1V9.21l2.647-1.471H1V4.261h3.463L1 2.336V1h1.563L6.87 3.392V1h3.26v2.846L15.253 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx94(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx94("path", { fill: "#0052B4", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx94("path", { fill: "#FCFCFC", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx94(
        "path",
        {
          fill: "#D80027",
          d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66ZM5.21 7.739 1 10.078V11l5.87-3.261H5.21Z"
        }
      ),
      /* @__PURE__ */ jsx94("path", { fill: "#0052B4", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx94("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx94(
        "path",
        {
          fill: "#D80027",
          d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66ZM11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z"
        }
      ),
      /* @__PURE__ */ jsx94("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gs_default = SvgGs;

// build/Gt.tsx
import { jsx as jsx95, jsxs as jsxs95 } from "react/jsx-runtime";
var SvgGt = (props) => /* @__PURE__ */ jsxs95(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx95("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx95("path", { fill: "#338AF3", d: "M11 1H1v20h10V1ZM31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx95(
        "path",
        {
          fill: "#ACABB1",
          d: "m18.818 12.8-1.823-1.822 1.736-1.735-.079-.917-.497-.497-2.154 2.155-2.154-2.155-.497.497-.079.917 1.736 1.735-1.823 1.823.994.994L16 11.972l1.823 1.823.994-.994Z"
        }
      ),
      /* @__PURE__ */ jsx95(
        "path",
        {
          fill: "#6DA544",
          d: "m18.652 8.326-.995.995a2.344 2.344 0 1 1-3.315 0l-.994-.995a3.75 3.75 0 1 0 5.303 0Z"
        }
      ),
      /* @__PURE__ */ jsx95("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gt_default = SvgGt;

// build/Gu.tsx
import { jsx as jsx96, jsxs as jsxs96 } from "react/jsx-runtime";
var SvgGu = (props) => /* @__PURE__ */ jsxs96(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx96("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx96("path", { fill: "#0052B4", d: "M30 2H2v18h28V2Z" }),
      /* @__PURE__ */ jsx96(
        "path",
        {
          fill: "#D80027",
          d: "M15.435 17.312c-.137-.117-3.347-2.908-3.347-6.313 0-3.404 3.21-6.195 3.347-6.312l.566-.485.566.485c.137.117 3.347 2.908 3.347 6.312 0 3.405-3.21 6.196-3.347 6.313l-.566.485-.566-.485Z"
        }
      ),
      /* @__PURE__ */ jsx96(
        "path",
        {
          fill: "#338AF3",
          d: "M19.044 11C19.044 7.956 16 5.348 16 5.348S12.957 7.956 12.957 11c0 .93.285 1.821.68 2.608h4.726c.396-.787.681-1.677.681-2.608Z"
        }
      ),
      /* @__PURE__ */ jsx96(
        "path",
        {
          fill: "#0052B4",
          d: "M19.044 11c0 .93-.285 1.82-.68 2.608L16 14.043l-2.363-.435c-.395-.787-.68-1.677-.68-2.609h6.087Z"
        }
      ),
      /* @__PURE__ */ jsx96(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 16.652s1.466-1.257 2.363-3.044h-4.726C14.534 15.395 16 16.652 16 16.652Z"
        }
      ),
      /* @__PURE__ */ jsx96("path", { fill: "#6DA544", d: "M14.043 9.26h3.913l-1.957 1.957-1.956-1.956Z" }),
      /* @__PURE__ */ jsx96("path", { fill: "#A2001D", d: "M16.652 10.565h-1.304v3.912h1.304v-3.912Z" }),
      /* @__PURE__ */ jsx96("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gu_default = SvgGu;

// build/Gw.tsx
import { jsx as jsx97, jsxs as jsxs97 } from "react/jsx-runtime";
var SvgGw = (props) => /* @__PURE__ */ jsxs97(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx97("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx97("path", { fill: "#FFDA44", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx97("path", { fill: "#D80027", d: "M11.652 1H1v20h10.652V1Z" }),
      /* @__PURE__ */ jsx97(
        "path",
        {
          fill: "#000",
          d: "m6.762 7.433.885 2.725h2.865l-2.318 1.684.885 2.724-2.317-1.684-2.318 1.684.885-2.724-2.317-1.684h2.864l.886-2.725Z"
        }
      ),
      /* @__PURE__ */ jsx97("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gw_default = SvgGw;

// build/Gy.tsx
import { jsx as jsx98, jsxs as jsxs98 } from "react/jsx-runtime";
var SvgGy = (props) => /* @__PURE__ */ jsxs98(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx98("path", { fill: "#6DA544", d: "M31 21V11L1 21h30ZM1 1l30 10V1H1Z" }),
      /* @__PURE__ */ jsx98("path", { fill: "#000", d: "M1 1v1.052L14.422 11 1 19.948V21l15-10L1 1Z" }),
      /* @__PURE__ */ jsx98(
        "path",
        {
          fill: "#FFDA44",
          d: "M4.156 18.896 27.845 11 4.156 3.104 16.001 11 4.156 18.896Z"
        }
      ),
      /* @__PURE__ */ jsx98(
        "path",
        {
          fill: "#fff",
          d: "m1 1 3.156 2.104L27.844 11 4.156 18.896 1 21l30-10L1 1Z"
        }
      ),
      /* @__PURE__ */ jsx98("path", { fill: "#D80027", d: "M1 2.052v17.896l13.422-8.949L1 2.053Z" }),
      /* @__PURE__ */ jsx98("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Gy_default = SvgGy;

// build/Hi.tsx
import { jsx as jsx99, jsxs as jsxs99 } from "react/jsx-runtime";
var SvgHi = (props) => /* @__PURE__ */ jsxs99(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx99("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx99("path", { fill: "#D80027", d: "M31 3.5H1V6h30V3.5Z" }),
      /* @__PURE__ */ jsx99("path", { fill: "#0052B4", d: "M31 6H1v2.5h30V6Z" }),
      /* @__PURE__ */ jsx99("path", { fill: "#D80027", d: "M31 11H1v2.5h30V11Z" }),
      /* @__PURE__ */ jsx99("path", { fill: "#0052B4", d: "M31 13.5H1V16h30v-2.5Z" }),
      /* @__PURE__ */ jsx99("path", { fill: "#D80027", d: "M31 18.5H1V21h30v-2.5Z" }),
      /* @__PURE__ */ jsx99("path", { fill: "#FCFCFC", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx99(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.063H1v1.875h6.563V11h1.875V6.938H16V5.063H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx99(
        "path",
        {
          fill: "#0052B4",
          d: "M12.536 7.74 16 9.662V7.74h-3.463ZM10.13 7.74 16 11v-.922L11.79 7.74h-1.66ZM14.437 11l-4.306-2.392V11h4.306Z"
        }
      ),
      /* @__PURE__ */ jsx99("path", { fill: "#FCFCFC", d: "M10.13 7.74 16 11v-.922L11.79 7.74h-1.66Z" }),
      /* @__PURE__ */ jsx99("path", { fill: "#D80027", d: "M10.13 7.74 16 11v-.922L11.79 7.74h-1.66Z" }),
      /* @__PURE__ */ jsx99(
        "path",
        {
          fill: "#0052B4",
          d: "M3.647 7.74 1 9.21V7.74h2.647ZM6.87 8.154V11H1.747L6.87 8.154Z"
        }
      ),
      /* @__PURE__ */ jsx99("path", { fill: "#D80027", d: "M5.21 7.74 1 10.077V11l5.87-3.26H5.21Z" }),
      /* @__PURE__ */ jsx99(
        "path",
        {
          fill: "#0052B4",
          d: "M4.463 4.26 1 2.338V4.26h3.463ZM6.87 4.26 1 1v.922l4.21 2.339h1.66ZM2.563 1 6.87 3.393V1H2.563Z"
        }
      ),
      /* @__PURE__ */ jsx99("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx99("path", { fill: "#D80027", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx99(
        "path",
        {
          fill: "#0052B4",
          d: "M13.354 4.261 16 2.791v1.47h-2.646ZM10.13 3.846V1h5.124L10.13 3.846Z"
        }
      ),
      /* @__PURE__ */ jsx99("path", { fill: "#D80027", d: "M11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z" }),
      /* @__PURE__ */ jsx99("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Hi_default = SvgHi;

// build/Hk.tsx
import { jsx as jsx100, jsxs as jsxs100 } from "react/jsx-runtime";
var SvgHk = (props) => /* @__PURE__ */ jsxs100(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx100("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx100(
        "path",
        {
          fill: "#FCFCFC",
          d: "M17.033 8.565c-.228.945-.632.765-.83 1.59a2.174 2.174 0 0 1 1.017-4.228c-.397 1.649.016 1.792-.187 2.638ZM14.003 9.265c.828.509.532.837 1.255 1.28a2.174 2.174 0 0 1-3.706-2.273c1.445.887 1.71.539 2.45.993ZM13.733 12.363c.74-.632.96-.248 1.605-.799a2.174 2.174 0 0 1-3.307 2.823c1.29-1.1 1.04-1.46 1.702-2.024ZM16.595 13.576c-.371-.898.061-.99-.263-1.773a2.174 2.174 0 0 1 1.663 4.018c-.649-1.567-1.067-1.441-1.4-2.245ZM18.634 11.23c-.97.075-.923-.365-1.768-.298a2.174 2.174 0 0 1 4.335-.34c-1.69.133-1.7.57-2.567.637Z"
        }
      ),
      /* @__PURE__ */ jsx100("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Hk_default = SvgHk;

// build/Hm.tsx
import { jsx as jsx101, jsxs as jsxs101 } from "react/jsx-runtime";
var SvgHm = (props) => /* @__PURE__ */ jsxs101(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx101("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx101(
        "path",
        {
          fill: "#FCFCFC",
          d: "m14.09 11 .048-.054-.048.054ZM12.087 13.456l.642 1.343 1.45-.335-.65 1.339 1.167.924-1.452.328.004 1.488-1.16-.931-1.162.93.004-1.487-1.451-.328 1.166-.924-.65-1.34 1.45.336.642-1.343ZM23.68 15.124l.306.64.692-.16-.31.64.556.44-.692.156.002.71-.554-.444-.554.444.002-.71-.692-.156.556-.44-.31-.64.692.16.306-.64ZM20.832 8.33l.306.641.692-.16-.31.64.556.44-.692.156.002.71-.554-.444-.554.444.002-.71-.692-.156.556-.44-.31-.64.692.16.306-.64ZM23.68 4.45l.306.64.692-.16-.31.638.556.441-.692.156.002.71-.554-.444-.554.444.002-.71-.692-.156.556-.44-.31-.64.692.16.306-.64ZM26.168 7.36l.306.64.692-.159-.31.639.556.44-.692.157.002.71-.554-.444-.554.444.002-.71-.692-.156.556-.441-.31-.639.692.16.306-.64ZM24.39 10.757l.24.741h.78l-.63.459.24.74-.63-.457-.631.458.24-.741-.63-.459h.78l.24-.74ZM16 1v1.79l-2.646 1.47H16V7.74h-3.463L16 9.663V11h-1.563L10.13 8.608V11H6.87V8.154L1.747 11H1V9.21l2.647-1.471H1V4.26h3.463L1 2.336V1h1.563L6.87 3.392V1h3.26v2.846L15.253 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx101(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx101("path", { fill: "#0052B4", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.34h-1.66Z" }),
      /* @__PURE__ */ jsx101("path", { fill: "#FCFCFC", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.34h-1.66Z" }),
      /* @__PURE__ */ jsx101(
        "path",
        {
          fill: "#D80027",
          d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.34h-1.66ZM5.21 7.739 1 10.078V11l5.87-3.261H5.21Z"
        }
      ),
      /* @__PURE__ */ jsx101("path", { fill: "#0052B4", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx101("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx101(
        "path",
        {
          fill: "#D80027",
          d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66ZM11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z"
        }
      ),
      /* @__PURE__ */ jsx101("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Hm_default = SvgHm;

// build/Hn.tsx
import { jsx as jsx102, jsxs as jsxs102 } from "react/jsx-runtime";
var SvgHn = (props) => /* @__PURE__ */ jsxs102(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx102("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx102(
        "path",
        {
          fill: "#338AF3",
          d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667ZM12.923 8.217l.26.798h.838l-.679.492.26.797-.679-.492-.678.492.26-.797-.679-.492h.838l.26-.798ZM12.923 11.696l.26.797h.838l-.679.492.26.798-.679-.493-.678.493.26-.798-.679-.492h.838l.26-.797ZM19.076 8.217l.259.798h.838l-.678.492.259.797-.678-.492-.678.492.259-.797-.678-.492h.838l.259-.798ZM19.076 11.696l.259.797h.838l-.678.492.259.798-.678-.493-.678.493.259-.798-.678-.492h.838l.259-.797ZM16 9.956l.259.798h.838l-.678.492.259.797-.679-.492-.678.492.26-.797-.679-.492h.839l.258-.798Z"
        }
      ),
      /* @__PURE__ */ jsx102("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Hn_default = SvgHn;

// build/Hr.tsx
import { jsx as jsx103, jsxs as jsxs103 } from "react/jsx-runtime";
var SvgHr = (props) => /* @__PURE__ */ jsxs103(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx103("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx103("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx103("path", { fill: "#0052B4", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx103(
        "path",
        {
          fill: "#338AF3",
          d: "M18.608 7.957H16.87l.29-2.174 1.16-.87 1.159.87v1.739l-.87.435ZM13.391 7.957h1.74l-.29-2.174-1.16-.87-1.16.87v1.739l.87.435Z"
        }
      ),
      /* @__PURE__ */ jsx103(
        "path",
        {
          fill: "#0052B4",
          d: "M17.159 7.957h-2.32V5.783l1.16-.87 1.16.87v2.174Z"
        }
      ),
      /* @__PURE__ */ jsx103(
        "path",
        {
          fill: "#FCFCFC",
          d: "M12.521 7.522v4.782c0 1.14.55 2.152 1.399 2.787l.609-.152.768.772a3.486 3.486 0 0 0 1.402.001l.877-.73.503.107a3.474 3.474 0 0 0 1.399-2.785V7.522H12.52Z"
        }
      ),
      /* @__PURE__ */ jsx103(
        "path",
        {
          fill: "#D80027",
          d: "M13.913 7.522H12.52v1.391h1.392V7.522ZM16.696 7.522h-1.391v1.391h1.391V7.522ZM19.48 7.522h-1.392v1.391h1.391V7.522ZM15.303 8.913h-1.39v1.391h1.39V8.913ZM18.087 8.913h-1.392v1.391h1.392V8.913ZM13.913 10.304H12.52v1.391h1.392v-1.39ZM15.303 11.695h-1.39v1.392h1.39v-1.392ZM16.696 10.304h-1.391v1.391h1.391v-1.39ZM19.48 10.304h-1.392v1.391h1.391v-1.39ZM18.087 11.695h-1.392v1.392h1.392v-1.392ZM16.696 13.087h-1.391v1.391h1.391v-1.391ZM13.913 13.087H12.61c.12.517.354.99.676 1.391h.626v-1.391ZM18.088 14.478h.625c.322-.4.557-.874.676-1.391h-1.301v1.391ZM13.912 14.478v.607c.405.305.878.523 1.391.628v-1.235h-1.39ZM16.695 14.478v1.235a3.463 3.463 0 0 0 1.392-.628v-.607h-1.392Z"
        }
      ),
      /* @__PURE__ */ jsx103("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Hr_default = SvgHr;

// build/Ht.tsx
import { jsx as jsx104, jsxs as jsxs104 } from "react/jsx-runtime";
var SvgHt = (props) => /* @__PURE__ */ jsxs104(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx104("path", { fill: "#A2001D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx104("path", { fill: "#0052B4", d: "M31 1v9.767L1 11.01V1h30Z" }),
      /* @__PURE__ */ jsx104(
        "path",
        {
          fill: "#FCFCFC",
          d: "M19.478 13.609 16 13.174l-3.479.435V8.39h6.957v5.218Z"
        }
      ),
      /* @__PURE__ */ jsx104(
        "path",
        {
          fill: "#0052B4",
          d: "M16 13.174a1.74 1.74 0 1 0 0-3.478 1.74 1.74 0 0 0 0 3.478Z"
        }
      ),
      /* @__PURE__ */ jsx104(
        "path",
        {
          fill: "#A2001D",
          d: "M16 12.305a.87.87 0 1 0 0-1.74.87.87 0 0 0 0 1.74Z"
        }
      ),
      /* @__PURE__ */ jsx104("path", { fill: "#6DA544", d: "M14.695 9.261h2.609L16 10.565l-1.305-1.304Z" }),
      /* @__PURE__ */ jsx104("path", { fill: "#FFDA44", d: "M16.435 10.13h-.87v2.61h.87v-2.61Z" }),
      /* @__PURE__ */ jsx104(
        "path",
        {
          fill: "#6DA544",
          d: "M17.391 12.479h-2.783l-2.087 1.13h6.957l-2.087-1.13Z"
        }
      ),
      /* @__PURE__ */ jsx104("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ht_default = SvgHt;

// build/Hu.tsx
import { jsx as jsx105, jsxs as jsxs105 } from "react/jsx-runtime";
var SvgHu = (props) => /* @__PURE__ */ jsxs105(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx105("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx105("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx105("path", { fill: "#6DA544", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx105("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Hu_default = SvgHu;

// build/Ib.tsx
import { jsx as jsx106, jsxs as jsxs106 } from "react/jsx-runtime";
var SvgIb = (props) => /* @__PURE__ */ jsxs106(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx106("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx106(
        "path",
        {
          fill: "#FFDA44",
          d: "M31 5.444H1v2.222h30V5.444ZM31 9.888H1v2.222h30V9.888ZM31 14.333H1v2.222h30v-2.222ZM31 18.777H1V21h30v-2.222ZM31 1H1v2.222h30V1Z"
        }
      ),
      /* @__PURE__ */ jsx106("path", { fill: "#4A1F63", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx106(
        "path",
        {
          fill: "#FCFCFC",
          d: "M11.108 5.13V6h-.434v-.87h-.87V6H9.37V4.26H7.63V6h-.435v-.87h-.87V6h-.434v-.87h-.87V7.74h6.957V5.13h-.87Z"
        }
      ),
      /* @__PURE__ */ jsx106("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ib_default = SvgIb;

// build/Ic.tsx
import { jsx as jsx107, jsxs as jsxs107 } from "react/jsx-runtime";
var SvgIc = (props) => /* @__PURE__ */ jsxs107(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx107("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx107("path", { fill: "#FCFCFC", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx107("path", { fill: "#FFDA44", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx107("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ic_default = SvgIc;

// build/Id.tsx
import { jsx as jsx108, jsxs as jsxs108 } from "react/jsx-runtime";
var SvgId = (props) => /* @__PURE__ */ jsxs108(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx108("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx108("path", { fill: "#A2001D", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx108("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Id_default = SvgId;

// build/Ie.tsx
import { jsx as jsx109, jsxs as jsxs109 } from "react/jsx-runtime";
var SvgIe = (props) => /* @__PURE__ */ jsxs109(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx109("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx109("path", { fill: "#6DA544", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx109("path", { fill: "#FF9811", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx109("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ie_default = SvgIe;

// build/Il.tsx
import { jsx as jsx110, jsxs as jsxs110 } from "react/jsx-runtime";
var SvgIl = (props) => /* @__PURE__ */ jsxs110(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx110("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx110(
        "path",
        {
          fill: "#2E52B2",
          d: "M19.75 8.835h-2.5L16 6.67l-1.25 2.165h-2.5L13.5 11l-1.25 2.165h2.5L16 15.33l1.25-2.165h2.5L18.5 11l1.25-2.165ZM17.536 11l-.768 1.33h-1.536L14.464 11l.768-1.33h1.536l.768 1.33ZM16 8.34l.286.495h-.572L16 8.34Zm-2.304 1.33h.572l-.286.495-.286-.495Zm0 2.66.286-.495.286.495h-.572ZM16 13.66l-.286-.495h.572L16 13.66Zm2.304-1.33h-.572l.286-.495.286.495Zm-.572-2.66h.572l-.286.495-.286-.495ZM31 2.25H1v2.5h30v-2.5ZM31 17.25H1v2.5h30v-2.5Z"
        }
      ),
      /* @__PURE__ */ jsx110("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Il_default = SvgIl;

// build/Im.tsx
import { jsx as jsx111, jsxs as jsxs111 } from "react/jsx-runtime";
var SvgIm = (props) => /* @__PURE__ */ jsxs111(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx111("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx111(
        "path",
        {
          fill: "#FCFCFC",
          d: "m19.702 7.703-.706 2.523-2.121-.392L15.51 7.02 11.822 8.33l-.29-.82-.966-.119.727 2.05 2.538-.65.722 2.033-1.755 2.589 2.977 2.539-.564.662.38.895L17 15.854l-1.83-1.874 1.399-1.64 3.12.225.71-3.849.855.158.585-.776-2.138-.395Z"
        }
      ),
      /* @__PURE__ */ jsx111("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Im_default = SvgIm;

// build/In.tsx
import { jsx as jsx112, jsxs as jsxs112 } from "react/jsx-runtime";
var SvgIn = (props) => /* @__PURE__ */ jsxs112(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx112("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx112("path", { fill: "#FF9811", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx112("path", { fill: "#6DA544", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx112(
        "path",
        {
          fill: "#0052B4",
          d: "M16 13.572a2.572 2.572 0 1 0 0-5.144 2.572 2.572 0 0 0 0 5.144Z"
        }
      ),
      /* @__PURE__ */ jsx112(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 12.607a1.607 1.607 0 1 0 0-3.214 1.607 1.607 0 0 0 0 3.214Z"
        }
      ),
      /* @__PURE__ */ jsx112(
        "path",
        {
          fill: "#0052B4",
          d: "m16 9.016.495 1.125 1.222-.133-.726.992.726.992-1.222-.133L16 12.984l-.496-1.125-1.222.133.726-.992-.726-.992 1.222.133L16 9.016Z"
        }
      ),
      /* @__PURE__ */ jsx112("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var In_default = SvgIn;

// build/Io.tsx
import { jsx as jsx113, jsxs as jsxs113 } from "react/jsx-runtime";
var SvgIo = (props) => /* @__PURE__ */ jsxs113(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx113("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#0052B4",
          d: "M28.05 12.602c-.235 0-.783-.311-1.184-.539-.642-.365-1.248-.709-1.828-.709-.58 0-1.186.345-1.828.71-.4.226-.95.538-1.185.538-.235 0-.784-.311-1.184-.539-.642-.365-1.248-.709-1.828-.709-.58 0-1.187.345-1.829.71-.4.226-.949.538-1.184.538s-.784-.311-1.184-.539c-.642-.365-1.249-.709-1.829-.709-.58 0-1.186.345-1.828.71-.4.226-.949.538-1.184.538-.236 0-.784-.311-1.184-.539-.643-.365-1.249-.709-1.829-.709-.58 0-1.186.345-1.828.71-.4.226-.95.538-1.185.538-.235 0-.783-.311-1.184-.539-.619-.351-1.204-.683-1.765-.707v1.309c.26.044.753.323 1.121.532.642.365 1.248.71 1.828.71.58 0 1.187-.345 1.829-.71.4-.227.949-.539 1.184-.539s.784.312 1.184.54c.642.364 1.249.708 1.829.708.58 0 1.186-.344 1.828-.709.4-.227.949-.539 1.184-.539.236 0 .784.312 1.184.54.643.364 1.249.708 1.829.708.58 0 1.186-.344 1.828-.709.4-.227.95-.539 1.184-.539.236 0 .784.312 1.185.54.642.364 1.248.708 1.828.708.58 0 1.186-.344 1.829-.709.4-.227.948-.539 1.184-.539.235 0 .784.312 1.184.54.642.364 1.249.708 1.828.708.58 0 1.187-.344 1.829-.709.368-.209.86-.488 1.12-.532v-1.309c-.56.024-1.146.356-1.764.707-.4.227-.949.539-1.184.539ZM1 2.883c.26.043.753.323 1.121.532.642.365 1.248.709 1.828.709.58 0 1.187-.344 1.829-.709.4-.227.949-.539 1.184-.539s.784.312 1.184.539c.642.365 1.249.709 1.829.709.58 0 1.186-.344 1.828-.709.4-.227.949-.539 1.184-.539.236 0 .784.312 1.184.539.643.365 1.249.709 1.829.709.58 0 1.186-.344 1.828-.709.4-.227.95-.539 1.184-.539.236 0 .784.312 1.185.539.642.365 1.248.709 1.828.709.58 0 1.186-.344 1.829-.709.4-.227.948-.539 1.184-.539.235 0 .784.312 1.184.539.642.365 1.249.709 1.828.709.58 0 1.187-.344 1.829-.709.368-.21.86-.489 1.12-.532V1.574c-.56.024-1.146.355-1.764.707-.4.227-.95.539-1.185.539-.235 0-.784-.312-1.184-.54-.642-.364-1.248-.708-1.828-.708-.58 0-1.187.344-1.829.709-.4.227-.949.539-1.184.539s-.784-.312-1.184-.54c-.642-.364-1.249-.708-1.829-.708-.58 0-1.186.344-1.828.709-.4.227-.949.539-1.184.539-.236 0-.784-.312-1.184-.54-.643-.364-1.249-.708-1.829-.708-.58 0-1.186.344-1.828.709-.4.227-.95.539-1.184.539-.236 0-.784-.312-1.185-.54-.642-.364-1.248-.708-1.828-.708-.58 0-1.186.344-1.828.709-.4.227-.95.539-1.185.539-.235 0-.784-.312-1.184-.54-.619-.35-1.204-.682-1.765-.706v1.309ZM28.05 6.08c-.235 0-.783-.311-1.184-.538-.642-.365-1.248-.71-1.828-.71-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.784-.311-1.184-.538-.642-.365-1.248-.71-1.828-.71-.58 0-1.187.345-1.829.71-.4.227-.949.538-1.184.538s-.784-.311-1.184-.538c-.642-.365-1.249-.71-1.829-.71-.58 0-1.186.345-1.828.71-.4.227-.949.538-1.184.538-.236 0-.784-.311-1.184-.538-.643-.365-1.249-.71-1.829-.71-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.783-.311-1.184-.538C2.146 5.19 1.561 4.859 1 4.835v1.308c.26.044.753.324 1.121.533.642.364 1.248.709 1.828.709.58 0 1.187-.345 1.829-.71.4-.227.949-.538 1.184-.538s.784.311 1.184.539c.642.364 1.249.709 1.829.709.58 0 1.186-.345 1.828-.71.4-.227.949-.538 1.184-.538.236 0 .784.311 1.184.539.643.364 1.249.709 1.829.709.58 0 1.186-.345 1.828-.71.4-.227.95-.538 1.184-.538.236 0 .784.311 1.185.539.642.364 1.248.709 1.828.709.58 0 1.186-.345 1.829-.71.4-.227.948-.538 1.184-.538.235 0 .784.311 1.184.539.642.364 1.249.709 1.828.709.58 0 1.187-.345 1.829-.71.368-.208.86-.488 1.12-.532V4.835c-.56.024-1.146.355-1.764.707-.4.227-.949.538-1.184.538ZM31 8.096c-.56.023-1.146.355-1.765.706-.4.228-.95.54-1.184.54-.236 0-.784-.312-1.185-.54-.642-.364-1.248-.709-1.828-.709-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.784-.311-1.184-.539-.642-.364-1.248-.709-1.828-.709-.58 0-1.187.345-1.829.71-.4.227-.949.538-1.184.538s-.784-.311-1.184-.539c-.642-.364-1.249-.709-1.829-.709-.58 0-1.186.345-1.828.71-.4.227-.949.538-1.184.538-.236 0-.784-.311-1.184-.539-.643-.364-1.249-.709-1.829-.709-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.783-.311-1.184-.539C2.146 8.451 1.561 8.12 1 8.096v1.308c.26.044.753.323 1.121.533.642.364 1.248.709 1.828.709.58 0 1.187-.345 1.829-.71.4-.227.949-.538 1.184-.538s.784.311 1.184.539c.642.364 1.249.709 1.829.709.58 0 1.186-.345 1.828-.71.4-.227.949-.538 1.184-.538.236 0 .784.311 1.184.539.643.364 1.249.709 1.829.709.58 0 1.186-.345 1.828-.71.4-.227.95-.538 1.184-.538.236 0 .784.311 1.185.539.642.364 1.248.709 1.828.709.58 0 1.186-.345 1.829-.71.4-.227.948-.538 1.184-.538.235 0 .784.311 1.184.539.642.364 1.249.709 1.828.709.58 0 1.187-.345 1.829-.71.368-.209.86-.488 1.12-.532V8.096H31ZM28.05 15.863c-.235 0-.783-.312-1.184-.54-.642-.364-1.248-.708-1.828-.708-.58 0-1.186.344-1.828.709-.4.227-.95.539-1.185.539-.235 0-.784-.312-1.184-.54-.642-.364-1.248-.708-1.828-.708-.58 0-1.187.344-1.829.709-.4.227-.949.539-1.184.539s-.784-.312-1.184-.54c-.642-.364-1.249-.708-1.829-.708-.58 0-1.186.344-1.828.709-.4.227-.949.539-1.184.539-.236 0-.784-.312-1.184-.54-.643-.364-1.249-.708-1.829-.708-.58 0-1.186.344-1.828.709-.4.227-.95.539-1.185.539-.235 0-.783-.312-1.184-.54-.619-.35-1.204-.682-1.765-.706v1.309c.26.043.753.323 1.121.532.642.365 1.248.709 1.828.709.58 0 1.187-.344 1.829-.709.4-.227.949-.539 1.184-.539s.784.312 1.184.54c.642.364 1.249.708 1.829.708.58 0 1.186-.344 1.828-.709.4-.227.949-.539 1.184-.539.236 0 .784.312 1.184.54.643.364 1.249.708 1.829.708.58 0 1.186-.344 1.828-.709.4-.227.95-.539 1.184-.539.236 0 .784.312 1.185.54.642.364 1.248.708 1.828.708.58 0 1.186-.344 1.829-.709.4-.227.948-.539 1.184-.539.235 0 .784.312 1.184.54.642.364 1.249.708 1.828.708.58 0 1.187-.344 1.829-.709.368-.21.86-.489 1.12-.532v-1.309c-.56.024-1.146.355-1.764.707-.4.227-.949.539-1.184.539ZM31 17.878c-.56.024-1.146.355-1.765.707-.4.227-.95.539-1.184.539-.236 0-.784-.312-1.185-.54-.642-.364-1.248-.708-1.828-.708-.58 0-1.186.344-1.828.709-.4.227-.95.539-1.185.539-.235 0-.784-.312-1.184-.54-.642-.364-1.248-.708-1.828-.708-.58 0-1.187.344-1.829.709-.4.227-.949.539-1.184.539s-.784-.312-1.184-.54c-.642-.364-1.249-.708-1.829-.708-.58 0-1.186.344-1.828.709-.4.227-.949.539-1.184.539-.236 0-.784-.312-1.184-.54-.643-.364-1.249-.708-1.829-.708-.58 0-1.186.344-1.828.709-.4.227-.95.539-1.185.539-.235 0-.783-.312-1.184-.54-.619-.35-1.204-.682-1.765-.706v1.308c.26.044.753.324 1.121.533.642.364 1.248.709 1.828.709.58 0 1.187-.345 1.829-.71.4-.227.949-.538 1.184-.538s.784.311 1.184.539c.642.364 1.249.709 1.829.709.58 0 1.186-.345 1.828-.71.4-.227.949-.538 1.184-.538.236 0 .784.311 1.184.539.643.364 1.249.709 1.829.709.58 0 1.186-.345 1.828-.71.4-.227.95-.538 1.184-.538.236 0 .784.311 1.185.539.642.364 1.248.709 1.828.709.58 0 1.186-.345 1.829-.71.4-.227.948-.538 1.184-.538.235 0 .784.311 1.184.539.642.364 1.249.709 1.828.709.58 0 1.187-.345 1.829-.71.368-.208.86-.488 1.12-.532v-1.308H31Z"
        }
      ),
      /* @__PURE__ */ jsx113("path", { fill: "#FCFCFC", d: "M15.973 11h.026v-.027a6.76 6.76 0 0 0-.026.027Z" }),
      /* @__PURE__ */ jsx113("path", { fill: "#6DA544", d: "M21.543 5.891h3.913L23.5 7.848 21.543 5.89Z" }),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#A2001D",
          d: "M23.934 7.413h-.87v2.391h.87V7.413ZM23.934 13.717h-.87v2.392h.87v-2.392Z"
        }
      ),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#FFDA44",
          d: "M26.108 12.413a1.304 1.304 0 0 0-2.174-.972v-.767h.435v-.87h-.435V9.37h-.87v.435h-.434v.87h.434v.767a1.304 1.304 0 0 0-1.74 1.944v.767h4.35v-.767c.266-.239.434-.586.434-.972Z"
        }
      ),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#D80027",
          d: "M24.805 11.978a.428.428 0 0 0-.29.11l-.58.52h-.869l-.58-.52a.435.435 0 0 0-.58.648l.29.26v.286h2.61v-.286l.289-.259a.435.435 0 0 0-.29-.759Z"
        }
      ),
      /* @__PURE__ */ jsx113("path", { fill: "#FCFCFC", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx113("path", { fill: "#D80027", d: "M1 1v.884l3.362 2.241h1.325L1 1Z" }),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#2E52B2",
          d: "M1 2.325v1.8h2.7L1 2.325ZM6.625 1v2.866L2.326 1h4.3Z"
        }
      ),
      /* @__PURE__ */ jsx113("path", { fill: "#D80027", d: "M16 1v.884l-3.362 2.241h-1.325L16 1Z" }),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#2E52B2",
          d: "M16 2.325v1.8h-2.7l2.7-1.8ZM10.375 1v2.866L14.675 1h-4.3Z"
        }
      ),
      /* @__PURE__ */ jsx113("path", { fill: "#D80027", d: "M1 1v.884l3.362 2.241h1.325L1 1Z" }),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#2E52B2",
          d: "M1 2.325v1.8h2.7L1 2.325ZM6.625 1v2.866L2.326 1h4.3Z"
        }
      ),
      /* @__PURE__ */ jsx113("path", { fill: "#D80027", d: "M16 1v.884l-3.362 2.241h-1.325L16 1Z" }),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#2E52B2",
          d: "M16 2.325v1.8h-2.7l2.7-1.8ZM10.375 1v2.866L14.675 1h-4.3Z"
        }
      ),
      /* @__PURE__ */ jsx113("path", { fill: "#D80027", d: "M1 11v-.884l3.362-2.241h1.325L1 11Z" }),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#2E52B2",
          d: "M1 9.674v-1.8h2.7L1 9.675ZM6.625 11V8.134L2.326 11h4.3Z"
        }
      ),
      /* @__PURE__ */ jsx113("path", { fill: "#D80027", d: "M16 11v-.884l-3.362-2.241h-1.325L16 11Z" }),
      /* @__PURE__ */ jsx113(
        "path",
        {
          fill: "#2E52B2",
          d: "M16 9.674v-1.8h-2.7l2.7 1.8ZM10.375 11V8.134l4.3 2.866h-4.3Z"
        }
      ),
      /* @__PURE__ */ jsx113("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Io_default = SvgIo;

// build/Iq.tsx
import { jsx as jsx114, jsxs as jsxs114 } from "react/jsx-runtime";
var SvgIq = (props) => /* @__PURE__ */ jsxs114(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx114("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx114("path", { fill: "#A2001D", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx114("path", { fill: "#000", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx114(
        "path",
        {
          fill: "#496E2D",
          d: "M13.844 10.418H12.123a.777.777 0 0 1 .75-.582V8.672c-1.069 0-1.939.87-1.939 1.94v.97h2.91c.107 0 .194.087.194.194v.388h-3.88v1.163h5.043v-1.551a1.36 1.36 0 0 0-1.357-1.358ZM16.752 12.164V8.672h-1.164v4.656h1.94v-1.164h-.776ZM20.631 12.164V8.672h-1.163v3.492h-.388V11h-1.164v2.328h3.491v-1.164h-.776Z"
        }
      ),
      /* @__PURE__ */ jsx114("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Iq_default = SvgIq;

// build/Ir.tsx
import { jsx as jsx115, jsxs as jsxs115 } from "react/jsx-runtime";
var SvgIr = (props) => /* @__PURE__ */ jsxs115(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx115("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx115("path", { fill: "#6DA544", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx115(
        "path",
        {
          fill: "#D80027",
          d: "M31 14.333H1V21h30v-6.667ZM18.598 8.913H17.55c.009.115.014.231.014.348 0 .774-.194 1.524-.531 2.058a1.89 1.89 0 0 1-.513.554v-2.96h-1.043v2.96a1.892 1.892 0 0 1-.513-.554c-.338-.534-.53-1.284-.53-2.058 0-.117.004-.233.013-.348H13.4c-.007.114-.01.23-.01.348 0 2.145 1.146 3.826 2.608 3.826 1.463 0 2.61-1.68 2.61-3.826-.001-.118-.005-.234-.011-.348Z"
        }
      ),
      /* @__PURE__ */ jsx115(
        "path",
        {
          fill: "#FCFCFC",
          d: "M4.914 6.797H3.609v1.431h1.305v-1.43ZM2.304 6.797H1v1.431h1.304v-1.43ZM7.521 6.797H6.217v1.431H7.52v-1.43ZM10.13 6.797H8.826v1.431h1.304v-1.43ZM12.74 6.797h-1.305v1.431h1.305v-1.43ZM15.347 6.797h-1.304v1.431h1.304v-1.43ZM17.957 6.797h-1.305v1.431h1.305v-1.43ZM20.566 6.797h-1.304v1.431h1.304v-1.43ZM23.174 6.797h-1.305v1.431h1.305v-1.43ZM25.783 6.797h-1.305v1.431h1.305v-1.43ZM28.392 6.797h-1.304v1.431h1.304v-1.43ZM31 6.797h-1.305v1.431H31v-1.43ZM4.914 13.707H3.609v1.496h1.305v-1.496ZM2.304 13.707H1v1.496h1.304v-1.496ZM7.521 13.707H6.217v1.496H7.52v-1.496ZM10.13 13.707H8.826v1.496h1.304v-1.496ZM12.74 13.707h-1.305v1.496h1.305v-1.496ZM15.347 13.707h-1.304v1.496h1.304v-1.496ZM17.957 13.707h-1.305v1.496h1.305v-1.496ZM20.566 13.707h-1.304v1.496h1.304v-1.496ZM23.174 13.707h-1.305v1.496h1.305v-1.496ZM25.783 13.707h-1.305v1.496h1.305v-1.496ZM28.392 13.707h-1.304v1.496h1.304v-1.496ZM31 13.707h-1.305v1.496H31v-1.496Z"
        }
      ),
      /* @__PURE__ */ jsx115("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ir_default = SvgIr;

// build/Is.tsx
import { jsx as jsx116, jsxs as jsxs116 } from "react/jsx-runtime";
var SvgIs = (props) => /* @__PURE__ */ jsxs116(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx116("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx116(
        "path",
        {
          fill: "#FCFCFC",
          d: "M31 13.337H12.847V21H8.174v-7.663H1V8.663h7.174V1h4.673v7.663H31V13.337Z"
        }
      ),
      /* @__PURE__ */ jsx116(
        "path",
        {
          fill: "#D80027",
          d: "M31 9.75v2.5H11.76V21h-2.5v-8.75H1v-2.5h8.26V1h2.5v8.75H31Z"
        }
      ),
      /* @__PURE__ */ jsx116("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Is_default = SvgIs;

// build/It.tsx
import { jsx as jsx117, jsxs as jsxs117 } from "react/jsx-runtime";
var SvgIt = (props) => /* @__PURE__ */ jsxs117(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx117("path", { fill: "#FCFCFC", d: "M21 1H1v20h30V1H21Z" }),
      /* @__PURE__ */ jsx117("path", { fill: "#6DA544", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx117("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx117("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var It_default = SvgIt;

// build/Je.tsx
import { jsx as jsx118, jsxs as jsxs118 } from "react/jsx-runtime";
var SvgJe = (props) => /* @__PURE__ */ jsxs118(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx118("path", { fill: "#fff", d: "M1 1h30v19.981H1z" }),
      /* @__PURE__ */ jsx118(
        "path",
        {
          fill: "#D80027",
          d: "M18.652 11.01 31 2.785V1.02h-2.652L16 9.244 3.652 1.019H1v1.766l12.348 8.225L1 19.234V21h2.652L16 12.776 28.348 21H31v-1.766L18.652 11.01Z"
        }
      ),
      /* @__PURE__ */ jsx118(
        "path",
        {
          fill: "#FFDA44",
          d: "M14.695 5.797 16 6.123l1.304-.326V4.69l-.522.26L16 4.168l-.783.782-.522-.26v1.107Z"
        }
      ),
      /* @__PURE__ */ jsx118(
        "path",
        {
          fill: "#D80027",
          d: "M14.695 5.797v.815c0 .997 1.305 1.303 1.305 1.303s1.304-.306 1.304-1.303v-.815h-2.609Z"
        }
      ),
      /* @__PURE__ */ jsx118("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Je_default = SvgJe;

// build/Jm.tsx
import { jsx as jsx119, jsxs as jsxs119 } from "react/jsx-runtime";
var SvgJm = (props) => /* @__PURE__ */ jsxs119(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx119("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx119(
        "path",
        {
          fill: "#000",
          d: "M13.648 11 1 19.432V2.568L13.648 11ZM31 2.568v16.864L18.352 11 31 2.568Z"
        }
      ),
      /* @__PURE__ */ jsx119(
        "path",
        {
          fill: "#0052B4",
          d: "M31 2.568 18.352 11 31 19.432V21h-2.351L16 12.568 3.351 21H1v-1.568L13.648 11 1 2.568V1h2.351L16 9.433 28.649 1H31v1.568Z"
        }
      ),
      /* @__PURE__ */ jsx119(
        "path",
        {
          fill: "#FFDA44",
          d: "M31 2.568 18.352 11 31 19.432V21h-2.351L16 12.568 3.351 21H1v-1.568L13.648 11 1 2.568V1h2.351L16 9.433 28.649 1H31v1.568Z"
        }
      ),
      /* @__PURE__ */ jsx119("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Jm_default = SvgJm;

// build/Jo.tsx
import { jsx as jsx120, jsxs as jsxs120 } from "react/jsx-runtime";
var SvgJo = (props) => /* @__PURE__ */ jsxs120(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx120("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx120("path", { fill: "#000", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx120("path", { fill: "#6DA544", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx120("path", { fill: "#D80027", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx120(
        "path",
        {
          fill: "#FCFCFC",
          d: "m5.565 9.172.462.965 1.042-.24-.467.962.838.664-1.043.235.003 1.07-.835-.67-.834.67.003-1.07-1.044-.235.839-.664-.467-.963 1.042.241.461-.965Z"
        }
      ),
      /* @__PURE__ */ jsx120("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Jo_default = SvgJo;

// build/Jp.tsx
import { jsx as jsx121, jsxs as jsxs121 } from "react/jsx-runtime";
var SvgJp = (props) => /* @__PURE__ */ jsxs121(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx121("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx121(
        "path",
        {
          fill: "#D80027",
          d: "M16 16.625a5.625 5.625 0 1 0 0-11.25 5.625 5.625 0 0 0 0 11.25Z"
        }
      ),
      /* @__PURE__ */ jsx121("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Jp_default = SvgJp;

// build/Ke.tsx
import { jsx as jsx122, jsxs as jsxs122 } from "react/jsx-runtime";
var SvgKe = (props) => /* @__PURE__ */ jsxs122(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx122("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx122("path", { fill: "#000", d: "M31 1H1v5.307h30V1Z" }),
      /* @__PURE__ */ jsx122("path", { fill: "#496E2D", d: "M31 15.693H1v5.306h30v-5.306Z" }),
      /* @__PURE__ */ jsx122("path", { fill: "#A2001D", d: "M31 7.637H1v6.727h30V7.636Z" }),
      /* @__PURE__ */ jsx122(
        "path",
        {
          fill: "#FCFCFC",
          d: "M19.941 4.192 18.442 3.5 16 9.03 13.558 3.5l-1.5.692L15.092 11l-3.032 6.808 1.499.692L16 12.97l2.442 5.53 1.5-.692L16.908 11l3.032-6.808Z"
        }
      ),
      /* @__PURE__ */ jsx122(
        "path",
        {
          fill: "#FCFCFC",
          d: "M17.019 4.844C16.439 4.21 16 3.846 16 3.846s-.438.364-1.019.998v12.312c.58.633 1.018.998 1.018.998s.438-.364 1.019-.998V4.844Z"
        }
      ),
      /* @__PURE__ */ jsx122(
        "path",
        {
          fill: "#A2001D",
          d: "M13.248 7.205v7.59a13.28 13.28 0 0 0 1.926 2.567V4.637c-.562.59-1.313 1.481-1.926 2.568ZM18.752 7.205a13.273 13.273 0 0 0-1.926-2.568v12.725a13.277 13.277 0 0 0 1.926-2.567v-7.59Z"
        }
      ),
      /* @__PURE__ */ jsx122(
        "path",
        {
          fill: "#000",
          d: "M18.752 7.205v7.59c.62-1.1 1.1-2.401 1.1-3.795 0-1.394-.48-2.695-1.1-3.795ZM13.25 7.205v7.59c-.622-1.1-1.102-2.401-1.102-3.795 0-1.394.48-2.695 1.101-3.795Z"
        }
      ),
      /* @__PURE__ */ jsx122("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ke_default = SvgKe;

// build/Kg.tsx
import { jsx as jsx123, jsxs as jsxs123 } from "react/jsx-runtime";
var SvgKg = (props) => /* @__PURE__ */ jsxs123(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx123("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx123(
        "path",
        {
          fill: "#FFDA44",
          d: "m20.89 11-1.998.94 1.064 1.935-2.17-.415-.275 2.192L16 14.04l-1.511 1.612-.276-2.192-2.17.415 1.065-1.935-1.999-.94 1.999-.94-1.064-1.936 2.17.416.274-2.192L16 7.96l1.511-1.612.275 2.192 2.17-.416-1.064 1.936 1.998.94Z"
        }
      ),
      /* @__PURE__ */ jsx123(
        "path",
        {
          fill: "#D80027",
          d: "M16 14.043a3.043 3.043 0 1 0 0-6.087 3.043 3.043 0 0 0 0 6.087Z"
        }
      ),
      /* @__PURE__ */ jsx123(
        "path",
        {
          fill: "#FFDA44",
          d: "M14.479 11c-.073 0-.146.003-.217.01.002.422.155.808.407 1.108a3.05 3.05 0 0 1 .588-.974 2.162 2.162 0 0 0-.778-.144ZM15.416 12.638a1.736 1.736 0 0 0 1.17 0c-.1-.391-.305-.74-.585-1.015-.28.275-.485.624-.585 1.015ZM17.506 10.13a1.738 1.738 0 0 0-3.012 0 3.025 3.025 0 0 1 1.506.41 3.024 3.024 0 0 1 1.506-.41ZM16.744 11.144c.253.282.454.612.588.974.252-.3.404-.686.407-1.107a2.196 2.196 0 0 0-.995.133Z"
        }
      ),
      /* @__PURE__ */ jsx123("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Kg_default = SvgKg;

// build/Kh.tsx
import { jsx as jsx124, jsxs as jsxs124 } from "react/jsx-runtime";
var SvgKh = (props) => /* @__PURE__ */ jsxs124(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx124("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx124("path", { fill: "#0052B4", d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx124(
        "path",
        {
          fill: "#FCFCFC",
          d: "M18.782 12.522v-1.044h-.695v-1.391l-.696-.696-.696.696V8.696L16 8l-.696.696v1.39l-.696-.695-.695.696v1.391h-.696v1.044h-.696v1.043h6.957v-1.043h-.696Z"
        }
      ),
      /* @__PURE__ */ jsx124("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Kh_default = SvgKh;

// build/Ki.tsx
import { jsx as jsx125, jsxs as jsxs125 } from "react/jsx-runtime";
var SvgKi = (props) => /* @__PURE__ */ jsxs125(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx125(
        "path",
        {
          fill: "#D80027",
          d: "M31 1v10.059c-.822.06-2.155 1.245-2.95 1.245-.814 0-2.197-1.247-3.012-1.247s-2.197 1.247-3.013 1.247c-.815 0-2.197-1.247-3.013-1.247-.815 0-2.197 1.247-3.012 1.247s-2.197-1.247-3.012-1.247c-.816 0-2.198 1.247-3.013 1.247-.816 0-2.198-1.247-3.013-1.247s-2.198 1.247-3.013 1.247c-.794 0-2.127-1.185-2.949-1.245V1h30Z"
        }
      ),
      /* @__PURE__ */ jsx125(
        "path",
        {
          fill: "#FFDA44",
          d: "m19.478 10.952-1.421.669.757 1.376-1.544-.295-.195 1.559L16 13.114l-1.075 1.147-.196-1.56-1.543.296.757-1.376-1.421-.669 1.42-.668-.756-1.377 1.543.295.196-1.559L16 8.79l1.075-1.147.195 1.56 1.544-.296-.757 1.377 1.421.668ZM18.608 4.913h-1.957a.652.652 0 0 0-1.304 0h-1.956c0 .36.313.652.674.652h-.022c0 .36.292.652.652.652 0 .36.292.652.652.652h1.304c.36 0 .653-.292.653-.652.36 0 .652-.292.652-.652h-.022c.36 0 .674-.292.674-.652Z"
        }
      ),
      /* @__PURE__ */ jsx125(
        "path",
        {
          fill: "#0052B4",
          d: "M31 11.059V21H1v-9.941c.822.06 2.155 1.245 2.95 1.245.814 0 2.197-1.247 3.012-1.247s2.197 1.247 3.013 1.247c.815 0 2.197-1.247 3.013-1.247.815 0 2.197 1.247 3.012 1.247s2.197-1.247 3.012-1.247c.816 0 2.198 1.247 3.013 1.247.816 0 2.198-1.247 3.013-1.247s2.198 1.247 3.013 1.247c.794 0 2.127-1.185 2.949-1.245Z"
        }
      ),
      /* @__PURE__ */ jsx125(
        "path",
        {
          fill: "#FCFCFC",
          d: "M1 11.715c.26.044.753.323 1.121.533.642.364 1.248.709 1.828.709.58 0 1.187-.345 1.829-.71.4-.227.949-.538 1.184-.538s.784.311 1.184.539c.642.364 1.249.709 1.829.709.58 0 1.186-.345 1.828-.71.4-.227.949-.538 1.184-.538.236 0 .784.311 1.185.539.642.364 1.248.709 1.828.709.58 0 1.186-.345 1.828-.71.4-.227.95-.538 1.185-.538.235 0 .784.311 1.184.539.642.364 1.248.709 1.828.709.58 0 1.187-.345 1.829-.71.4-.227.949-.538 1.184-.538s.784.311 1.184.539c.642.364 1.249.709 1.829.709.58 0 1.186-.345 1.828-.71.368-.209.861-.488 1.12-.532v-1.308c-.56.023-1.145.355-1.764.706-.4.228-.95.54-1.184.54-.236 0-.784-.312-1.185-.54-.642-.364-1.248-.709-1.828-.709-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.784-.311-1.184-.539-.642-.364-1.248-.709-1.828-.709-.58 0-1.187.345-1.829.71-.4.227-.949.538-1.184.538s-.784-.311-1.184-.539c-.642-.364-1.249-.709-1.829-.709-.58 0-1.186.345-1.828.71-.4.227-.949.538-1.184.538-.236 0-.784-.311-1.185-.539-.642-.364-1.248-.709-1.828-.709-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.784-.311-1.184-.539-.619-.351-1.204-.683-1.765-.706v1.308ZM28.05 14.913c-.235 0-.783-.311-1.184-.539-.642-.364-1.248-.709-1.828-.709-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.784-.311-1.184-.539-.642-.364-1.248-.709-1.828-.709-.58 0-1.187.345-1.829.71-.4.227-.949.538-1.184.538s-.784-.311-1.184-.539c-.642-.364-1.249-.709-1.829-.709-.58 0-1.186.345-1.828.71-.4.227-.949.538-1.184.538-.236 0-.784-.311-1.185-.539-.642-.364-1.248-.709-1.828-.709-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.783-.311-1.184-.539-.619-.351-1.204-.683-1.765-.707v1.31c.26.043.753.322 1.121.531.642.365 1.248.71 1.828.71.58 0 1.187-.345 1.829-.71.4-.227.949-.538 1.184-.538s.784.311 1.184.538c.642.365 1.249.71 1.829.71.58 0 1.186-.345 1.828-.71.4-.227.949-.538 1.184-.538.236 0 .784.311 1.185.538.642.365 1.248.71 1.828.71.58 0 1.186-.345 1.828-.71.4-.227.95-.538 1.185-.538.235 0 .784.311 1.184.538.642.365 1.248.71 1.828.71.58 0 1.187-.345 1.829-.71.4-.227.949-.538 1.184-.538s.784.311 1.184.538c.642.365 1.249.71 1.829.71.58 0 1.186-.345 1.828-.71.368-.209.861-.488 1.12-.532v-1.308c-.56.023-1.145.355-1.764.706-.4.228-.949.54-1.184.54ZM31 16.928c-.56.024-1.146.356-1.765.707-.4.228-.95.54-1.184.54-.236 0-.784-.312-1.185-.54-.642-.365-1.248-.709-1.828-.709-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.784-.311-1.184-.539-.642-.365-1.248-.709-1.828-.709-.58 0-1.187.345-1.829.71-.4.227-.949.538-1.184.538s-.784-.311-1.184-.539c-.642-.365-1.249-.709-1.829-.709-.58 0-1.186.345-1.828.71-.4.227-.949.538-1.184.538-.236 0-.784-.311-1.185-.539-.642-.365-1.248-.709-1.828-.709-.58 0-1.186.345-1.828.71-.4.227-.95.538-1.185.538-.235 0-.784-.311-1.184-.539-.619-.351-1.204-.683-1.765-.707v1.309c.26.044.753.323 1.121.532.642.365 1.248.71 1.828.71.58 0 1.187-.345 1.829-.71.4-.227.949-.538 1.184-.538s.784.311 1.184.538c.642.365 1.249.71 1.829.71.58 0 1.186-.345 1.828-.71.4-.227.949-.538 1.184-.538.236 0 .784.311 1.185.538.642.365 1.248.71 1.828.71.58 0 1.186-.345 1.828-.71.4-.227.95-.538 1.185-.538.235 0 .784.311 1.184.538.642.365 1.248.71 1.828.71.58 0 1.187-.345 1.829-.71.4-.227.949-.538 1.184-.538s.784.311 1.184.538c.642.365 1.249.71 1.829.71.58 0 1.186-.345 1.828-.71.368-.209.861-.488 1.12-.532V16.93H31Z"
        }
      ),
      /* @__PURE__ */ jsx125("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ki_default = SvgKi;

// build/Km.tsx
import { jsx as jsx126, jsxs as jsxs126 } from "react/jsx-runtime";
var SvgKm = (props) => /* @__PURE__ */ jsxs126(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx126("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx126("path", { fill: "#FFDA44", d: "M31 1H1v5h30V1Z" }),
      /* @__PURE__ */ jsx126("path", { fill: "#FCFCFC", d: "M31 6H1v5h30V6Z" }),
      /* @__PURE__ */ jsx126("path", { fill: "#D80027", d: "M31 11H1v5h30v-5Z" }),
      /* @__PURE__ */ jsx126("path", { fill: "#6DA544", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx126(
        "path",
        {
          fill: "#FCFCFC",
          d: "M5.021 11a3.044 3.044 0 0 1 2.391-2.973 3.043 3.043 0 1 0 0 5.945A3.044 3.044 0 0 1 5.022 11Z"
        }
      ),
      /* @__PURE__ */ jsx126(
        "path",
        {
          fill: "#FCFCFC",
          d: "m7.38 8.391.161.499h.524l-.424.308.162.498-.424-.308-.424.308.162-.498-.424-.308h.524l.162-.499ZM7.38 9.696l.161.498h.524l-.424.308.162.498-.424-.308-.424.308.162-.498-.424-.308h.524l.162-.498ZM7.38 11l.161.498h.524l-.424.308.162.498-.424-.308-.424.308.162-.498-.424-.308h.524L7.38 11ZM7.38 12.304l.161.498h.524l-.424.309.162.498-.424-.308-.424.308.162-.498-.424-.309h.524l.162-.498Z"
        }
      ),
      /* @__PURE__ */ jsx126("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Km_default = SvgKm;

// build/Kn.tsx
import { jsx as jsx127, jsxs as jsxs127 } from "react/jsx-runtime";
var SvgKn = (props) => /* @__PURE__ */ jsxs127(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx127("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx127("path", { fill: "#6DA544", d: "M31 1H1v20" }),
      /* @__PURE__ */ jsx127(
        "path",
        {
          fill: "#FFDA44",
          d: "M27.173 1h-1.69L1 17.321V21H6.517L31 4.678V1h-3.827Z"
        }
      ),
      /* @__PURE__ */ jsx127("path", { fill: "#000", d: "M31 1h-3.827L1 18.448V21h3.827L31 3.55V1Z" }),
      /* @__PURE__ */ jsx127(
        "path",
        {
          fill: "#FCFCFC",
          d: "m11.913 11.582 1.107.852 1.152-.79-.467 1.316 1.107.851-1.396-.037-.468 1.316-.395-1.34-1.397-.038 1.152-.79-.395-1.34ZM17.944 7.445l1.107.851 1.152-.79-.467 1.316 1.107.852-1.396-.038-.467 1.316-.396-1.34-1.396-.037 1.152-.79-.396-1.34Z"
        }
      ),
      /* @__PURE__ */ jsx127("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Kn_default = SvgKn;

// build/Kp.tsx
import { jsx as jsx128, jsxs as jsxs128 } from "react/jsx-runtime";
var SvgKp = (props) => /* @__PURE__ */ jsxs128(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx128("path", { fill: "#91DC5A", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx128("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx128("path", { fill: "#0052B4", d: "M31 1H1v3.35h30V1ZM31 17.65H1V21h30v-3.35Z" }),
      /* @__PURE__ */ jsx128("path", { fill: "#D80027", d: "M31 5.68H1v10.64h30V5.68Z" }),
      /* @__PURE__ */ jsx128(
        "path",
        {
          fill: "#FCFCFC",
          d: "M12.152 14.847a3.848 3.848 0 1 0 0-7.695 3.848 3.848 0 0 0 0 7.695Z"
        }
      ),
      /* @__PURE__ */ jsx128(
        "path",
        {
          fill: "#D80027",
          d: "m12.152 7.152.863 2.657h2.798l-2.264 1.643.87 2.664-2.267-1.65-2.264 1.647.867-2.661-2.263-1.643h2.796l.864-2.657Z"
        }
      ),
      /* @__PURE__ */ jsx128("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Kp_default = SvgKp;

// build/Kr.tsx
import { jsx as jsx129, jsxs as jsxs129 } from "react/jsx-runtime";
var SvgKr = (props) => /* @__PURE__ */ jsxs129(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx129("path", { fill: "#fff", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx129(
        "path",
        {
          fill: "#D80027",
          d: "M19.652 11c0 .913-1.635 3.195-3.652 3.195-2.017 0-3.652-2.282-3.652-3.195a3.652 3.652 0 1 1 7.304 0Z"
        }
      ),
      /* @__PURE__ */ jsx129("path", { fill: "#0052B4", d: "M19.652 11a3.652 3.652 0 0 1-7.304 0" }),
      /* @__PURE__ */ jsx129(
        "path",
        {
          fill: "#000",
          d: "m20.841 13.26-.968.968.646.646.968-.969-.645-.645ZM19.228 14.873l-.968.969.645.645.969-.968-.646-.646ZM22.779 15.195l-.968.969.645.645.969-.968-.646-.646ZM21.166 16.81l-.969.969.646.645.968-.968-.645-.646ZM21.81 14.228l-.968.968.645.646.969-.969-.646-.645ZM20.197 15.842l-.968.968.645.646.969-.969-.646-.645ZM19.228 5.189 21.81 7.77l.646-.645-2.582-2.583-.646.646ZM18.26 6.157l.968.969.646-.646-.968-.968-.646.646ZM19.873 7.772l.969.968.645-.645-.968-.969-.646.646ZM20.196 4.22l.968.969.646-.646-.969-.968-.645.646ZM21.81 5.835l.97.968.645-.645-.969-.969-.645.646ZM11.803 17.778l-2.582-2.582-.646.646 2.583 2.582.645-.646ZM12.771 16.81l-.968-.968-.646.645.969.969.645-.646ZM11.158 15.196l-.968-.968-.646.645.968.969.646-.646ZM13.74 15.842l-2.582-2.582-.645.645 2.582 2.583.646-.646ZM9.222 6.802l2.583-2.582-.646-.646-2.582 2.583.645.645ZM10.19 7.771l2.582-2.582-.646-.646-2.583 2.583.646.645ZM11.158 8.74l2.582-2.583-.645-.645-2.583 2.582.646.646Z"
        }
      ),
      /* @__PURE__ */ jsx129("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Kr_default = SvgKr;

// build/Kw.tsx
import { jsx as jsx130, jsxs as jsxs130 } from "react/jsx-runtime";
var SvgKw = (props) => /* @__PURE__ */ jsxs130(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx130("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx130("path", { fill: "#6DA544", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx130("path", { fill: "#D80027", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx130("path", { fill: "#000", d: "M10.783 14.333 1 21V1l9.783 6.667v6.666Z" }),
      /* @__PURE__ */ jsx130("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Kw_default = SvgKw;

// build/Ky.tsx
import { jsx as jsx131, jsxs as jsxs131 } from "react/jsx-runtime";
var SvgKy = (props) => /* @__PURE__ */ jsxs131(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx131("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx131(
        "path",
        {
          fill: "#6DA544",
          d: "M23.5 8.391a1.74 1.74 0 1 0 0-3.478 1.74 1.74 0 0 0 0 3.478Z"
        }
      ),
      /* @__PURE__ */ jsx131("path", { fill: "#D80027", d: "M26.544 6.218h-6.087v2.608h6.087V6.218Z" }),
      /* @__PURE__ */ jsx131(
        "path",
        {
          fill: "#FFDA44",
          d: "M20.457 12.739v1.74h.915c.549.537 1.3.869 2.128.869.83 0 1.58-.332 2.129-.87h.915v-1.74h-6.087Z"
        }
      ),
      /* @__PURE__ */ jsx131(
        "path",
        {
          fill: "#338AF3",
          d: "M20.457 8.391V11c0 2.33 3.043 3.043 3.043 3.043s3.044-.713 3.044-3.043V8.39h-6.087Z"
        }
      ),
      /* @__PURE__ */ jsx131(
        "path",
        {
          fill: "#F3F3F3",
          d: "M23.5 9.785c-.76 0-.76.695-1.521.695-.761 0-.761-.695-1.522-.695v1.217c.76 0 .76.696 1.522.696.76 0 .76-.696 1.521-.696.761 0 .761.696 1.522.696s.761-.696 1.522-.696V9.785c-.76 0-.76.695-1.522.695-.76 0-.76-.695-1.522-.695ZM23.5 7.348c-.76 0-.76.695-1.521.695-.761 0-.761-.695-1.522-.695v1.217c.76 0 .76.696 1.522.696.76 0 .76-.696 1.521-.696.761 0 .761.696 1.522.696s.761-.696 1.522-.696V7.348c-.76 0-.76.695-1.522.695-.76 0-.76-.695-1.522-.695Z"
        }
      ),
      /* @__PURE__ */ jsx131(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 1v1.325l-2.7 1.8H16v3.75h-2.7l2.7 1.8V11h-1.326l-4.299-2.866V11h-3.75V8.134L2.325 11H1V9.675l2.7-1.8H1v-3.75h2.7L1 2.325V1h1.326l4.299 2.866V1h3.75v2.866L14.675 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx131(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx131(
        "path",
        {
          fill: "#D80027",
          d: "M1 1v.884l3.362 2.241h1.325L1 1ZM16 1v.884l-3.362 2.241h-1.325L16 1Z"
        }
      ),
      /* @__PURE__ */ jsx131(
        "path",
        {
          fill: "#D80027",
          d: "M1 1v.884l3.362 2.241h1.325L1 1ZM16 1v.884l-3.362 2.241h-1.325L16 1ZM1 11v-.884l3.362-2.241h1.325L1 11ZM16 11v-.884l-3.362-2.241h-1.325L16 11Z"
        }
      ),
      /* @__PURE__ */ jsx131("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ky_default = SvgKy;

// build/Kz.tsx
import { jsx as jsx132, jsxs as jsxs132 } from "react/jsx-runtime";
var SvgKz = (props) => /* @__PURE__ */ jsxs132(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx132("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx132(
        "path",
        {
          fill: "#FFDA44",
          d: "M21.625 11.572h-11.25c0 .777.676 1.407 1.453 1.407h-.047c0 .776.63 1.406 1.407 1.406 0 .777.63 1.406 1.406 1.406h2.812c.777 0 1.407-.63 1.407-1.406.776 0 1.406-.63 1.406-1.406h-.047c.776 0 1.453-.63 1.453-1.407Z"
        }
      ),
      /* @__PURE__ */ jsx132("path", { fill: "#338AF3", d: "M19.894 9.733a3.894 3.894 0 0 1-7.788 0" }),
      /* @__PURE__ */ jsx132(
        "path",
        {
          fill: "#FFDA44",
          d: "m19.861 9.369-1.577.639.84 1.315-1.713-.283-.217 1.49L16 11.434l-1.193 1.096-.217-1.49-1.713.282.84-1.314-1.577-.639 1.577-.639-.84-1.314 1.713.282.217-1.49L16 7.304l1.193-1.096.217 1.49 1.713-.282-.84 1.314 1.577.639Z"
        }
      ),
      /* @__PURE__ */ jsx132("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Kz_default = SvgKz;

// build/La.tsx
import { jsx as jsx133, jsxs as jsxs133 } from "react/jsx-runtime";
var SvgLa = (props) => /* @__PURE__ */ jsxs133(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx133("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx133("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx133(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 13.783a2.783 2.783 0 1 0 0-5.566 2.783 2.783 0 0 0 0 5.566Z"
        }
      ),
      /* @__PURE__ */ jsx133("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var La_default = SvgLa;

// build/Lb.tsx
import { jsx as jsx134, jsxs as jsxs134 } from "react/jsx-runtime";
var SvgLb = (props) => /* @__PURE__ */ jsxs134(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx134("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx134("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx134(
        "path",
        {
          fill: "#6DA544",
          d: "M18.008 12.34 16 8.655 13.99 12.34h1.507v1.005H16.5v-1.005h1.507Z"
        }
      ),
      /* @__PURE__ */ jsx134("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Lb_default = SvgLb;

// build/Lc.tsx
import { jsx as jsx135, jsxs as jsxs135 } from "react/jsx-runtime";
var SvgLc = (props) => /* @__PURE__ */ jsxs135(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx135("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx135("path", { fill: "#F3F3F3", d: "M12.305 14.478h7.391L16 5.782l-3.695 8.696Z" }),
      /* @__PURE__ */ jsx135("path", { fill: "#333", d: "m13.588 13.608 2.411-5.484 2.411 5.484h-4.822Z" }),
      /* @__PURE__ */ jsx135("path", { fill: "#FFDA44", d: "M12.305 14.478h7.391L16 11l-3.695 3.478Z" }),
      /* @__PURE__ */ jsx135("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Lc_default = SvgLc;

// build/Li.tsx
import { jsx as jsx136, jsxs as jsxs136 } from "react/jsx-runtime";
var SvgLi = (props) => /* @__PURE__ */ jsxs136(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx136("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx136("path", { fill: "#0052B4", d: "M31 1v9.767L1 11.01V1h30Z" }),
      /* @__PURE__ */ jsx136(
        "path",
        {
          fill: "#FFDA44",
          d: "M13.391 7.957a1.304 1.304 0 0 0-2.174-.972v-.768h.435v-.87h-.435v-.434h-.87v.435h-.434v.87h.435v.767a1.304 1.304 0 1 0-1.739 1.944v.767h4.348v-.767c.266-.24.434-.586.434-.972Z"
        }
      ),
      /* @__PURE__ */ jsx136("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Li_default = SvgLi;

// build/Lk.tsx
import { jsx as jsx137, jsxs as jsxs137 } from "react/jsx-runtime";
var SvgLk = (props) => /* @__PURE__ */ jsxs137(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx137(
        "path",
        {
          fill: "#FFDA44",
          d: "M1 1v20h30V1H1Zm28.696 18.695H14.043V2.305h15.653v17.39Z"
        }
      ),
      /* @__PURE__ */ jsx137("path", { fill: "#A2001D", d: "M29.696 2.305H14.044v17.39h15.652V2.306Z" }),
      /* @__PURE__ */ jsx137("path", { fill: "#D80027", d: "M14.044 2.305H2.304v17.39h11.74V2.306Z" }),
      /* @__PURE__ */ jsx137("path", { fill: "#FFDA44", d: "M14.044 1h-1.305v20h1.305V1Z" }),
      /* @__PURE__ */ jsx137("path", { fill: "#6DA544", d: "M7.522 2.305H2.305v17.39h5.217V2.306Z" }),
      /* @__PURE__ */ jsx137("path", { fill: "#FF9811", d: "M12.739 2.305H7.52v17.39h5.218V2.306Z" }),
      /* @__PURE__ */ jsx137(
        "path",
        {
          fill: "#FFDA44",
          d: "M22.016 10.674V8.065c0-.435-.652-.87-.652-.87s-.652.435-.652.87h-2.609v2.61h1.305v1.303c0 .286.057.56.162.807l-.597.498h-1.739V5.239c-.72 0-1.304.584-1.304 1.304v5.653c0 .386.167.733.434.971v2.072h.87v-1.087h3.913v1.74h-.87v.869h1.74v-1.74l.796-.869h2.595v1.74h-.87v.869h1.74v-1.74l.797-.869.735-2.359-.647-1.119h-2.282c-.83-.007-2.38.005-2.865 0Z"
        }
      ),
      /* @__PURE__ */ jsx137(
        "path",
        {
          fill: "#FFDA44",
          d: "M22.712 8.413V9.89h4.19v.783h.261V9.63h-4.19v-.956h4.45v-.261h-4.711ZM15.348 2.305h-1.304v1.304h1.304V2.305ZM29.696 2.305h-1.304v1.304h1.304V2.305ZM15.348 18.39h-1.304v1.305h1.304v-1.304ZM29.696 18.39h-1.304v1.305h1.304v-1.304Z"
        }
      ),
      /* @__PURE__ */ jsx137("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Lk_default = SvgLk;

// build/Lr.tsx
import { jsx as jsx138, jsxs as jsxs138 } from "react/jsx-runtime";
var SvgLr = (props) => /* @__PURE__ */ jsxs138(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx138("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx138(
        "path",
        {
          fill: "#D80027",
          d: "M31 1H1v1.818h30V1ZM31 4.636H1v1.819h30V4.636ZM31 8.273H1v1.818h30V8.273ZM31 11.91H1v1.817h30V11.91ZM31 15.545H1v1.819h30v-1.819ZM31 19.182H1V21h30v-1.818Z"
        }
      ),
      /* @__PURE__ */ jsx138("path", { fill: "#0052B4", d: "M16 1H1v9.812h15V1Z" }),
      /* @__PURE__ */ jsx138(
        "path",
        {
          fill: "#FCFCFC",
          d: "m8.5 3.297.648 1.993h2.096L9.548 6.52l.648 1.993L8.5 7.283 6.805 8.514l.648-1.993L5.758 5.29h2.095l.648-1.993Z"
        }
      ),
      /* @__PURE__ */ jsx138("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Lr_default = SvgLr;

// build/Ls.tsx
import { jsx as jsx139, jsxs as jsxs139 } from "react/jsx-runtime";
var SvgLs = (props) => /* @__PURE__ */ jsxs139(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx139("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx139("path", { fill: "#0052B4", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx139("path", { fill: "#6DA544", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx139(
        "path",
        {
          fill: "#000",
          d: "M16.651 10.783V8.39h-1.304v2.392l-1.575 1.575a2.607 2.607 0 0 0 4.455 0l-1.576-1.575Z"
        }
      ),
      /* @__PURE__ */ jsx139("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ls_default = SvgLs;

// build/Lt.tsx
import { jsx as jsx140, jsxs as jsxs140 } from "react/jsx-runtime";
var SvgLt = (props) => /* @__PURE__ */ jsxs140(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx140("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx140("path", { fill: "#FFDA44", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx140("path", { fill: "#D80027", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx140("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Lt_default = SvgLt;

// build/Lu.tsx
import { jsx as jsx141, jsxs as jsxs141 } from "react/jsx-runtime";
var SvgLu = (props) => /* @__PURE__ */ jsxs141(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx141("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx141("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx141("path", { fill: "#338AF3", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx141("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Lu_default = SvgLu;

// build/Lv.tsx
import { jsx as jsx142, jsxs as jsxs142 } from "react/jsx-runtime";
var SvgLv = (props) => /* @__PURE__ */ jsxs142(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx142("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx142("path", { fill: "#A2001D", d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx142("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Lv_default = SvgLv;

// build/Ly.tsx
import { jsx as jsx143, jsxs as jsxs143 } from "react/jsx-runtime";
var SvgLy = (props) => /* @__PURE__ */ jsxs143(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx143("path", { fill: "#000", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx143("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx143("path", { fill: "#496E2D", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx143(
        "path",
        {
          fill: "#FCFCFC",
          d: "m17.49 9.83.525.723.85-.276-.526.724.525.723-.85-.277-.526.723v-.894l-.85-.277.851-.275V9.83Z"
        }
      ),
      /* @__PURE__ */ jsx143(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16.056 12.809a1.809 1.809 0 1 1 .86-3.4 2.226 2.226 0 1 0 0 3.183 1.8 1.8 0 0 1-.86.217Z"
        }
      ),
      /* @__PURE__ */ jsx143("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ly_default = SvgLy;

// build/Ma.tsx
import { jsx as jsx144, jsxs as jsxs144 } from "react/jsx-runtime";
var SvgMa = (props) => /* @__PURE__ */ jsxs144(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx144("path", { fill: "#D80027", d: "M1 1v20h30V1H1Z" }),
      /* @__PURE__ */ jsx144(
        "path",
        {
          fill: "#6DA544",
          d: "M21.625 9.272H17.33L16 5.182l-1.33 4.084h-4.295l3.475 2.525-1.33 4.083 3.474-2.525 3.475 2.525-1.33-4.083 3.486-2.52Zm-6.803 2.208.451-1.382h1.454l.45 1.382-1.177.856-1.178-.856Zm1.635-2.208h-.914L16 7.866l.457 1.406Zm1.424 1.699-.281-.873h1.482l-1.201.873Zm-3.48-.873-.282.873-1.195-.873H14.4Zm-.305 3.62.457-1.406.738.54-1.195.866Zm2.607-.873.738-.539.457 1.406-1.195-.867Z"
        }
      ),
      /* @__PURE__ */ jsx144("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ma_default = SvgMa;

// build/Mc.tsx
import { jsx as jsx145, jsxs as jsxs145 } from "react/jsx-runtime";
var SvgMc = (props) => /* @__PURE__ */ jsxs145(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx145("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx145("path", { fill: "#D80027", d: "M31 1v9.767L1 11.01V1h30Z" }),
      /* @__PURE__ */ jsx145("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mc_default = SvgMc;

// build/Md.tsx
import { jsx as jsx146, jsxs as jsxs146 } from "react/jsx-runtime";
var SvgMd = (props) => /* @__PURE__ */ jsxs146(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx146("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx146("path", { fill: "#D80027", d: "M31 1H20.348v20H31V1Z" }),
      /* @__PURE__ */ jsx146("path", { fill: "#0052B4", d: "M11.652 1H1v20h10.652V1Z" }),
      /* @__PURE__ */ jsx146(
        "path",
        {
          fill: "#FF9811",
          d: "M19.478 8.868h-2.391a1.087 1.087 0 0 0-2.174 0H12.52c0 .59.515 1.07 1.106 1.07h-.035c0 .59.479 1.07 1.07 1.07 0 .523.376.958.872 1.051l-.843 1.904a3.466 3.466 0 0 0 2.618 0l-.844-1.904a1.07 1.07 0 0 0 .872-1.05c.592 0 1.07-.48 1.07-1.071h-.035c.591 0 1.106-.48 1.106-1.07Z"
        }
      ),
      /* @__PURE__ */ jsx146(
        "path",
        {
          fill: "#0052B4",
          d: "M16 10.348 14.589 11v1.304l1.413.87 1.413-.87V11l-1.413-.652Z"
        }
      ),
      /* @__PURE__ */ jsx146("path", { fill: "#D80027", d: "M17.412 9.695h-2.826V11h2.826V9.695Z" }),
      /* @__PURE__ */ jsx146("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Md_default = SvgMd;

// build/Me.tsx
import { jsx as jsx147, jsxs as jsxs147 } from "react/jsx-runtime";
var SvgMe = (props) => /* @__PURE__ */ jsxs147(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx147("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx147("path", { fill: "#A2001D", d: "M31 2.739H1V19.26h30V2.74Z" }),
      /* @__PURE__ */ jsx147(
        "path",
        {
          fill: "#FFDA44",
          d: "M13.826 8.391h4.348V6.652l-.87.435L16 5.783l-1.304 1.304-.87-.435v1.74ZM19.913 11H17.74a1.003 1.003 0 1 0-1.753-.974 1.003 1.003 0 1 0-1.753.974h-2.147c0 .665.58 1.204 1.244 1.204h-.04c0 .546.363 1.006.86 1.154l-.977.977.922.923 1.308-1.309a.987.987 0 0 0 .16.044l-.791 1.785a3.25 3.25 0 0 0 2.454 0l-.79-1.785c.054-.01.107-.025.158-.044l1.309 1.309.922-.923-.977-.977c.497-.148.86-.609.86-1.154h-.04c.665 0 1.244-.539 1.244-1.204Z"
        }
      ),
      /* @__PURE__ */ jsx147(
        "path",
        {
          fill: "#6DA544",
          d: "m16 11.652-1.413.652v1.305l1.413.87 1.413-.87v-1.305L16 11.652Z"
        }
      ),
      /* @__PURE__ */ jsx147("path", { fill: "#0052B4", d: "M17.413 11h-2.826v1.74h2.826V11Z" }),
      /* @__PURE__ */ jsx147("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Me_default = SvgMe;

// build/Mf.tsx
import { jsx as jsx148, jsxs as jsxs148 } from "react/jsx-runtime";
var SvgMf = (props) => /* @__PURE__ */ jsxs148(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx148("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx148("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx148("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx148("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mf_default = SvgMf;

// build/Mg.tsx
import { jsx as jsx149, jsxs as jsxs149 } from "react/jsx-runtime";
var SvgMg = (props) => /* @__PURE__ */ jsxs149(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx149("path", { fill: "#6DA544", d: "M31 21V1H1v20h30Z" }),
      /* @__PURE__ */ jsx149("path", { fill: "#D80027", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx149("path", { fill: "#FCFCFC", d: "M11.652 1H1v20h10.652V1Z" }),
      /* @__PURE__ */ jsx149("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mg_default = SvgMg;

// build/Mh.tsx
import { jsx as jsx150, jsxs as jsxs150 } from "react/jsx-runtime";
var SvgMh = (props) => /* @__PURE__ */ jsxs150(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx150("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx150(
        "path",
        {
          fill: "#FCFCFC",
          d: "m14.702 6.846-1.221.575.65 1.183-1.326-.254-.168 1.34-.924-.986-.923.986-.168-1.34-1.327.254.65-1.183-1.22-.575 1.22-.574-.65-1.183 1.327.254.168-1.34.924.985.923-.985.168 1.34 1.327-.254-.65 1.183 1.22.574ZM26.015 1 1 20.699v.22L30.517 1h-4.502Z"
        }
      ),
      /* @__PURE__ */ jsx150("path", { fill: "#FF9811", d: "M31 1h-.483L1 20.92V21h.218L31 4.027V1Z" }),
      /* @__PURE__ */ jsx150("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mh_default = SvgMh;

// build/Mk.tsx
import { jsx as jsx151, jsxs as jsxs151 } from "react/jsx-runtime";
var SvgMk = (props) => /* @__PURE__ */ jsxs151(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx151("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx151(
        "path",
        {
          fill: "#D80027",
          d: "M23.493 21 16 10.782 17.572 21h5.92ZM8.826 1 16 10.782 14.495 1H8.826ZM14.428 21 16 10.782 8.508 21h5.92ZM1 1v7.475l15 2.307L2.66 1H1ZM1 21h1.067L16 10.782 1 13.09V21ZM16 10.782l15-2.307V1h-1.66L16 10.782ZM17.505 1 16 10.782 23.174 1h-5.669ZM31 21v-7.91l-15-2.308L29.933 21H31Z"
        }
      ),
      /* @__PURE__ */ jsx151(
        "path",
        {
          fill: "#D80027",
          d: "M16 14.26a3.478 3.478 0 1 0 0-6.955 3.478 3.478 0 0 0 0 6.956Z"
        }
      ),
      /* @__PURE__ */ jsx151(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 13.391a2.609 2.609 0 1 0 0-5.217 2.609 2.609 0 0 0 0 5.217Z"
        }
      ),
      /* @__PURE__ */ jsx151("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mk_default = SvgMk;

// build/Ml.tsx
import { jsx as jsx152, jsxs as jsxs152 } from "react/jsx-runtime";
var SvgMl = (props) => /* @__PURE__ */ jsxs152(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx152("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx152("path", { fill: "#6DA544", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx152("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx152("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ml_default = SvgMl;

// build/Mm.tsx
import { jsx as jsx153, jsxs as jsxs153 } from "react/jsx-runtime";
var SvgMm = (props) => /* @__PURE__ */ jsxs153(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx153("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx153("path", { fill: "#FFDA44", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx153("path", { fill: "#D80027", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx153(
        "path",
        {
          fill: "#FCFCFC",
          d: "M23.5 9.316h-5.73L16 3.866l-1.77 5.45H8.5l4.635 3.368-1.77 5.45L16 14.803l4.635 3.33-1.77-5.45L23.5 9.316Z"
        }
      ),
      /* @__PURE__ */ jsx153("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mm_default = SvgMm;

// build/Mn.tsx
import { jsx as jsx154, jsxs as jsxs154 } from "react/jsx-runtime";
var SvgMn = (props) => /* @__PURE__ */ jsxs154(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx154("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx154("path", { fill: "#A2001D", d: "M31 1H20.348v20H31V1ZM11.652 1H1v20h10.652V1Z" }),
      /* @__PURE__ */ jsx154(
        "path",
        {
          fill: "#FFDA44",
          d: "M8.5 11.652h-.87v3.478h.87v-3.478ZM5.022 11.652h-.87v3.478h.87v-3.478ZM6.327 13.826a.87.87 0 1 0 0-1.74.87.87 0 0 0 0 1.74ZM6.326 10.347a.435.435 0 1 0 0-.87.435.435 0 0 0 0 .87ZM7.195 14.26H5.456v.87h1.74v-.87ZM7.195 10.783H5.456v.87h1.74v-.87ZM6.326 6.87l.308.947h.996l-.806.586.308.947-.806-.585-.806.585.308-.947-.807-.586h.997l.308-.948Z"
        }
      ),
      /* @__PURE__ */ jsx154("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mn_default = SvgMn;

// build/Mo.tsx
import { jsx as jsx155, jsxs as jsxs155 } from "react/jsx-runtime";
var SvgMo = (props) => /* @__PURE__ */ jsxs155(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx155("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx155(
        "path",
        {
          fill: "#FCFCFC",
          d: "M17.74 10.583a2.05 2.05 0 0 0-.696.127 2.13 2.13 0 0 0 .198-.873C17.242 8.595 16 7.663 16 7.663s-1.242.932-1.242 2.174c0 .314.08.608.198.873a2.05 2.05 0 0 0-.695-.127c-1.242 0-2.174 1.242-2.174 1.242s.932 1.242 2.174 1.242c.728 0 1.35-.427 1.739-.78.39.353 1.01.78 1.74.78 1.241 0 2.173-1.242 2.173-1.242s-.931-1.242-2.174-1.242Z"
        }
      ),
      /* @__PURE__ */ jsx155(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 4.913.257.79h.83l-.672.488.257.79L16 6.491l-.672.488.257-.79-.672-.488h.83l.257-.79ZM12.842 6.294l.494.444.575-.332-.27.607.494.445-.66-.07-.27.607-.14-.65-.66-.07.575-.331-.138-.65ZM10.531 8.605l.65.139.332-.576.07.66.65.14-.607.27.069.66-.444-.494-.607.27.332-.575-.445-.494ZM19.158 6.294l-.494.444-.575-.332.27.607-.494.445.66-.07.271.607.138-.65.66-.07-.574-.331.138-.65ZM21.469 8.605l-.65.139-.332-.576-.07.66-.65.14.607.27-.069.66.445-.494.606.27-.332-.575.445-.494Z"
        }
      ),
      /* @__PURE__ */ jsx155(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 16.545c.987 0 1.896-.329 2.626-.883h-5.252c.73.554 1.64.883 2.626.883ZM12.015 13.937c.138.316.313.611.518.883h6.935c.205-.271.38-.567.518-.883h-7.971Z"
        }
      ),
      /* @__PURE__ */ jsx155("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mo_default = SvgMo;

// build/Mp.tsx
import { jsx as jsx156, jsxs as jsxs156 } from "react/jsx-runtime";
var SvgMp = (props) => /* @__PURE__ */ jsxs156(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx156("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx156(
        "path",
        {
          fill: "#F3F3F3",
          d: "M15.734 16.394a.553.553 0 0 1-.492-.361.554.554 0 0 1-.988-.255.554.554 0 0 1-.915-.45.553.553 0 0 1-.807-.623.552.552 0 0 1-.665-.772.554.554 0 0 1-.496-.891.553.553 0 0 1-.306-.973.553.553 0 0 1-.104-1.014.554.554 0 0 1 .101-1.014.554.554 0 0 1 .305-.974.554.554 0 0 1 .494-.891.554.554 0 0 1 .663-.775.553.553 0 0 1 .805-.625.554.554 0 0 1 .915-.45.554.554 0 0 1 .986-.258.554.554 0 0 1 1.018-.053.554.554 0 0 1 1.008.152.554.554 0 0 1 .957.353.553.553 0 0 1 .866.538.554.554 0 0 1 .74.701.554.554 0 0 1 .585.835.554.554 0 0 1 .404.937.553.553 0 0 1 .207.998c.198.084.338.28.338.509v.012a.554.554 0 0 1-.337.51.553.553 0 0 1-.204.998.554.554 0 0 1-.403.937.554.554 0 0 1-.582.837.554.554 0 0 1-.739.702.554.554 0 0 1-.865.54.554.554 0 0 1-.956.355.554.554 0 0 1-1.008.154.553.553 0 0 1-.525.311Z"
        }
      ),
      /* @__PURE__ */ jsx156(
        "path",
        {
          fill: "#338AF3",
          d: "M16.002 14.74a3.69 3.69 0 1 0 0-7.381 3.69 3.69 0 0 0 0 7.38Z"
        }
      ),
      /* @__PURE__ */ jsx156(
        "path",
        {
          fill: "#BDBCC1",
          d: "M16.81 9.797c.182-.135.3-.35.3-.593v-.369a.738.738 0 0 0-.738-.738h-.738a.738.738 0 0 0-.739.738v.37c0 .242.119.457.3.592l-.669 6.788s.37.37 1.477.37c1.107 0 1.476-.37 1.476-.37l-.669-6.788Z"
        }
      ),
      /* @__PURE__ */ jsx156(
        "path",
        {
          fill: "#FCFCFC",
          d: "m16.002 8.097.64 1.974h2.076l-1.679 1.22.641 1.973-1.678-1.22-1.68 1.22.642-1.974-1.679-1.22h2.075l.642-1.973Z"
        }
      ),
      /* @__PURE__ */ jsx156("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mp_default = SvgMp;

// build/Mq.tsx
import { jsx as jsx157, jsxs as jsxs157 } from "react/jsx-runtime";
var SvgMq = (props) => /* @__PURE__ */ jsxs157(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx157("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx157(
        "path",
        {
          fill: "#FCFCFC",
          d: "M31 9.695v2.609H17.304v8.695h-2.608v-8.695H1V9.695h13.696V1h2.608v8.695H31Z"
        }
      ),
      /* @__PURE__ */ jsx157(
        "path",
        {
          fill: "#FCFCFC",
          d: "M23.652 6.306c0-.133.108-.241.24-.241h.518c.816 0 1.48-.664 1.48-1.481 0-.817-.664-1.48-1.48-1.48h-.491a1.021 1.021 0 0 0-.612-.195c-.494 0-.895.32-.895.716 0 .391.393.709.88.715v.003h1.117a.241.241 0 0 1 0 .482h-.516c-.817 0-1.48.664-1.48 1.48 0 .817.663 1.482 1.48 1.482h1.997v-1.24h-1.997a.241.241 0 0 1-.241-.241ZM7.35 6.306c0-.133.107-.241.24-.241h.517c.816 0 1.48-.664 1.48-1.481 0-.817-.664-1.48-1.48-1.48h-.49a1.02 1.02 0 0 0-.613-.195c-.494 0-.895.32-.895.716 0 .391.393.709.881.715v.003h1.117a.241.241 0 0 1 0 .482H7.59c-.816 0-1.48.664-1.48 1.48 0 .817.664 1.482 1.48 1.482h1.998v-1.24H7.59a.241.241 0 0 1-.24-.241ZM23.652 17.61c0-.133.108-.241.24-.241h.518c.816 0 1.48-.665 1.48-1.481 0-.816-.664-1.48-1.48-1.48h-.491a1.021 1.021 0 0 0-.612-.195c-.494 0-.895.32-.895.716 0 .391.393.709.88.715v.003h1.117a.241.241 0 0 1 0 .482h-.516c-.817 0-1.48.664-1.48 1.48 0 .817.663 1.482 1.48 1.482h1.997v-1.24h-1.997a.241.241 0 0 1-.241-.241ZM7.35 17.61c0-.133.107-.241.24-.241h.517c.816 0 1.48-.665 1.48-1.481 0-.816-.664-1.48-1.48-1.48h-.49a1.021 1.021 0 0 0-.613-.195c-.494 0-.895.32-.895.716 0 .391.393.709.881.715v.003h1.117a.241.241 0 0 1 0 .482H7.59c-.816 0-1.48.664-1.48 1.48 0 .817.664 1.482 1.48 1.482h1.998v-1.24H7.59a.241.241 0 0 1-.24-.241Z"
        }
      ),
      /* @__PURE__ */ jsx157("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mq_default = SvgMq;

// build/Mr.tsx
import { jsx as jsx158, jsxs as jsxs158 } from "react/jsx-runtime";
var SvgMr = (props) => /* @__PURE__ */ jsxs158(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx158("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx158(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 13.51a5.626 5.626 0 0 1-5.494-4.419 5.625 5.625 0 1 0 10.988 0A5.626 5.626 0 0 1 16 13.511Z"
        }
      ),
      /* @__PURE__ */ jsx158(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 6.078.523 1.611h1.694l-1.37.996.523 1.612L16 9.3l-1.372.996.524-1.612-1.37-.996h1.694l.523-1.611Z"
        }
      ),
      /* @__PURE__ */ jsx158("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mr_default = SvgMr;

// build/Ms.tsx
import { jsx as jsx159, jsxs as jsxs159 } from "react/jsx-runtime";
var SvgMs = (props) => /* @__PURE__ */ jsxs159(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx159("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx159(
        "path",
        {
          fill: "#338AF3",
          d: "M20.584 7.25v4.583c0 2.233 2.917 2.917 2.917 2.917s2.916-.684 2.916-2.917V7.25h-5.833Z"
        }
      ),
      /* @__PURE__ */ jsx159(
        "path",
        {
          fill: "#A2001D",
          d: "M20.584 11.833c0 2.233 2.917 2.917 2.917 2.917s2.916-.684 2.916-2.917h-5.833Z"
        }
      ),
      /* @__PURE__ */ jsx159(
        "path",
        {
          fill: "#000",
          d: "M24.75 9.333h-.833V8.5h-.834v.833h-.833v.833h.833v2.5h.834v-2.5h.833v-.833Z"
        }
      ),
      /* @__PURE__ */ jsx159(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 1v1.79l-2.646 1.471H16v3.478h-3.463L16 9.663V11h-1.563L10.13 8.608V11H6.87V8.154L1.747 11H1V9.21l2.647-1.471H1V4.261h3.463L1 2.336V1h1.563L6.87 3.392V1h3.26v2.846L15.253 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx159(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx159("path", { fill: "#0052B4", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx159("path", { fill: "#FCFCFC", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx159(
        "path",
        {
          fill: "#D80027",
          d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66ZM5.21 7.739 1 10.078V11l5.87-3.261H5.21Z"
        }
      ),
      /* @__PURE__ */ jsx159("path", { fill: "#0052B4", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx159("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx159(
        "path",
        {
          fill: "#D80027",
          d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66ZM11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z"
        }
      ),
      /* @__PURE__ */ jsx159("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ms_default = SvgMs;

// build/Mt.tsx
import { jsx as jsx160, jsxs as jsxs160 } from "react/jsx-runtime";
var SvgMt = (props) => /* @__PURE__ */ jsxs160(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx160("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx160("path", { fill: "#D80027", d: "M31 1H16v20h15V1Z" }),
      /* @__PURE__ */ jsx160(
        "path",
        {
          fill: "#ACABB1",
          d: "M13.201 4.125v-1.25h-1.25v1.25h-1.25v1.25h1.25v1.25h1.25v-1.25h1.25v-1.25h-1.25Z"
        }
      ),
      /* @__PURE__ */ jsx160("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mt_default = SvgMt;

// build/Mu.tsx
import { jsx as jsx161, jsxs as jsxs161 } from "react/jsx-runtime";
var SvgMu = (props) => /* @__PURE__ */ jsxs161(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx161("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx161("path", { fill: "#D80027", d: "M31 1H1v5h30V1Z" }),
      /* @__PURE__ */ jsx161("path", { fill: "#0052B4", d: "M31 6H1v5h30V6Z" }),
      /* @__PURE__ */ jsx161("path", { fill: "#6DA544", d: "M31 16H1v5h30v-5Z" }),
      /* @__PURE__ */ jsx161("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mu_default = SvgMu;

// build/Mv.tsx
import { jsx as jsx162, jsxs as jsxs162 } from "react/jsx-runtime";
var SvgMv = (props) => /* @__PURE__ */ jsxs162(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx162("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx162("path", { fill: "#6DA544", d: "M22.522 6.217H9.479v9.566h13.043V6.217Z" }),
      /* @__PURE__ */ jsx162(
        "path",
        {
          fill: "#FCFCFC",
          d: "M17.61 13.826a2.826 2.826 0 1 1 1.345-5.313 3.478 3.478 0 1 0 0 4.973c-.4.217-.858.34-1.345.34Z"
        }
      ),
      /* @__PURE__ */ jsx162("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mv_default = SvgMv;

// build/Mw.tsx
import { jsx as jsx163, jsxs as jsxs163 } from "react/jsx-runtime";
var SvgMw = (props) => /* @__PURE__ */ jsxs163(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx163("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx163("path", { fill: "#000", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx163("path", { fill: "#496E2D", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx163(
        "path",
        {
          fill: "#D80027",
          d: "m18.99 5.783-1.222-.575.65-1.183-1.326.254-.168-1.34-.923.986-.924-.986-.168 1.34-1.326-.254.65 1.183-1.221.575h5.977Z"
        }
      ),
      /* @__PURE__ */ jsx163("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mw_default = SvgMw;

// build/Mx.tsx
import { jsx as jsx164, jsxs as jsxs164 } from "react/jsx-runtime";
var SvgMx = (props) => /* @__PURE__ */ jsxs164(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx164("path", { fill: "#D80027", d: "M21 1H1v20h30V1H21Z" }),
      /* @__PURE__ */ jsx164("path", { fill: "#6DA544", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx164("path", { fill: "#FCFCFC", d: "M21 1H11v20h10V1Z" }),
      /* @__PURE__ */ jsx164(
        "path",
        {
          fill: "#6DA544",
          d: "M13.188 11a2.812 2.812 0 0 0 5.624 0v-.938h-5.625V11Z"
        }
      ),
      /* @__PURE__ */ jsx164(
        "path",
        {
          fill: "#FF9811",
          d: "M19.75 9.125h-2.813a.938.938 0 0 0-1.875 0H12.25c0 .518.451.937.969.937h-.031c0 .518.42.938.937.938 0 .518.42.937.938.937h1.874c.518 0 .938-.42.938-.937.518 0 .938-.42.938-.938h-.032c.518 0 .969-.42.969-.937Z"
        }
      ),
      /* @__PURE__ */ jsx164("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mx_default = SvgMx;

// build/My.tsx
import { jsx as jsx165, jsxs as jsxs165 } from "react/jsx-runtime";
var SvgMy = (props) => /* @__PURE__ */ jsxs165(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx165("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx165(
        "path",
        {
          fill: "#D80027",
          d: "M31 3.5H1V6h30V3.5ZM31 8.5H1V11h30V8.5ZM31 13.5H1V16h30v-2.5ZM31 18.5H1V21h30v-2.5Z"
        }
      ),
      /* @__PURE__ */ jsx165("path", { fill: "#0052B4", d: "M16 1H1v10.77h15V1Z" }),
      /* @__PURE__ */ jsx165(
        "path",
        {
          fill: "#FFDA44",
          d: "M9.256 8.857a2.473 2.473 0 1 1 1.176-4.648 3.043 3.043 0 1 0 0 4.351c-.35.19-.75.297-1.176.297Z"
        }
      ),
      /* @__PURE__ */ jsx165(
        "path",
        {
          fill: "#FFDA44",
          d: "m9.954 4.645.439.918.991-.229-.444.916.798.632-.993.224.003 1.018-.794-.637-.794.636.003-1.017-.993-.224.797-.632-.444-.916.992.23.439-.919Z"
        }
      ),
      /* @__PURE__ */ jsx165("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var My_default = SvgMy;

// build/Mz.tsx
import { jsx as jsx166, jsxs as jsxs166 } from "react/jsx-runtime";
var SvgMz = (props) => /* @__PURE__ */ jsxs166(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx166("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx166("path", { fill: "#FFDA44", d: "M31 14.913H1V21h30v-6.087Z" }),
      /* @__PURE__ */ jsx166("path", { fill: "#496E2D", d: "M31 1H1v6.124h30V1Z" }),
      /* @__PURE__ */ jsx166("path", { fill: "#000", d: "M31 8.356H1v5.253h30V8.356Z" }),
      /* @__PURE__ */ jsx166("path", { fill: "#A2001D", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx166(
        "path",
        {
          fill: "#FFDA44",
          d: "m5.89 7.434.886 2.724H9.64l-2.318 1.684.885 2.724-2.317-1.683-2.318 1.684.885-2.725-2.317-1.684h2.864l.886-2.724Z"
        }
      ),
      /* @__PURE__ */ jsx166("path", { fill: "#FCFCFC", d: "M8.482 11H3.3v2.378h5.18V11Z" }),
      /* @__PURE__ */ jsx166(
        "path",
        {
          fill: "#000",
          d: "m9.463 8.274-.841-.84-2.732 2.731L3.16 7.434l-.84.84 2.733 2.73-2.734 2.733.841.83L5.89 11.84l2.732 2.726.84-.829-2.733-2.734 2.734-2.729Z"
        }
      ),
      /* @__PURE__ */ jsx166("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Mz_default = SvgMz;

// build/Na.tsx
import { jsx as jsx167, jsxs as jsxs167 } from "react/jsx-runtime";
var SvgNa = (props) => /* @__PURE__ */ jsxs167(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx167("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx167("path", { fill: "#0052B4", d: "M1 21V1h30" }),
      /* @__PURE__ */ jsx167("path", { fill: "#FCFCFC", d: "M31 4.92V1h-5.879L1 17.08V21h5.879L31 4.92Z" }),
      /* @__PURE__ */ jsx167("path", { fill: "#A2001D", d: "M31 1v2.351L4.527 21H1v-2.351L27.473 1H31Z" }),
      /* @__PURE__ */ jsx167(
        "path",
        {
          fill: "#FFDA44",
          d: "m12 7.087-1.332.626.71 1.29-1.448-.276-.183 1.462L8.74 9.114l-1.007 1.075-.184-1.462-1.447.277.71-1.29-1.332-.627L6.81 6.46 6.1 5.17l1.447.276.184-1.462L8.739 5.06l1.008-1.076.183 1.462 1.447-.277-.71 1.29L12 7.088Z"
        }
      ),
      /* @__PURE__ */ jsx167("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Na_default = SvgNa;

// build/Nc.tsx
import { jsx as jsx168, jsxs as jsxs168 } from "react/jsx-runtime";
var SvgNc = (props) => /* @__PURE__ */ jsxs168(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx168("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx168("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx168("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx168("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Nc_default = SvgNc;

// build/Ne.tsx
import { jsx as jsx169, jsxs as jsxs169 } from "react/jsx-runtime";
var SvgNe = (props) => /* @__PURE__ */ jsxs169(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx169("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx169("path", { fill: "#FF9811", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx169("path", { fill: "#6DA544", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx169(
        "path",
        {
          fill: "#FF9811",
          d: "M16 12.875a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
        }
      ),
      /* @__PURE__ */ jsx169("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ne_default = SvgNe;

// build/Nf.tsx
import { jsx as jsx170, jsxs as jsxs170 } from "react/jsx-runtime";
var SvgNf = (props) => /* @__PURE__ */ jsxs170(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx170("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx170(
        "path",
        {
          fill: "#6DA544",
          d: "M11 1H1v20h10V1ZM31 1H21v20h10V1ZM18.813 14.281 16 5.375l-2.813 8.906h2.11v2.344h1.406V14.28h2.11Z"
        }
      ),
      /* @__PURE__ */ jsx170("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Nf_default = SvgNf;

// build/Ng.tsx
import { jsx as jsx171, jsxs as jsxs171 } from "react/jsx-runtime";
var SvgNg = (props) => /* @__PURE__ */ jsxs171(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx171("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx171("path", { fill: "#6DA544", d: "M11 1H1v20h10V1ZM31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx171("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ng_default = SvgNg;

// build/Ni.tsx
import { jsx as jsx172, jsxs as jsxs172 } from "react/jsx-runtime";
var SvgNi = (props) => /* @__PURE__ */ jsxs172(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx172("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx172("path", { fill: "#338AF3", d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx172(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 8.565a2.435 2.435 0 1 0 0 4.87 2.435 2.435 0 0 0 0-4.87Zm0 3.826a1.391 1.391 0 1 1 0-2.782 1.391 1.391 0 0 1 0 2.782Z"
        }
      ),
      /* @__PURE__ */ jsx172(
        "path",
        {
          fill: "#0052B4",
          d: "M17.204 11.348 15.999 11l-1.205.348-.401.695h3.213l-.402-.695Z"
        }
      ),
      /* @__PURE__ */ jsx172("path", { fill: "#338AF3", d: "m16 9.26-.803 1.392L16 11l.804-.348L16 9.261Z" }),
      /* @__PURE__ */ jsx172("path", { fill: "#6DA544", d: "M14.795 11.348h2.41l-.402-.696h-1.607l-.401.696Z" }),
      /* @__PURE__ */ jsx172("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ni_default = SvgNi;

// build/Nl.tsx
import { jsx as jsx173, jsxs as jsxs173 } from "react/jsx-runtime";
var SvgNl = (props) => /* @__PURE__ */ jsxs173(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx173("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx173("path", { fill: "#A2001D", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx173("path", { fill: "#0052B4", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx173("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Nl_default = SvgNl;

// build/No.tsx
import { jsx as jsx174, jsxs as jsxs174 } from "react/jsx-runtime";
var SvgNo = (props) => /* @__PURE__ */ jsxs174(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx174("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx174(
        "path",
        {
          fill: "#FCFCFC",
          d: "M31 13.337H12.847V21H8.174v-7.663H1V8.663h7.174V1h4.673v7.663H31V13.337Z"
        }
      ),
      /* @__PURE__ */ jsx174(
        "path",
        {
          fill: "#2E52B2",
          d: "M31 9.75v2.5H11.76V21h-2.5v-8.75H1v-2.5h8.26V1h2.5v8.75H31Z"
        }
      ),
      /* @__PURE__ */ jsx174("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var No_default = SvgNo;

// build/Np.tsx
import { jsx as jsx175, jsxs as jsxs175 } from "react/jsx-runtime";
var SvgNp = (props) => /* @__PURE__ */ jsxs175(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx175("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx175("path", { fill: "#0052B4", d: "M1 21V1l16.43 10.24H6.134L16.89 21H1Z" }),
      /* @__PURE__ */ jsx175(
        "path",
        {
          fill: "#D80027",
          d: "M15.342 10.642 2 2.077V20h12.5l-9.914-9.358h10.756Z"
        }
      ),
      /* @__PURE__ */ jsx175(
        "path",
        {
          fill: "#FCFCFC",
          d: "m6.743 15.01-.855-.402.455-.828-.928.177-.118-.938-.646.69-.647-.69-.117.938-.929-.177.456.828-.855.402.855.402-.456.828.929-.178.117.938.647-.69.646.69.118-.938.928.178-.455-.828.855-.402ZM6.172 7.23l-.621-.292.33-.603-.674.13-.086-.682-.47.501-.47-.501-.086.682-.675-.13.33.603-.621.292 1.522.304 1.521-.304Z"
        }
      ),
      /* @__PURE__ */ jsx175("path", { fill: "#FCFCFC", d: "M6.476 7.23a1.826 1.826 0 1 1-3.652 0" }),
      /* @__PURE__ */ jsx175("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Np_default = SvgNp;

// build/Nr.tsx
import { jsx as jsx176, jsxs as jsxs176 } from "react/jsx-runtime";
var SvgNr = (props) => /* @__PURE__ */ jsxs176(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx176("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx176("path", { fill: "#FFDA44", d: "M31 10.062H1v1.875h30v-1.875Z" }),
      /* @__PURE__ */ jsx176(
        "path",
        {
          fill: "#FCFCFC",
          d: "m11.242 16-1.12.527.597 1.085-1.217-.233-.154 1.23-.848-.904-.847.904-.155-1.23-1.216.233.596-1.085L5.758 16l1.12-.527-.596-1.085 1.216.232.155-1.229.847.904.848-.904.154 1.23 1.217-.233-.597 1.085 1.12.527Z"
        }
      ),
      /* @__PURE__ */ jsx176("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Nr_default = SvgNr;

// build/Nu.tsx
import { jsx as jsx177, jsxs as jsxs177 } from "react/jsx-runtime";
var SvgNu = (props) => /* @__PURE__ */ jsxs177(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx177("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx177("path", { fill: "#FCFCFC", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx177(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx177("path", { fill: "#D80027", d: "M1 1v.884l3.362 2.241h1.325L1 1Z" }),
      /* @__PURE__ */ jsx177(
        "path",
        {
          fill: "#2E52B2",
          d: "M1 2.325v1.8h2.7L1 2.325ZM6.625 1v2.866L2.326 1h4.3Z"
        }
      ),
      /* @__PURE__ */ jsx177("path", { fill: "#D80027", d: "M16 1v.884l-3.362 2.241h-1.325L16 1Z" }),
      /* @__PURE__ */ jsx177(
        "path",
        {
          fill: "#2E52B2",
          d: "M16 2.325v1.8h-2.7l2.7-1.8ZM10.375 1v2.866L14.675 1h-4.3Z"
        }
      ),
      /* @__PURE__ */ jsx177("path", { fill: "#D80027", d: "M1 1v.884l3.362 2.241h1.325L1 1Z" }),
      /* @__PURE__ */ jsx177(
        "path",
        {
          fill: "#2E52B2",
          d: "M1 2.325v1.8h2.7L1 2.325ZM6.625 1v2.866L2.326 1h4.3Z"
        }
      ),
      /* @__PURE__ */ jsx177("path", { fill: "#D80027", d: "M16 1v.884l-3.362 2.241h-1.325L16 1Z" }),
      /* @__PURE__ */ jsx177(
        "path",
        {
          fill: "#2E52B2",
          d: "M16 2.325v1.8h-2.7l2.7-1.8ZM10.375 1v2.866L14.675 1h-4.3Z"
        }
      ),
      /* @__PURE__ */ jsx177("path", { fill: "#D80027", d: "M1 11v-.884l3.362-2.241h1.325L1 11Z" }),
      /* @__PURE__ */ jsx177(
        "path",
        {
          fill: "#2E52B2",
          d: "M1 9.674v-1.8h2.7L1 9.675ZM6.625 11V8.134L2.326 11h4.3Z"
        }
      ),
      /* @__PURE__ */ jsx177("path", { fill: "#D80027", d: "M16 11v-.884l-3.362-2.241h-1.325L16 11Z" }),
      /* @__PURE__ */ jsx177(
        "path",
        {
          fill: "#2E52B2",
          d: "M16 9.674v-1.8h-2.7l2.7 1.8ZM10.375 11V8.134l4.3 2.866h-4.3ZM8.5 7.325a1.326 1.326 0 1 0 0-2.651 1.326 1.326 0 0 0 0 2.651Z"
        }
      ),
      /* @__PURE__ */ jsx177(
        "path",
        {
          fill: "#FFDA44",
          d: "m8.5 5.062.232.717h.753l-.609.442.233.716-.61-.442-.609.442.233-.716-.61-.442h.754l.232-.717ZM8.499 8.88l.139.426h.448l-.363.263.139.427-.363-.264-.363.264.139-.427-.363-.263h.448l.139-.427ZM8.499 2.004l.139.427h.448l-.363.263.139.427-.363-.264-.363.264.139-.427-.363-.263h.448l.139-.427ZM12.597 5.442l.138.426h.449l-.363.264.139.426-.363-.263-.363.263.139-.426-.363-.264h.448l.139-.426ZM4.403 5.442l.139.426h.448l-.362.264.138.426-.363-.263-.362.263.138-.426-.363-.264h.449l.138-.426Z"
        }
      ),
      /* @__PURE__ */ jsx177("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Nu_default = SvgNu;

// build/Nz.tsx
import { jsx as jsx178, jsxs as jsxs178 } from "react/jsx-runtime";
var SvgNz = (props) => /* @__PURE__ */ jsxs178(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx178("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx178(
        "path",
        {
          fill: "#D80027",
          d: "m25.92 9.696.198.611h.642l-.52.378.199.61-.52-.377-.52.378.199-.611-.52-.378h.643l.198-.611ZM23.623 14.095l.297.916h.964l-.78.567.298.916-.78-.566-.779.566.298-.916-.78-.567h.964l.298-.916ZM23.71 6.897l.248.764h.803l-.65.472.248.763-.65-.472-.65.472.249-.763-.65-.472h.803l.248-.764ZM21.5 9.67l.297.916h.964l-.78.566.298.917-.78-.567-.779.567.298-.917-.78-.566h.964l.298-.917Z"
        }
      ),
      /* @__PURE__ */ jsx178(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 1v1.79l-2.647 1.47H16V7.74h-3.463L16 9.663V11h-1.564l-4.305-2.392V11H6.87V8.153l-5.123 2.845H1V9.21l2.647-1.47H1V4.26h3.463L1 2.337V1h1.564L6.87 3.393V1h3.26v2.846L15.254 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx178(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.063H1v1.874h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx178("path", { fill: "#0052B4", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx178("path", { fill: "#FCFCFC", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx178(
        "path",
        {
          fill: "#D80027",
          d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66ZM5.21 7.739 1 10.078V11l5.87-3.261H5.21Z"
        }
      ),
      /* @__PURE__ */ jsx178("path", { fill: "#0052B4", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx178("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx178(
        "path",
        {
          fill: "#D80027",
          d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66ZM11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z"
        }
      ),
      /* @__PURE__ */ jsx178("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Nz_default = SvgNz;

// build/Om.tsx
import { jsx as jsx179, jsxs as jsxs179 } from "react/jsx-runtime";
var SvgOm = (props) => /* @__PURE__ */ jsxs179(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx179("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx179("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx179(
        "path",
        {
          fill: "#FCFCFC",
          d: "m12.117 5.4-.922-.921-.615.614-.615-.614-.922.922.615.615-.615.615.922.922.615-.615.615.615.922-.922-.615-.615.615-.615ZM31 1H13.39v6.522H31V1Z"
        }
      ),
      /* @__PURE__ */ jsx179("path", { fill: "#6DA544", d: "M31 14.478H13.39v6.521H31v-6.521Z" }),
      /* @__PURE__ */ jsx179("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Om_default = SvgOm;

// build/Or.tsx
import { jsx as jsx180, jsxs as jsxs180 } from "react/jsx-runtime";
var SvgOr = (props) => /* @__PURE__ */ jsxs180(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx180("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx180(
        "path",
        {
          fill: "#000",
          d: "M19.482 9.47a3.83 3.83 0 0 0-7.329-1.557l-.472 1.713.435.434-.87 1.74.87.434-.435.435v.435l.435.435v.87l.434.434 1.305-.434s0 .434.435.869.87 1.304.87 1.304 1.304.435 2.173-.87c.87-1.303 1.74-1.738 1.74-1.738l-.839-1.677a3.819 3.819 0 0 0 1.248-2.827Z"
        }
      ),
      /* @__PURE__ */ jsx180(
        "path",
        {
          fill: "#ACABB1",
          d: "M19.794 10.934c1.766-.298 2.06-3.757 2.06-3.757H19.42c1.26 3.043-.059 3.248-.059 3.248-.179-.133-6.577-3.164-6.78-3.241-.049.065-.229.237-.447.772-.219.534-.273 1.015-.273 1.015.103.067 6.898 2.44 7.078 2.46.356.233.794.93.55 2.996l2.343-.66s-.796-2.116-2.038-2.833Z"
        }
      ),
      /* @__PURE__ */ jsx180("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Or_default = SvgOr;

// build/Pa.tsx
import { jsx as jsx181, jsxs as jsxs181 } from "react/jsx-runtime";
var SvgPa = (props) => /* @__PURE__ */ jsxs181(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx181("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx181("path", { fill: "#0052B4", d: "M16 11v10H1V11h15Z" }),
      /* @__PURE__ */ jsx181("path", { fill: "#D80027", d: "M31 1v10H16V1h15Z" }),
      /* @__PURE__ */ jsx181(
        "path",
        {
          fill: "#0052B4",
          d: "m8.5 3.209.692 2.132h2.242L9.62 6.66l.693 2.132-1.814-1.318-1.814 1.318.693-2.132L5.564 5.34h2.242L8.5 3.21Z"
        }
      ),
      /* @__PURE__ */ jsx181(
        "path",
        {
          fill: "#D80027",
          d: "m23.5 13.209.692 2.132h2.242L24.62 16.66l.693 2.132-1.814-1.318-1.813 1.318.692-2.132-1.814-1.318h2.242l.693-2.132Z"
        }
      ),
      /* @__PURE__ */ jsx181("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pa_default = SvgPa;

// build/Pe.tsx
import { jsx as jsx182, jsxs as jsxs182 } from "react/jsx-runtime";
var SvgPe = (props) => /* @__PURE__ */ jsxs182(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx182("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx182("path", { fill: "#D80027", d: "M11 1H1v20h10V1ZM31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx182("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pe_default = SvgPe;

// build/Pf.tsx
import { jsx as jsx183, jsxs as jsxs183 } from "react/jsx-runtime";
var SvgPf = (props) => /* @__PURE__ */ jsxs183(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx183("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx183("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx183(
        "path",
        {
          fill: "#FFDA44",
          d: "M18.226 11c0 1.23-.997 1.948-2.226 1.948-1.23 0-2.227-.719-2.227-1.948a2.226 2.226 0 0 1 4.453 0Z"
        }
      ),
      /* @__PURE__ */ jsx183("path", { fill: "#0052B4", d: "M18.226 11a2.226 2.226 0 0 1-4.453 0" }),
      /* @__PURE__ */ jsx183(
        "path",
        {
          fill: "#D80027",
          d: "M15.166 10.444h-.557v1.113h.557v-1.113ZM17.392 10.444h-.557v1.113h.556v-1.113ZM16.278 9.609h-.556v1.948h.556V9.609Z"
        }
      ),
      /* @__PURE__ */ jsx183("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pf_default = SvgPf;

// build/Pg.tsx
import { jsx as jsx184, jsxs as jsxs184 } from "react/jsx-runtime";
var SvgPg = (props) => /* @__PURE__ */ jsxs184(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx184("path", { fill: "#000", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx184("path", { fill: "#A2001D", d: "M1 1h30v20" }),
      /* @__PURE__ */ jsx184(
        "path",
        {
          fill: "#FCFCFC",
          d: "m12.99 15.13.162.498h.524l-.424.308.162.498-.423-.308-.424.308.162-.498-.424-.308h.524l.162-.498ZM11.653 10.348l.27.83h.873l-.707.513.27.83-.706-.513-.707.514.27-.83-.706-.514h.873l.27-.83ZM11.653 16.434l.27.83h.873l-.707.514.27.83-.706-.513-.707.513.27-.83-.706-.513h.873l.27-.83ZM14.205 12.521l.27.83h.873l-.706.514.27.83-.707-.513-.706.513.27-.83-.707-.513h.874l.27-.83ZM9.1 12.521l.27.83h.873l-.707.514.27.83-.706-.513-.706.513.27-.83-.707-.513h.873l.27-.83Z"
        }
      ),
      /* @__PURE__ */ jsx184(
        "path",
        {
          fill: "#FFDA44",
          d: "M23.062 7.963a2.59 2.59 0 0 0-1.652-.757l1.868-1.452a3.47 3.47 0 0 0-2.714-1.01 2.596 2.596 0 0 0-.668-1.142l-.738 1.475a1.087 1.087 0 1 0-1.476 1.476l-1.475.738c.33.33.725.551 1.144.668a3.467 3.467 0 0 0 1.008 2.713l1.632-2.098a.648.648 0 0 1 .919.004.648.648 0 0 1 .19.46.648.648 0 0 1-.19.462l.615.615c.287-.288.445-.67.445-1.076a1.51 1.51 0 0 0-.302-.91 1.741 1.741 0 0 1 .779 2.908l.615.615a2.592 2.592 0 0 0 .764-1.845c0-.697-.271-1.352-.764-1.844Z"
        }
      ),
      /* @__PURE__ */ jsx184("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pg_default = SvgPg;

// build/Ph.tsx
import { jsx as jsx185, jsxs as jsxs185 } from "react/jsx-runtime";
var SvgPh = (props) => /* @__PURE__ */ jsxs185(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx185("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx185("path", { fill: "#0052B4", d: "M31 1v10H16L1 1h30Z" }),
      /* @__PURE__ */ jsx185("path", { fill: "#D80027", d: "M31 11v10H1l15-10h15Z" }),
      /* @__PURE__ */ jsx185(
        "path",
        {
          fill: "#FFDA44",
          d: "m10.486 11-1.599-.752.852-1.549-1.736.333-.22-1.754-1.21 1.29-1.21-1.29-.22 1.754-1.735-.333.851 1.549L2.66 11l1.6.752-.852 1.549 1.736-.332.22 1.753 1.21-1.29 1.209 1.29.22-1.753 1.736.332-.852-1.549 1.6-.752ZM2.277 2.89l.532.745.872-.276-.543.736.532.743-.868-.289-.543.736.007-.914-.868-.29.872-.276.007-.914ZM2.277 16.715l.532.744.872-.276-.543.735.532.744-.868-.289-.543.736.007-.914-.868-.29.872-.276.007-.914ZM13.328 9.803l-.532.744-.872-.276.543.736-.532.743.867-.289.543.736-.006-.914.867-.29-.871-.276-.007-.914Z"
        }
      ),
      /* @__PURE__ */ jsx185("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ph_default = SvgPh;

// build/Pk.tsx
import { jsx as jsx186, jsxs as jsxs186 } from "react/jsx-runtime";
var SvgPk = (props) => /* @__PURE__ */ jsxs186(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx186(
        "path",
        {
          fill: "#FCFCFC",
          d: "m24.058 5.991 1.026 1.106 1.37-.634-.736 1.318 1.026 1.106-1.48-.292-.735 1.318-.18-1.498-1.48-.292 1.37-.634-.18-1.498Z"
        }
      ),
      /* @__PURE__ */ jsx186("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx186("path", { fill: "#496E2D", d: "M31 1H8.5v20H31V1Z" }),
      /* @__PURE__ */ jsx186(
        "path",
        {
          fill: "#FCFCFC",
          d: "M22.205 13.507a4.062 4.062 0 1 1-2.906-7.321 5 5 0 1 0 4.187 5.794 4.045 4.045 0 0 1-1.281 1.527ZM22.128 6.13l1.025 1.104 1.366-.633-.733 1.316L24.81 9.02l-1.478-.291-.733 1.315-.18-1.495-1.478-.291 1.367-.633-.18-1.496Z"
        }
      ),
      /* @__PURE__ */ jsx186("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pk_default = SvgPk;

// build/Pl.tsx
import { jsx as jsx187, jsxs as jsxs187 } from "react/jsx-runtime";
var SvgPl = (props) => /* @__PURE__ */ jsxs187(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx187("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx187("path", { fill: "#FCFCFC", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx187("path", { fill: "#D80027", d: "M31 11H1v10h30V11Z" }),
      /* @__PURE__ */ jsx187("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pl_default = SvgPl;

// build/Pm.tsx
import { jsx as jsx188, jsxs as jsxs188 } from "react/jsx-runtime";
var SvgPm = (props) => /* @__PURE__ */ jsxs188(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx188("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx188("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx188("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx188("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pm_default = SvgPm;

// build/Pn.tsx
import { jsx as jsx189, jsxs as jsxs189 } from "react/jsx-runtime";
var SvgPn = (props) => /* @__PURE__ */ jsxs189(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx189("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx189(
        "path",
        {
          fill: "#ACABB1",
          d: "m24.478 8.88-.978.326-.979-.326-.326-.815.326-.815h1.957l-.326.815.326.815Z"
        }
      ),
      /* @__PURE__ */ jsx189(
        "path",
        {
          fill: "#338AF3",
          d: "M21.217 8.88v3.587c0 1.747 2.282 2.283 2.282 2.283s2.283-.536 2.283-2.283V8.88h-4.565Z"
        }
      ),
      /* @__PURE__ */ jsx189(
        "path",
        {
          fill: "#6DA544",
          d: "M21.424 13.317c.56 1.077 2.077 1.433 2.077 1.433s1.515-.356 2.076-1.433l-2.076-3.458-2.077 3.458Z"
        }
      ),
      /* @__PURE__ */ jsx189(
        "path",
        {
          fill: "#FFDA44",
          d: "M25.782 12.43 23.5 8.88l-2.282 3.55v.037c0 .323.078.605.206.85l2.076-3.23 2.077 3.23c.128-.245.206-.527.206-.85v-.036Z"
        }
      ),
      /* @__PURE__ */ jsx189(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 1v1.79l-2.646 1.471H16v3.478h-3.463L16 9.663V11h-1.563L10.13 8.608V11H6.87V8.154L1.747 11H1V9.21l2.647-1.471H1V4.261h3.463L1 2.336V1h1.563L6.87 3.392V1h3.26v2.846L15.253 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx189(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx189("path", { fill: "#0052B4", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx189("path", { fill: "#FCFCFC", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx189(
        "path",
        {
          fill: "#D80027",
          d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66ZM5.21 7.739 1 10.078V11l5.87-3.261H5.21Z"
        }
      ),
      /* @__PURE__ */ jsx189("path", { fill: "#0052B4", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx189("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx189(
        "path",
        {
          fill: "#D80027",
          d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66ZM11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z"
        }
      ),
      /* @__PURE__ */ jsx189("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pn_default = SvgPn;

// build/Pr.tsx
import { jsx as jsx190, jsxs as jsxs190 } from "react/jsx-runtime";
var SvgPr = (props) => /* @__PURE__ */ jsxs190(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx190("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx190("path", { fill: "#D80027", d: "M31 1H1v4h30V1ZM31 9H1v4h30V9ZM31 17H1v4h30v-4Z" }),
      /* @__PURE__ */ jsx190("path", { fill: "#0052B4", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx190(
        "path",
        {
          fill: "#FCFCFC",
          d: "m5.892 7.434.885 2.724h2.865l-2.318 1.684.885 2.724-2.317-1.683-2.318 1.684.885-2.725-2.317-1.684h2.864l.886-2.724Z"
        }
      ),
      /* @__PURE__ */ jsx190("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pr_default = SvgPr;

// build/Ps.tsx
import { jsx as jsx191, jsxs as jsxs191 } from "react/jsx-runtime";
var SvgPs = (props) => /* @__PURE__ */ jsxs191(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx191("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx191("path", { fill: "#000", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx191("path", { fill: "#6DA544", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx191("path", { fill: "#D80027", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx191("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ps_default = SvgPs;

// build/Pt.tsx
import { jsx as jsx192, jsxs as jsxs192 } from "react/jsx-runtime";
var SvgPt = (props) => /* @__PURE__ */ jsxs192(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx192("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx192("path", { fill: "#6DA544", d: "M12.522 1v20H1V1h11.522Z" }),
      /* @__PURE__ */ jsx192(
        "path",
        {
          fill: "#FFDA44",
          d: "M12.521 14.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
        }
      ),
      /* @__PURE__ */ jsx192(
        "path",
        {
          fill: "#D80027",
          d: "M10.412 9.125v2.344a2.11 2.11 0 1 0 4.219 0V9.125h-4.219Z"
        }
      ),
      /* @__PURE__ */ jsx192(
        "path",
        {
          fill: "#FCFCFC",
          d: "M12.521 12.172a.704.704 0 0 1-.703-.703v-.938h1.407v.938a.704.704 0 0 1-.704.703Z"
        }
      ),
      /* @__PURE__ */ jsx192("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pt_default = SvgPt;

// build/Pw.tsx
import { jsx as jsx193, jsxs as jsxs193 } from "react/jsx-runtime";
var SvgPw = (props) => /* @__PURE__ */ jsxs193(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx193("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx193(
        "path",
        {
          fill: "#FFDA44",
          d: "M13.827 15.348a4.348 4.348 0 1 0 0-8.696 4.348 4.348 0 0 0 0 8.696Z"
        }
      ),
      /* @__PURE__ */ jsx193("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Pw_default = SvgPw;

// build/Py.tsx
import { jsx as jsx194, jsxs as jsxs194 } from "react/jsx-runtime";
var SvgPy = (props) => /* @__PURE__ */ jsxs194(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx194("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx194("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx194("path", { fill: "#0052B4", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx194(
        "path",
        {
          fill: "#6DA544",
          d: "m17.967 8.7-.738.737a1.74 1.74 0 1 1-2.46 0l-.737-.738a2.783 2.783 0 1 0 3.935 0Z"
        }
      ),
      /* @__PURE__ */ jsx194(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 9.624.259.797h.838l-.678.492.259.798-.679-.493-.678.493.26-.798-.679-.492h.839l.258-.797Z"
        }
      ),
      /* @__PURE__ */ jsx194("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Py_default = SvgPy;

// build/Qa.tsx
import { jsx as jsx195, jsxs as jsxs195 } from "react/jsx-runtime";
var SvgQa = (props) => /* @__PURE__ */ jsxs195(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx195("path", { fill: "#751A46", d: "M31.001 1H1.131v20H31V1Z" }),
      /* @__PURE__ */ jsx195(
        "path",
        {
          fill: "#FCFCFC",
          d: "M13.273 5.055 10.329 6.54l2.944 1.487-2.944 1.487L13.273 11l-2.944 1.487 2.944 1.486-2.944 1.487 2.944 1.486-2.944 1.487 2.944 1.487L11.137 21H1V1h10.133l2.14 1.08-2.944 1.488 2.944 1.487Z"
        }
      ),
      /* @__PURE__ */ jsx195("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Qa_default = SvgQa;

// build/Re.tsx
import { jsx as jsx196, jsxs as jsxs196 } from "react/jsx-runtime";
var SvgRe = (props) => /* @__PURE__ */ jsxs196(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx196("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx196("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx196("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx196("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Re_default = SvgRe;

// build/Rk.tsx
import { jsx as jsx197, jsxs as jsxs197 } from "react/jsx-runtime";
var SvgRk = (props) => /* @__PURE__ */ jsxs197(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx197("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx197(
        "path",
        {
          fill: "#FFDA44",
          d: "M31 13.337H12.847V21H8.174v-7.663H1V8.663h7.174V1h4.673v7.663H31V13.337Z"
        }
      ),
      /* @__PURE__ */ jsx197(
        "path",
        {
          fill: "#0052B4",
          d: "M31 9.75v2.5H11.76V21h-2.5v-8.75H1v-2.5h8.26V1h2.5v8.75H31Z"
        }
      ),
      /* @__PURE__ */ jsx197("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Rk_default = SvgRk;

// build/Ro.tsx
import { jsx as jsx198, jsxs as jsxs198 } from "react/jsx-runtime";
var SvgRo = (props) => /* @__PURE__ */ jsxs198(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx198("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx198("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx198("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx198("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ro_default = SvgRo;

// build/Rs.tsx
import { jsx as jsx199, jsxs as jsxs199 } from "react/jsx-runtime";
var SvgRs = (props) => /* @__PURE__ */ jsxs199(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx199("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx199("path", { fill: "#D80027", d: "M31 1H1v6.666h30V1Z" }),
      /* @__PURE__ */ jsx199("path", { fill: "#FCFCFC", d: "M31 14.333H1v6.666h30v-6.666Z" }),
      /* @__PURE__ */ jsx199(
        "path",
        {
          fill: "#D80027",
          d: "M8.586 6.652v4.988c0 2.838 3.707 3.707 3.707 3.707S16 14.477 16 11.64V6.652H8.586Z"
        }
      ),
      /* @__PURE__ */ jsx199(
        "path",
        {
          fill: "#FFDA44",
          d: "M10.12 7.522h4.347v-1.74l-.87.435-1.304-1.304-1.304 1.304-.87-.435v1.74ZM15.13 12.335l-2.825-2.826-2.826 2.826.922.922 1.904-1.903 1.903 1.903.923-.922Z"
        }
      ),
      /* @__PURE__ */ jsx199(
        "path",
        {
          fill: "#FCFCFC",
          d: "M15.13 9.695h-1.318a.87.87 0 1 0-1.519-.845.87.87 0 1 0-1.519.845H9.48c0 .48.418.87.898.87h-.029c0 .48.39.87.87.87a.87.87 0 0 0 .708.854l-.685 1.546a2.816 2.816 0 0 0 2.127 0l-.685-1.546a.87.87 0 0 0 .708-.855c.48 0 .87-.389.87-.87h-.03c.481 0 .9-.388.9-.869Z"
        }
      ),
      /* @__PURE__ */ jsx199("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Rs_default = SvgRs;

// build/Ru.tsx
import { jsx as jsx200, jsxs as jsxs200 } from "react/jsx-runtime";
var SvgRu = (props) => /* @__PURE__ */ jsxs200(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx200("path", { fill: "#FCFCFC", d: "M1 1v20h30V1H1Z" }),
      /* @__PURE__ */ jsx200("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx200("path", { fill: "#FCFCFC", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx200("path", { fill: "#D80027", d: "M31 14.333H1v6.666h30v-6.666Z" }),
      /* @__PURE__ */ jsx200("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ru_default = SvgRu;

// build/Rw.tsx
import { jsx as jsx201, jsxs as jsxs201 } from "react/jsx-runtime";
var SvgRw = (props) => /* @__PURE__ */ jsxs201(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx201("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx201("path", { fill: "#FFDA44", d: "M31 11H1v4.782h30V11Z" }),
      /* @__PURE__ */ jsx201("path", { fill: "#496E2D", d: "M31 15.782H1v5.217h30v-5.217Z" }),
      /* @__PURE__ */ jsx201(
        "path",
        {
          fill: "#FFDA44",
          d: "m17.305 6.852 1.221.575-.65 1.182 1.326-.253.168 1.34.924-.986.923.985.168-1.34 1.326.254-.65-1.182 1.221-.575-1.22-.574.65-1.183-1.327.254-.168-1.34-.923.985-.924-.985-.168 1.34-1.326-.254.65 1.183-1.221.574Z"
        }
      ),
      /* @__PURE__ */ jsx201("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Rw_default = SvgRw;

// build/Sa.tsx
import { jsx as jsx202, jsxs as jsxs202 } from "react/jsx-runtime";
var SvgSa = (props) => /* @__PURE__ */ jsxs202(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx202("path", { fill: "#6DA544", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx202(
        "path",
        {
          fill: "#FCFCFC",
          d: "M11.754 12.956c0 .72.57 1.305 1.274 1.305h3.82c0 .6.476 1.087 1.062 1.087h1.273c.586 0 1.062-.487 1.062-1.087v-1.305h-8.491ZM20.351 6.652v3.043c0 .48-.38.87-.849.87v1.304c1.17 0 2.123-.975 2.123-2.174V6.652H20.35ZM11.224 9.695c0 .48-.38.87-.849.87v1.304c1.17 0 2.123-.975 2.123-2.174V6.652h-1.274v3.043Z"
        }
      ),
      /* @__PURE__ */ jsx202(
        "path",
        {
          fill: "#FCFCFC",
          d: "M19.715 6.652h-1.274v3.043h1.274V6.652ZM16.531 8.391c0 .12-.095.217-.212.217a.215.215 0 0 1-.212-.217v-1.74h-1.274v1.74c0 .12-.095.217-.212.217a.215.215 0 0 1-.213-.217v-1.74h-1.273v1.74c0 .84.666 1.522 1.486 1.522.315 0 .608-.102.849-.274a1.453 1.453 0 0 0 1.036.261.854.854 0 0 1-.824.665v1.304c1.17 0 2.123-.975 2.123-2.174V6.651H16.53v1.74Z"
        }
      ),
      /* @__PURE__ */ jsx202("path", { fill: "#FCFCFC", d: "M15.045 10.565h-1.91v1.304h1.91v-1.304Z" }),
      /* @__PURE__ */ jsx202("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sa_default = SvgSa;

// build/Sb.tsx
import { jsx as jsx203, jsxs as jsxs203 } from "react/jsx-runtime";
var SvgSb = (props) => /* @__PURE__ */ jsxs203(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx203("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx203("path", { fill: "#0052B4", d: "M1 21V1h30" }),
      /* @__PURE__ */ jsx203("path", { fill: "#FFDA44", d: "M1 19.232V21h2.652L31 2.768V1h-2.652L1 19.232Z" }),
      /* @__PURE__ */ jsx203(
        "path",
        {
          fill: "#FCFCFC",
          d: "m6.02 2.374.3.924h.971l-.785.57.3.923-.785-.57-.786.57.3-.923-.785-.57h.97l.3-.924ZM10.98 2.374l.3.924h.97l-.785.57.3.923-.785-.57-.786.57.3-.923-.785-.57h.97l.3-.924ZM6.02 7.208l.3.924h.971l-.785.57.3.923-.785-.57-.786.57.3-.923-.785-.57h.97l.3-.924ZM10.98 7.208l.3.924h.97l-.785.57.3.923-.785-.57-.786.57.3-.923-.785-.57h.97l.3-.924ZM8.5 4.791l.3.924h.97l-.785.57.3.923-.786-.57-.785.57.3-.923-.785-.57h.97l.3-.924Z"
        }
      ),
      /* @__PURE__ */ jsx203("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sb_default = SvgSb;

// build/Sc.tsx
import { jsx as jsx204, jsxs as jsxs204 } from "react/jsx-runtime";
var SvgSc = (props) => /* @__PURE__ */ jsxs204(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx204("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx204("path", { fill: "#FFDA44", d: "M14.796 1 1 21 26.04 1H14.796Z" }),
      /* @__PURE__ */ jsx204("path", { fill: "#6DA544", d: "M31 15.3 1 21h30v-5.7Z" }),
      /* @__PURE__ */ jsx204("path", { fill: "#D80027", d: "M31 1h-4.96L1 21 31 9.017V1Z" }),
      /* @__PURE__ */ jsx204("path", { fill: "#0052B4", d: "M1 1v20L14.796 1H1Z" }),
      /* @__PURE__ */ jsx204("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sc_default = SvgSc;

// build/Sd.tsx
import { jsx as jsx205, jsxs as jsxs205 } from "react/jsx-runtime";
var SvgSd = (props) => /* @__PURE__ */ jsxs205(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx205("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx205("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx205("path", { fill: "#000", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx205("path", { fill: "#496E2D", d: "M1 21V1l15 10L1 21Z" }),
      /* @__PURE__ */ jsx205("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sd_default = SvgSd;

// build/Se.tsx
import { jsx as jsx206, jsxs as jsxs206 } from "react/jsx-runtime";
var SvgSe = (props) => /* @__PURE__ */ jsxs206(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx206("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx206(
        "path",
        {
          fill: "#FFDA44",
          d: "M12.25 1H8.5v8.125H1v3.75h7.5V21h3.75v-8.125H31v-3.75H12.25V1Z"
        }
      ),
      /* @__PURE__ */ jsx206("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Se_default = SvgSe;

// build/Sg.tsx
import { jsx as jsx207, jsxs as jsxs207 } from "react/jsx-runtime";
var SvgSg = (props) => /* @__PURE__ */ jsxs207(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx207("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx207("path", { fill: "#D80027", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx207(
        "path",
        {
          fill: "#FCFCFC",
          d: "M5.892 6a3.044 3.044 0 0 1 2.392-2.973 3.043 3.043 0 1 0 0 5.945A3.044 3.044 0 0 1 5.892 6ZM9.805 3.174l.216.664h.698l-.565.41.216.665-.565-.41-.565.41.216-.664-.565-.41h.698l.216-.665Z"
        }
      ),
      /* @__PURE__ */ jsx207(
        "path",
        {
          fill: "#FCFCFC",
          d: "m8.11 4.478.215.664h.699l-.565.411.216.664-.565-.41-.565.41.215-.664-.565-.41h.699l.216-.665ZM11.498 4.478l.216.664h.699l-.566.411.216.664-.565-.41-.565.41.216-.664-.565-.41h.699l.215-.665ZM10.846 6.435l.216.664h.698l-.565.41.216.665-.565-.41-.565.41.216-.664-.565-.411h.698l.216-.664ZM8.762 6.435l.216.664h.698l-.565.41.216.665-.565-.41-.565.41.216-.664-.565-.411h.698l.216-.664Z"
        }
      ),
      /* @__PURE__ */ jsx207("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sg_default = SvgSg;

// build/Sh.tsx
import { jsx as jsx208, jsxs as jsxs208 } from "react/jsx-runtime";
var SvgSh = (props) => /* @__PURE__ */ jsxs208(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx208("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx208(
        "path",
        {
          fill: "#D80027",
          d: "M17.875 1h-3.75v8.125H1v3.75h13.125V21h3.75v-8.125H31v-3.75H17.875V1Z"
        }
      ),
      /* @__PURE__ */ jsx208(
        "path",
        {
          fill: "#0052B4",
          d: "m24.074 14.478 6.927 3.848v-3.848h-6.927ZM19.262 14.478 31 21v-1.845l-8.42-4.677h-3.32ZM27.874 21l-8.612-4.785V21h8.612Z"
        }
      ),
      /* @__PURE__ */ jsx208("path", { fill: "#FCFCFC", d: "M19.262 14.478 31 21v-1.845l-8.42-4.677h-3.32Z" }),
      /* @__PURE__ */ jsx208("path", { fill: "#D80027", d: "M19.262 14.478 31 21v-1.845l-8.42-4.677h-3.32Z" }),
      /* @__PURE__ */ jsx208(
        "path",
        {
          fill: "#0052B4",
          d: "M6.293 14.478 1 17.418v-2.94h5.293ZM12.74 15.307V21H2.494l10.246-5.693Z"
        }
      ),
      /* @__PURE__ */ jsx208("path", { fill: "#D80027", d: "M9.42 14.478 1 19.155V21l11.74-6.522H9.42Z" }),
      /* @__PURE__ */ jsx208(
        "path",
        {
          fill: "#0052B4",
          d: "M7.927 7.522 1 3.673v3.849h6.927ZM12.74 7.522 1 1v1.844l8.42 4.678h3.32ZM4.127 1l8.612 4.785V1H4.127Z"
        }
      ),
      /* @__PURE__ */ jsx208("path", { fill: "#FCFCFC", d: "M12.74 7.522 1 1v1.844l8.42 4.678h3.32Z" }),
      /* @__PURE__ */ jsx208("path", { fill: "#D80027", d: "M12.74 7.522 1 1v1.844l8.42 4.678h3.32Z" }),
      /* @__PURE__ */ jsx208(
        "path",
        {
          fill: "#0052B4",
          d: "M25.707 7.522 31 4.58v2.94h-5.293ZM19.262 6.692V1h10.245L19.262 6.692Z"
        }
      ),
      /* @__PURE__ */ jsx208("path", { fill: "#D80027", d: "m22.581 7.522 8.42-4.678V1L19.26 7.522h3.32Z" }),
      /* @__PURE__ */ jsx208("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sh_default = SvgSh;

// build/Si.tsx
import { jsx as jsx209, jsxs as jsxs209 } from "react/jsx-runtime";
var SvgSi = (props) => /* @__PURE__ */ jsxs209(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx209("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx209("path", { fill: "#0052B4", d: "M31 7.667H1v6.666h30V7.667Z" }),
      /* @__PURE__ */ jsx209("path", { fill: "#D80027", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx209(
        "path",
        {
          fill: "#FCFCFC",
          d: "M14.689 7.522v.87c0 1.996-2.609 2.608-2.609 2.608s-2.609-.612-2.609-2.609v-.87l-.008-2.588 5.217-.016.009 2.605Z"
        }
      ),
      /* @__PURE__ */ jsx209(
        "path",
        {
          fill: "#0052B4",
          d: "M14.689 7.522v.87c0 1.996-2.609 2.608-2.609 2.608s-2.609-.612-2.609-2.609v-.87l-.008-2.588 5.217-.016.009 2.605Z"
        }
      ),
      /* @__PURE__ */ jsx209(
        "path",
        {
          fill: "#FCFCFC",
          d: "M14.688 7.522v.87c0 1.996-2.609 2.608-2.609 2.608s-2.608-.612-2.608-2.609v-.87l.87.87 1.738-1.304 1.74 1.304.87-.87Z"
        }
      ),
      /* @__PURE__ */ jsx209("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Si_default = SvgSi;

// build/Sj.tsx
import { jsx as jsx210, jsxs as jsxs210 } from "react/jsx-runtime";
var SvgSj = (props) => /* @__PURE__ */ jsxs210(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx210("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx210(
        "path",
        {
          fill: "#FCFCFC",
          d: "M31 13.337H12.847V21H8.174v-7.663H1V8.663h7.174V1h4.673v7.663H31V13.337Z"
        }
      ),
      /* @__PURE__ */ jsx210(
        "path",
        {
          fill: "#2E52B2",
          d: "M31 9.75v2.5H11.76V21h-2.5v-8.75H1v-2.5h8.26V1h2.5v8.75H31Z"
        }
      ),
      /* @__PURE__ */ jsx210("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sj_default = SvgSj;

// build/Sk.tsx
import { jsx as jsx211, jsxs as jsxs211 } from "react/jsx-runtime";
var SvgSk = (props) => /* @__PURE__ */ jsxs211(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx211("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx211("path", { fill: "#0052B4", d: "M31 7.522H1v6.956h30V7.522Z" }),
      /* @__PURE__ */ jsx211("path", { fill: "#D80027", d: "M31 14.478H1V21h30v-6.522Z" }),
      /* @__PURE__ */ jsx211(
        "path",
        {
          fill: "#FCFCFC",
          d: "M8.586 6.652v4.989c0 2.838 3.707 3.707 3.707 3.707S16 14.478 16 11.64V6.652H8.586Z"
        }
      ),
      /* @__PURE__ */ jsx211(
        "path",
        {
          fill: "#D80027",
          d: "M9.563 6.798V11.6c0 .32.07.623.212.907h5.037c.141-.284.212-.587.212-.907V6.798H9.563Z"
        }
      ),
      /* @__PURE__ */ jsx211(
        "path",
        {
          fill: "#FCFCFC",
          d: "M13.967 10.146H12.71V9.31h.837v-.837h-.837v-.837h-.836v.837h-.837v.837h.837v.837h-1.256v.837h1.256v.837h.836v-.837h1.256v-.837Z"
        }
      ),
      /* @__PURE__ */ jsx211(
        "path",
        {
          fill: "#0052B4",
          d: "M10.917 13.675c.54.34 1.093.536 1.377.623a6.011 6.011 0 0 0 1.377-.623c.544-.341.925-.732 1.142-1.168a1.458 1.458 0 0 0-1.178-.23 1.465 1.465 0 0 0-2.682 0 1.467 1.467 0 0 0-1.178.23c.217.436.598.827 1.142 1.168Z"
        }
      ),
      /* @__PURE__ */ jsx211("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sk_default = SvgSk;

// build/Sl.tsx
import { jsx as jsx212, jsxs as jsxs212 } from "react/jsx-runtime";
var SvgSl = (props) => /* @__PURE__ */ jsxs212(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx212("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx212("path", { fill: "#6DA544", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx212("path", { fill: "#338AF3", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx212("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sl_default = SvgSl;

// build/Sm.tsx
import { jsx as jsx213, jsxs as jsxs213 } from "react/jsx-runtime";
var SvgSm = (props) => /* @__PURE__ */ jsxs213(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx213("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx213("path", { fill: "#FCFCFC", d: "M31 1v9.767L1 11.01V1h30Z" }),
      /* @__PURE__ */ jsx213(
        "path",
        {
          fill: "#6DA544",
          d: "m19.969 7.9-3.97 3.97L12.03 7.9a4.755 4.755 0 0 0-.813 2.665v1.305a4.79 4.79 0 0 0 3.231 4.524 1.447 1.447 0 0 0 .159 1.563l1.421-1.14 1.422 1.14c.371-.464.41-1.086.15-1.58a4.79 4.79 0 0 0 3.182-4.507v-1.305c0-.986-.3-1.903-.813-2.665Z"
        }
      ),
      /* @__PURE__ */ jsx213(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 15.348a3.482 3.482 0 0 1-3.479-3.478v-1.305A3.482 3.482 0 0 1 16 7.087a3.482 3.482 0 0 1 3.478 3.478v1.305A3.482 3.482 0 0 1 16 15.348Z"
        }
      ),
      /* @__PURE__ */ jsx213(
        "path",
        {
          fill: "#338AF3",
          d: "M18.174 11.87v-1.305A2.176 2.176 0 0 0 16 8.391a2.176 2.176 0 0 0-2.174 2.174v1.305l2.174.435 2.174-.435Z"
        }
      ),
      /* @__PURE__ */ jsx213(
        "path",
        {
          fill: "#6DA544",
          d: "M13.826 11.87c0 1.198.975 2.174 2.174 2.174a2.176 2.176 0 0 0 2.174-2.174h-4.348Z"
        }
      ),
      /* @__PURE__ */ jsx213(
        "path",
        {
          fill: "#FFDA44",
          d: "M18.608 7.087a1.304 1.304 0 0 0-2.174-.972v-.767h.435v-.87h-.435v-.434h-.87v.434h-.434v.87h.435v.767a1.304 1.304 0 1 0-1.74 1.944v.767h4.348V8.06c.267-.239.435-.586.435-.972Z"
        }
      ),
      /* @__PURE__ */ jsx213("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sm_default = SvgSm;

// build/Sn.tsx
import { jsx as jsx214, jsxs as jsxs214 } from "react/jsx-runtime";
var SvgSn = (props) => /* @__PURE__ */ jsxs214(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx214("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx214("path", { fill: "#D80027", d: "M31 1H20.348v20H31V1Z" }),
      /* @__PURE__ */ jsx214(
        "path",
        {
          fill: "#496E2D",
          d: "M11.652 1H1v20h10.652V1ZM16 7.521l.863 2.657h2.794l-2.26 1.643.863 2.657L16 12.836l-2.26 1.642.863-2.657-2.26-1.643h2.794L16 7.521Z"
        }
      ),
      /* @__PURE__ */ jsx214("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sn_default = SvgSn;

// build/So.tsx
import { jsx as jsx215, jsxs as jsxs215 } from "react/jsx-runtime";
var SvgSo = (props) => /* @__PURE__ */ jsxs215(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx215("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx215(
        "path",
        {
          fill: "#FCFCFC",
          d: "m16 5.215 1.328 4.087h4.297l-3.477 2.526 1.329 4.087L16 13.389l-3.476 2.526 1.328-4.087-3.477-2.526h4.297L16 5.215Z"
        }
      ),
      /* @__PURE__ */ jsx215("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var So_default = SvgSo;

// build/Sr.tsx
import { jsx as jsx216, jsxs as jsxs216 } from "react/jsx-runtime";
var SvgSr = (props) => /* @__PURE__ */ jsxs216(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx216("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx216("path", { fill: "#A2001D", d: "M31 7.522H1v6.956h30V7.522Z" }),
      /* @__PURE__ */ jsx216("path", { fill: "#6DA544", d: "M31 16.652H1V21h30v-4.348ZM31 1H1v4.348h30V1Z" }),
      /* @__PURE__ */ jsx216(
        "path",
        {
          fill: "#FFDA44",
          d: "m16.044 8.774.552 1.7h1.788l-1.446 1.051.552 1.7-1.446-1.05-1.447 1.05.553-1.7-1.447-1.051h1.788l.553-1.7Z"
        }
      ),
      /* @__PURE__ */ jsx216("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sr_default = SvgSr;

// build/Ss.tsx
import { jsx as jsx217, jsxs as jsxs217 } from "react/jsx-runtime";
var SvgSs = (props) => /* @__PURE__ */ jsxs217(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx217("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx217("path", { fill: "#496E2D", d: "M31 14.913H1V21h30v-6.087Z" }),
      /* @__PURE__ */ jsx217("path", { fill: "#000", d: "M31 1H1v6.124h30V1Z" }),
      /* @__PURE__ */ jsx217("path", { fill: "#A2001D", d: "M31 8.356H1v5.253h30V8.356Z" }),
      /* @__PURE__ */ jsx217("path", { fill: "#0052B4", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx217(
        "path",
        {
          fill: "#FFDA44",
          d: "m5.288 8.257 1.22 1.703 1.998-.634-1.243 1.687 1.22 1.703-1.988-.66-1.243 1.687.014-2.095-1.989-.661 1.997-.635.014-2.095Z"
        }
      ),
      /* @__PURE__ */ jsx217("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ss_default = SvgSs;

// build/St.tsx
import { jsx as jsx218, jsxs as jsxs218 } from "react/jsx-runtime";
var SvgSt = (props) => /* @__PURE__ */ jsxs218(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx218("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx218("path", { fill: "#6DA544", d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx218("path", { fill: "#D80027", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx218(
        "path",
        {
          fill: "#000",
          d: "m18.698 9.26.431 1.33h1.397l-1.13.82.432 1.33-1.13-.822-1.13.821.431-1.328-1.13-.822h1.397l.432-1.328ZM23.046 9.26l.431 1.33h1.397l-1.13.82.432 1.33-1.13-.822-1.13.821.431-1.328-1.13-.822h1.397l.431-1.328Z"
        }
      ),
      /* @__PURE__ */ jsx218("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var St_default = SvgSt;

// build/Sv.tsx
import { jsx as jsx219, jsxs as jsxs219 } from "react/jsx-runtime";
var SvgSv = (props) => /* @__PURE__ */ jsxs219(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx219("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx219("path", { fill: "#0052B4", d: "M31 1H1v6.667h30V1ZM31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx219("path", { fill: "#FFDA44", d: "m14.393 11.348 1.606-2.783 1.607 2.783h-3.213Z" }),
      /* @__PURE__ */ jsx219(
        "path",
        {
          fill: "#6DA544",
          d: "M18.088 12.267 16 13.31l-2.087-1.043v-1.392h4.174v1.392Z"
        }
      ),
      /* @__PURE__ */ jsx219(
        "path",
        {
          fill: "#FFDA44",
          d: "m17.967 8.685-.738.737a1.74 1.74 0 1 1-2.46 0l-.737-.737a2.783 2.783 0 1 0 3.935 0Z"
        }
      ),
      /* @__PURE__ */ jsx219("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sv_default = SvgSv;

// build/Sx.tsx
import { jsx as jsx220, jsxs as jsxs220 } from "react/jsx-runtime";
var SvgSx = (props) => /* @__PURE__ */ jsxs220(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx220("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx220("path", { fill: "#D80027", d: "M31 1v9.767L1 11.01V1h30Z" }),
      /* @__PURE__ */ jsx220("path", { fill: "#FCFCFC", d: "M16 11 1 21V1l15 10Z" }),
      /* @__PURE__ */ jsx220(
        "path",
        {
          fill: "#FFDA44",
          d: "M4.494 11a3.482 3.482 0 1 0 6.942 0H4.493ZM7.964 9.393a1.071 1.071 0 1 0 0-2.143 1.071 1.071 0 0 0 0 2.143Z"
        }
      ),
      /* @__PURE__ */ jsx220(
        "path",
        {
          fill: "#D80027",
          d: "M5.553 8.054v3.482c0 1.845 2.41 2.41 2.41 2.41s2.411-.565 2.411-2.41V8.054H5.553Z"
        }
      ),
      /* @__PURE__ */ jsx220(
        "path",
        {
          fill: "#338AF3",
          d: "M7.965 12.825c-.447-.16-1.34-.572-1.34-1.29v-2.41h2.679v2.41c0 .72-.894 1.13-1.339 1.29Z"
        }
      ),
      /* @__PURE__ */ jsx220(
        "path",
        {
          fill: "#F3F3F3",
          d: "M8.5 10.464V9.93l-.536-.268-.536.268v.535l-.268.268v1.072h1.607v-1.072l-.268-.268Z"
        }
      ),
      /* @__PURE__ */ jsx220("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sx_default = SvgSx;

// build/Sy.tsx
import { jsx as jsx221, jsxs as jsxs221 } from "react/jsx-runtime";
var SvgSy = (props) => /* @__PURE__ */ jsxs221(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx221("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx221("path", { fill: "#D80027", d: "M31 1H1v6.666h30V1Z" }),
      /* @__PURE__ */ jsx221("path", { fill: "#000", d: "M31 14.333H1v6.666h30v-6.666Z" }),
      /* @__PURE__ */ jsx221(
        "path",
        {
          fill: "#6DA544",
          d: "m11.975 8.609.54 1.66h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.412 1.026.54-1.66-1.414-1.027h1.747l.54-1.66ZM20.024 8.609l.54 1.66h1.746l-1.413 1.027.54 1.66-1.413-1.026-1.413 1.026.54-1.66-1.413-1.027h1.747l.539-1.66Z"
        }
      ),
      /* @__PURE__ */ jsx221("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sy_default = SvgSy;

// build/Sz.tsx
import { jsx as jsx222, jsxs as jsxs222 } from "react/jsx-runtime";
var SvgSz = (props) => /* @__PURE__ */ jsxs222(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx222("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx222("path", { fill: "#000", d: "M31 1H1v5.307h30V1Z" }),
      /* @__PURE__ */ jsx222("path", { fill: "#0052B4", d: "M31 15.693H1v5.306h30v-5.306Z" }),
      /* @__PURE__ */ jsx222("path", { fill: "#A2001D", d: "M31 7.637H1v6.727h30V7.637Z" }),
      /* @__PURE__ */ jsx222(
        "path",
        {
          fill: "#FFDA44",
          d: "M22.522 10.565H9.479v.87h13.043v-.87ZM20.782 8.826h-9.565v.87h9.565v-.87Z"
        }
      ),
      /* @__PURE__ */ jsx222(
        "path",
        {
          fill: "#FCFCFC",
          d: "M20.844 11S18.608 13.608 16 13.608c-2.608 0-2.608-2.608-2.608-2.608s0-2.609 2.608-2.609c2.609 0 4.845 2.609 4.845 2.609Z"
        }
      ),
      /* @__PURE__ */ jsx222(
        "path",
        {
          fill: "#000",
          d: "M16 13.608c-2.61 0-4.846-2.608-4.846-2.608S13.39 8.39 16 8.39"
        }
      ),
      /* @__PURE__ */ jsx222("path", { fill: "#FCFCFC", d: "M15.13 10.13h-.87v1.74h.87v-1.74Z" }),
      /* @__PURE__ */ jsx222("path", { fill: "#000", d: "M17.739 10.13h-.87v1.74h.87v-1.74Z" }),
      /* @__PURE__ */ jsx222(
        "path",
        {
          fill: "#0052B4",
          d: "M9.479 11.87a.87.87 0 1 0 0-1.74.87.87 0 0 0 0 1.74ZM22.522 11.87a.87.87 0 1 0 0-1.74.87.87 0 0 0 0 1.74Z"
        }
      ),
      /* @__PURE__ */ jsx222("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Sz_default = SvgSz;

// build/Tc.tsx
import { jsx as jsx223, jsxs as jsxs223 } from "react/jsx-runtime";
var SvgTc = (props) => /* @__PURE__ */ jsxs223(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx223("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx223(
        "path",
        {
          fill: "#FFDA44",
          d: "M20.457 7.25v4.583c0 2.232 3.043 2.917 3.043 2.917s3.044-.684 3.044-2.917V7.25h-6.087Z"
        }
      ),
      /* @__PURE__ */ jsx223(
        "path",
        {
          fill: "#FF9811",
          d: "M23.065 8.916c0 .46-.39 1.667-.87 1.667s-.869-1.206-.869-1.667c0-.46.87-.833.87-.833s.87.373.87.833Z"
        }
      ),
      /* @__PURE__ */ jsx223(
        "path",
        {
          fill: "#A2001D",
          d: "M25.373 9.824c.14-.328.25-.808.25-1.046 0-.384-.522-.695-.522-.695s-.522.311-.522.695c0 .238.11.718.25 1.046l-.302.652a1.577 1.577 0 0 0 1.147 0l-.3-.652Z"
        }
      ),
      /* @__PURE__ */ jsx223(
        "path",
        {
          fill: "#6DA544",
          d: "M22.847 11.833s-.435.833-.435 1.667h2.174c0-.834-.435-1.667-.435-1.667l-.652-.417-.652.417Z"
        }
      ),
      /* @__PURE__ */ jsx223(
        "path",
        {
          fill: "#D80027",
          d: "M24.152 11.833v-.208A.639.639 0 0 0 23.5 11c-.36 0-.652.28-.652.625v.208h1.304Z"
        }
      ),
      /* @__PURE__ */ jsx223(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 1v1.79l-2.646 1.471H16v3.478h-3.463L16 9.663V11h-1.563L10.13 8.608V11H6.87V8.154L1.747 11H1V9.21l2.647-1.471H1V4.261h3.463L1 2.336V1h1.563L6.87 3.392V1h3.26v2.846L15.253 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx223(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx223("path", { fill: "#0052B4", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx223("path", { fill: "#FCFCFC", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx223(
        "path",
        {
          fill: "#D80027",
          d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66ZM5.21 7.739 1 10.078V11l5.87-3.261H5.21Z"
        }
      ),
      /* @__PURE__ */ jsx223("path", { fill: "#0052B4", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx223("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx223(
        "path",
        {
          fill: "#D80027",
          d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66ZM11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z"
        }
      ),
      /* @__PURE__ */ jsx223("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tc_default = SvgTc;

// build/Td.tsx
import { jsx as jsx224, jsxs as jsxs224 } from "react/jsx-runtime";
var SvgTd = (props) => /* @__PURE__ */ jsxs224(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx224("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx224("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx224("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx224("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Td_default = SvgTd;

// build/Tf.tsx
import { jsx as jsx225, jsxs as jsxs225 } from "react/jsx-runtime";
var SvgTf = (props) => /* @__PURE__ */ jsxs225(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx225("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx225("path", { fill: "#FCFCFC", d: "M16.2 1H1v10.2h15.2V1Z" }),
      /* @__PURE__ */ jsx225("path", { fill: "#0052B4", d: "M6 1H1v10h5V1Z" }),
      /* @__PURE__ */ jsx225("path", { fill: "#D80027", d: "M16 1h-5v10h5V1Z" }),
      /* @__PURE__ */ jsx225(
        "path",
        {
          fill: "#fff",
          d: "M24.263 18.084h.602l-.488.355.187.573-.488-.355-.488.355.186-.573-.488-.355h.604l.186-.574.187.574Zm-1.886-1h.603l-.489.355.187.573-.488-.355-.488.355.187-.573-.489-.355h.604l.186-.574.187.574Zm3.6 0h.603l-.488.355.186.573-.488-.355-.488.355.186-.573-.488-.355h.604l.186-.574.187.574ZM26.3 12H24.5v1h1.554l-.576.8H24.5v1.6l.7-1.4.9 2h-.5l-.1-.25h-.7l-.1.25h-.2l-.5.5-.5-.5h-.1l-.1-.25h-.7l-.1.25H22l1-2 .5 1.11V12h-1.799L21 11.2h6l-.7.8ZM22.8 15.25h.4l-.2-.45-.2.45Zm2.2 0h.4l-.2-.45-.2.45Zm-3.737-2.166h.602l-.488.354.187.574-.488-.355-.488.355.186-.574-.488-.354h.604l.186-.574.187.574Zm6 0h.602l-.488.354.187.574-.488-.355-.488.355.186-.574-.488-.354h.604l.186-.574.187.574Z"
        }
      ),
      /* @__PURE__ */ jsx225("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tf_default = SvgTf;

// build/Tg.tsx
import { jsx as jsx226, jsxs as jsxs226 } from "react/jsx-runtime";
var SvgTg = (props) => /* @__PURE__ */ jsxs226(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx226("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx226("path", { fill: "#496E2D", d: "M31 1H1v4h30V1ZM31 17H1v4h30v-4ZM31 9H1v4h30V9Z" }),
      /* @__PURE__ */ jsx226("path", { fill: "#D80027", d: "M12.956 1H1v11.957h11.956V1Z" }),
      /* @__PURE__ */ jsx226(
        "path",
        {
          fill: "#FCFCFC",
          d: "m6.979 3.848.777 2.391h2.514L8.236 7.717l.777 2.392L6.98 8.63l-2.034 1.478.777-2.392L3.687 6.24h2.515l.777-2.391Z"
        }
      ),
      /* @__PURE__ */ jsx226("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tg_default = SvgTg;

// build/Th.tsx
import { jsx as jsx227, jsxs as jsxs227 } from "react/jsx-runtime";
var SvgTh = (props) => /* @__PURE__ */ jsxs227(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx227("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx227("path", { fill: "#0052B4", d: "M31 7.37H1v7.26h30V7.37Z" }),
      /* @__PURE__ */ jsx227("path", { fill: "#D80027", d: "M31 1H1v3.195h30V1ZM31 17.805H1V21h30v-3.195Z" }),
      /* @__PURE__ */ jsx227("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Th_default = SvgTh;

// build/Tj.tsx
import { jsx as jsx228, jsxs as jsxs228 } from "react/jsx-runtime";
var SvgTj = (props) => /* @__PURE__ */ jsxs228(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx228("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx228("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx228("path", { fill: "#6DA544", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx228(
        "path",
        {
          fill: "#FFDA44",
          d: "M14.262 13.609h3.478V12.13l-.696.348-1.043-1.043-1.044 1.043-.695-.348v1.479ZM12.272 11.87l.162.498h.523l-.423.308.161.498-.423-.308-.424.308.162-.498-.424-.308h.524l.162-.498ZM12.774 10.13l.162.499h.523l-.423.308.162.498-.424-.308-.424.308.162-.498-.424-.308h.524l.162-.499ZM14.207 8.826l.162.498h.524l-.424.308.162.498-.424-.308-.424.308.162-.498-.424-.308h.524l.162-.498ZM19.729 11.87l-.162.498h-.524l.424.308-.162.498.424-.308.424.308-.162-.498.424-.308h-.524l-.162-.498ZM19.227 10.13l-.162.499h-.524l.424.308-.162.498.424-.308.424.308-.162-.498.424-.308h-.524l-.162-.499ZM17.793 8.826l-.162.498h-.524l.424.308-.162.498.424-.308.424.308-.162-.498.424-.308h-.524l-.162-.498ZM16 8.174l.162.498h.524l-.424.308.162.498L16 9.17l-.424.308.162-.498-.423-.308h.523L16 8.174Z"
        }
      ),
      /* @__PURE__ */ jsx228("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tj_default = SvgTj;

// build/Tk.tsx
import { jsx as jsx229, jsxs as jsxs229 } from "react/jsx-runtime";
var SvgTk = (props) => /* @__PURE__ */ jsxs229(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx229("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx229(
        "path",
        {
          fill: "#FCFCFC",
          d: "m13.347 6.217.216.665h.698l-.565.41.216.664-.565-.41-.565.41.216-.664-.565-.41h.698l.216-.665ZM7.845 12.522l.27.83h.873l-.706.513.27.83-.707-.513-.706.514.27-.83-.707-.514h.873l.27-.83ZM9.478 3.012l.27.83h.873l-.707.514.27.83-.706-.513-.707.513.27-.83-.706-.513h.873l.27-.83ZM5.075 6.273l.27.83h.872l-.706.514.27.83-.706-.513-.707.513.27-.83-.706-.513h.873l.27-.83Z"
        }
      ),
      /* @__PURE__ */ jsx229(
        "path",
        {
          fill: "#FFDA44",
          d: "M29.323 16.772H7.903s6.4-5.19 18.198-12.946c0 0-5.182 7.555 3.222 12.946ZM7.903 17.45c-.655 0-.656 1.018 0 1.018h21.42c.656 0 .657-1.017 0-1.017H7.904Z"
        }
      ),
      /* @__PURE__ */ jsx229("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tk_default = SvgTk;

// build/Tl.tsx
import { jsx as jsx230, jsxs as jsxs230 } from "react/jsx-runtime";
var SvgTl = (props) => /* @__PURE__ */ jsxs230(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx230("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx230(
        "path",
        {
          fill: "#FFDA44",
          d: "M16 11 1 1.314v2.592L10.13 11 1 18.094v2.592L16 11Z"
        }
      ),
      /* @__PURE__ */ jsx230("path", { fill: "#000", d: "M1 1.314v19.372L12.087 11 1 1.314Z" }),
      /* @__PURE__ */ jsx230(
        "path",
        {
          fill: "#FCFCFC",
          d: "m3.59 8.502 1.459 1.381 1.765-.962-.863 1.816 1.46 1.381-1.993-.26-.863 1.816-.369-1.976-1.993-.26 1.765-.96-.369-1.976Z"
        }
      ),
      /* @__PURE__ */ jsx230("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tl_default = SvgTl;

// build/Tm.tsx
import { jsx as jsx231, jsxs as jsxs231 } from "react/jsx-runtime";
var SvgTm = (props) => /* @__PURE__ */ jsxs231(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx231("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx231(
        "path",
        {
          fill: "#FCFCFC",
          d: "M21.93 6.762a3.044 3.044 0 0 0-1.246-3.605 3.043 3.043 0 1 1-2.008 5.596 3.044 3.044 0 0 0 3.254-1.99ZM19.201 2.78l-.427.553-.658-.236.393.578-.427.552.67-.196.394.578.021-.698.67-.196-.657-.236.021-.698Z"
        }
      ),
      /* @__PURE__ */ jsx231(
        "path",
        {
          fill: "#FCFCFC",
          d: "m20.355 4.58-.427.553-.658-.236.394.578-.428.552.67-.196.394.578.021-.699.67-.195-.657-.236.021-.698ZM17.166 3.436l-.428.553-.657-.236.393.577-.427.552.67-.195.394.577.02-.698.671-.196-.657-.236.021-.698ZM17.12 5.498l-.428.553-.658-.236.393.577-.427.552.67-.195.394.577.021-.698.67-.196-.657-.236.021-.698ZM19.082 6.202l-.427.553-.658-.236.393.577-.427.552.67-.195.394.577.02-.698.671-.196-.657-.236.021-.698Z"
        }
      ),
      /* @__PURE__ */ jsx231("path", { fill: "#D80027", d: "M11.108 1H5.891v20h5.217V1Z" }),
      /* @__PURE__ */ jsx231(
        "path",
        {
          fill: "#FCFCFC",
          d: "m7.883 6.265-.873-.65v-.921l.873-.65H9.12l.873.65v.92l-.873.651H7.883Z"
        }
      ),
      /* @__PURE__ */ jsx231(
        "path",
        {
          fill: "#FF9811",
          d: "M8.501 4.043h-.618l-.873.651v.45H8.5v-1.1ZM8.5 6.265h.618l.873-.65v-.47H8.5v1.12Z"
        }
      ),
      /* @__PURE__ */ jsx231(
        "path",
        {
          fill: "#FCFCFC",
          d: "m7.883 17.957-.873-.651v-.92l.873-.651H9.12l.873.65v.92l-.873.652H7.883Z"
        }
      ),
      /* @__PURE__ */ jsx231(
        "path",
        {
          fill: "#FF9811",
          d: "M8.501 15.735h-.618l-.873.65v.45H8.5v-1.1ZM8.5 17.957h.618l.873-.651v-.47H8.5v1.12Z"
        }
      ),
      /* @__PURE__ */ jsx231(
        "path",
        {
          fill: "#496E2D",
          d: "m7.883 12.11-.873-.65v-.92l.873-.65H9.12l.873.65v.92l-.873.65H7.883ZM10.022 13.543h-.38v-.38h-.67l-.472-.474-.472.473h-.669v.38h-.38v.761h.38v.38h.669l.472.474.473-.473h.669v-.38h.38v-.761ZM10.022 7.697h-.38v-.38h-.67L8.5 6.842l-.472.473h-.669v.38h-.38v.761h.38v.38h.669l.472.474.473-.473h.669v-.38h.38v-.761Z"
        }
      ),
      /* @__PURE__ */ jsx231(
        "path",
        {
          fill: "#D80027",
          d: "M8.934 10.565h-.87v.87h.87v-.87ZM8.5 8.512a.435.435 0 1 0 0-.87.435.435 0 0 0 0 .87ZM8.5 14.358a.435.435 0 1 0 0-.87.435.435 0 0 0 0 .87Z"
        }
      ),
      /* @__PURE__ */ jsx231("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tm_default = SvgTm;

// build/Tn.tsx
import { jsx as jsx232, jsxs as jsxs232 } from "react/jsx-runtime";
var SvgTn = (props) => /* @__PURE__ */ jsxs232(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx232("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx232(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 16.625a5.625 5.625 0 1 0 0-11.25 5.625 5.625 0 0 0 0 11.25Z"
        }
      ),
      /* @__PURE__ */ jsx232(
        "path",
        {
          fill: "#D80027",
          d: "m16.693 8.85.965 1.329 1.563-.507-.967 1.329.965 1.33-1.562-.51-.967 1.33.001-1.643-1.562-.51 1.563-.506V8.85Z"
        }
      ),
      /* @__PURE__ */ jsx232(
        "path",
        {
          fill: "#D80027",
          d: "M17.277 14.324a3.324 3.324 0 1 1 1.582-6.248 4.09 4.09 0 1 0 0 5.849 3.31 3.31 0 0 1-1.582.399Z"
        }
      ),
      /* @__PURE__ */ jsx232("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tn_default = SvgTn;

// build/To.tsx
import { jsx as jsx233, jsxs as jsxs233 } from "react/jsx-runtime";
var SvgTo = (props) => /* @__PURE__ */ jsxs233(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx233("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx233("path", { fill: "#FCFCFC", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx233(
        "path",
        {
          fill: "#D80027",
          d: "M9.283 5.217V3.652H7.718v1.565H6.152v1.565h1.566v1.565h1.565V6.782h1.565V5.217H9.283Z"
        }
      ),
      /* @__PURE__ */ jsx233("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var To_default = SvgTo;

// build/Tr.tsx
import { jsx as jsx234, jsxs as jsxs234 } from "react/jsx-runtime";
var SvgTr = (props) => /* @__PURE__ */ jsxs234(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx234("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx234(
        "path",
        {
          fill: "#FCFCFC",
          d: "m15.485 8.702 1.031 1.421 1.67-.541-1.033 1.42 1.03 1.42-1.668-.544-1.033 1.42.001-1.755-1.668-.544 1.669-.541.001-1.756Z"
        }
      ),
      /* @__PURE__ */ jsx234(
        "path",
        {
          fill: "#FCFCFC",
          d: "M12.671 14.551a3.551 3.551 0 1 1 1.69-6.675 4.37 4.37 0 1 0 0 6.248 3.534 3.534 0 0 1-1.69.427Z"
        }
      ),
      /* @__PURE__ */ jsx234("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tr_default = SvgTr;

// build/Tt.tsx
import { jsx as jsx235, jsxs as jsxs235 } from "react/jsx-runtime";
var SvgTt = (props) => /* @__PURE__ */ jsxs235(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx235("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx235(
        "path",
        {
          fill: "#FCFCFC",
          d: "m1.355 1 12.186 12.46L21.25 21h9.394L18.459 8.54 10.75 1H1.355Z"
        }
      ),
      /* @__PURE__ */ jsx235("path", { fill: "#000", d: "m3.54 1 20 20h4.92l-20-20H3.54Z" }),
      /* @__PURE__ */ jsx235("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tt_default = SvgTt;

// build/Tv.tsx
import { jsx as jsx236, jsxs as jsxs236 } from "react/jsx-runtime";
var SvgTv = (props) => /* @__PURE__ */ jsxs236(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx236("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx236(
        "path",
        {
          fill: "#FFDA44",
          d: "m19.85 15.565.216.664h.698l-.565.41.216.665-.565-.41-.565.41.216-.664-.566-.41h.699l.216-.665ZM25.412 11.217l.216.665h.699l-.565.41.215.664-.565-.41-.565.41.216-.664-.565-.41h.698l.216-.665ZM26.805 4.696l.216.664h.698l-.565.41.216.665-.565-.41-.565.41.216-.665-.565-.41h.698l.216-.664ZM27.15 9.478l.216.664h.699l-.565.41.216.665-.565-.41-.565.41.216-.664-.566-.41h.699l.216-.665ZM20.85 14.003l.623.317.494-.494-.11.69.623.317-.69.109-.11.69-.316-.623-.69.11.494-.494-.317-.622ZM20.85 11.394l.623.317.494-.494-.11.69.623.317-.69.11-.11.69-.316-.623-.69.11.494-.495-.317-.622ZM23.024 13.066l.623.317.494-.494-.11.69.623.317-.69.11-.11.69-.316-.623-.69.11.494-.495-.318-.622ZM23.024 7.481l.623.317.494-.494-.11.69.623.317-.69.11-.11.69-.316-.623-.69.11.494-.495-.318-.622ZM25.132 7.414l.622.317.494-.494-.11.69.623.317-.69.11-.109.69-.317-.623-.69.11.494-.495-.317-.622Z"
        }
      ),
      /* @__PURE__ */ jsx236("path", { fill: "#FCFCFC", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx236(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx236(
        "path",
        {
          fill: "#0052B4",
          d: "M12.537 7.739 16 9.663V7.739h-3.463ZM10.13 7.739l5.87 3.26v-.921l-4.21-2.339h-1.66ZM14.437 11l-4.306-2.393V11h4.306Z"
        }
      ),
      /* @__PURE__ */ jsx236("path", { fill: "#FCFCFC", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx236("path", { fill: "#D80027", d: "m10.13 7.739 5.87 3.26v-.921l-4.21-2.339h-1.66Z" }),
      /* @__PURE__ */ jsx236(
        "path",
        {
          fill: "#0052B4",
          d: "M3.647 7.739 1 9.209V7.74h2.647ZM6.869 8.154V11H1.746L6.87 8.154Z"
        }
      ),
      /* @__PURE__ */ jsx236("path", { fill: "#D80027", d: "M5.21 7.739 1 10.078V11l5.87-3.261H5.21Z" }),
      /* @__PURE__ */ jsx236(
        "path",
        {
          fill: "#0052B4",
          d: "M4.463 4.26 1 2.338V4.26h3.463ZM6.87 4.26 1 1v.922l4.21 2.339h1.66ZM2.564 1l4.307 2.392V1H2.564Z"
        }
      ),
      /* @__PURE__ */ jsx236("path", { fill: "#FCFCFC", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx236("path", { fill: "#D80027", d: "M6.87 4.26 1 1v.922l4.21 2.339h1.66Z" }),
      /* @__PURE__ */ jsx236(
        "path",
        {
          fill: "#0052B4",
          d: "M13.354 4.26 16 2.79v1.47h-2.646ZM10.13 3.846V1h5.124L10.13 3.846Z"
        }
      ),
      /* @__PURE__ */ jsx236("path", { fill: "#D80027", d: "M11.79 4.26 16 1.923V1l-5.87 3.26h1.66Z" }),
      /* @__PURE__ */ jsx236("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tv_default = SvgTv;

// build/Tw.tsx
import { jsx as jsx237, jsxs as jsxs237 } from "react/jsx-runtime";
var SvgTw = (props) => /* @__PURE__ */ jsxs237(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx237("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx237("path", { fill: "#0052B4", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx237(
        "path",
        {
          fill: "#FCFCFC",
          d: "m11.924 6-1.399.658.745 1.355-1.52-.29-.192 1.534L8.5 8.128l-1.058 1.13-.193-1.536-1.519.291.745-1.355L5.076 6l1.4-.658-.746-1.355 1.52.29.192-1.534L8.5 3.872l1.058-1.13.193 1.536 1.519-.291-.745 1.355L11.924 6Z"
        }
      ),
      /* @__PURE__ */ jsx237(
        "path",
        {
          fill: "#0052B4",
          d: "M8.5 7.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4Z"
        }
      ),
      /* @__PURE__ */ jsx237(
        "path",
        {
          fill: "#FCFCFC",
          d: "M8.5 7.136c-.627 0-1.137-.51-1.137-1.136 0-.626.51-1.136 1.136-1.136.627 0 1.137.51 1.137 1.136 0 .626-.51 1.136-1.137 1.136Z"
        }
      ),
      /* @__PURE__ */ jsx237("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tw_default = SvgTw;

// build/Tz.tsx
import { jsx as jsx238, jsxs as jsxs238 } from "react/jsx-runtime";
var SvgTz = (props) => /* @__PURE__ */ jsxs238(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx238("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx238("path", { fill: "#6DA544", d: "M1 21V1h30" }),
      /* @__PURE__ */ jsx238("path", { fill: "#FFDA44", d: "M31 4.92V1h-5.879L1 17.08V21h5.879L31 4.92Z" }),
      /* @__PURE__ */ jsx238("path", { fill: "#000", d: "M31 1v2.351L4.527 21H1v-2.351L27.473 1H31Z" }),
      /* @__PURE__ */ jsx238("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Tz_default = SvgTz;

// build/Ua.tsx
import { jsx as jsx239, jsxs as jsxs239 } from "react/jsx-runtime";
var SvgUa = (props) => /* @__PURE__ */ jsxs239(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx239("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx239("path", { fill: "#338AF3", d: "M31 1H1v10h30V1Z" }),
      /* @__PURE__ */ jsx239("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ua_default = SvgUa;

// build/Ug.tsx
import { jsx as jsx240, jsxs as jsxs240 } from "react/jsx-runtime";
var SvgUg = (props) => /* @__PURE__ */ jsxs240(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx240("path", { fill: "#000", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx240("path", { fill: "#FFDA44", d: "M31 4.333H1v3.334h30V4.333Z" }),
      /* @__PURE__ */ jsx240("path", { fill: "#D80027", d: "M31 7.667H1V11h30V7.667Z" }),
      /* @__PURE__ */ jsx240("path", { fill: "#FFDA44", d: "M31 14.333H1v3.334h30v-3.334Z" }),
      /* @__PURE__ */ jsx240("path", { fill: "#D80027", d: "M31 17.667H1V21h30v-3.333Z" }),
      /* @__PURE__ */ jsx240(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 14.337a3.337 3.337 0 1 0 0-6.674 3.337 3.337 0 0 0 0 6.674Z"
        }
      ),
      /* @__PURE__ */ jsx240(
        "path",
        {
          fill: "#000",
          d: "m17.223 11.17-1.222-.53s.286-.949.301-1.014a.65.65 0 0 0-.174-.609l.308-.307a1.083 1.083 0 0 0-1.538 0l.308.307a.65.65 0 0 0-.163.65l-.463.463h.841s-.348.523-.537.952a.877.877 0 0 0 .441 1.148l.254.112.422.397v.435l-.435.435h.87v-.87l.396-.397h.82l.013-.024a.87.87 0 0 0-.442-1.148Z"
        }
      ),
      /* @__PURE__ */ jsx240("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ug_default = SvgUg;

// build/Um.tsx
import { jsx as jsx241, jsxs as jsxs241 } from "react/jsx-runtime";
var SvgUm = (props) => /* @__PURE__ */ jsxs241(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx241("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx241(
        "path",
        {
          fill: "#FCFCFC",
          d: "M31 3H1v2h30V3ZM31 7H1v2h30V7ZM31 15H1v2h30v-2ZM31 19H1v2h30v-2ZM31 11H1v2h30v-2Z"
        }
      ),
      /* @__PURE__ */ jsx241("path", { fill: "#2E52B2", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx241(
        "path",
        {
          fill: "#FCFCFC",
          d: "m6.85 5-.242.743h-.782l.632.46-.241.742.632-.459.632.46-.241-.744.632-.459H7.09L6.85 5ZM7.09 8.543 6.85 7.8l-.242.743h-.782l.632.46-.241.743.632-.46.632.46-.241-.744.632-.459H7.09ZM3.788 8.543 3.546 7.8l-.241.743h-.782l.633.46-.242.743.632-.46.632.46-.241-.744.632-.459h-.781ZM3.546 5l-.241.743h-.782l.633.46-.242.742.632-.459.632.46-.241-.744.632-.459h-.781L3.546 5ZM6.85 2.2l-.242.743h-.782l.632.46-.241.743.632-.46.632.46-.241-.744.632-.459H7.09L6.85 2.2ZM3.546 2.2l-.241.743h-.782l.633.46-.242.743.632-.46.632.46-.241-.744.632-.459h-.781L3.546 2.2ZM10.152 5l-.242.743H9.13l.632.46-.241.742.632-.459.632.46-.242-.744.633-.459h-.782L10.152 5ZM10.393 8.543l-.241-.743-.242.743H9.13l.632.46-.241.743.632-.46.632.46-.242-.744.633-.459h-.782ZM13.696 8.543l-.241-.743-.242.743h-.781l.632.46-.242.743.633-.46.631.46-.241-.744.632-.459h-.781ZM13.455 5l-.242.743h-.781l.632.46-.242.742.633-.459.631.46-.241-.744.632-.459h-.781L13.455 5ZM10.152 2.2l-.242.743H9.13l.632.46-.241.743.632-.46.632.46-.242-.744.633-.459h-.782l-.241-.743ZM13.455 2.2l-.242.743h-.781l.632.46-.242.743.633-.46.631.46-.241-.744.632-.459h-.781l-.241-.743Z"
        }
      ),
      /* @__PURE__ */ jsx241("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Um_default = SvgUm;

// build/Un.tsx
import { jsx as jsx242, jsxs as jsxs242 } from "react/jsx-runtime";
var SvgUn = (props) => /* @__PURE__ */ jsxs242(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx242("path", { fill: "#338AF3", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx242(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16.014 7.546a3.462 3.462 0 1 0 0 6.923 3.462 3.462 0 0 0 0-6.923Zm-.865 3.461a.865.865 0 1 1 1.73 0 .865.865 0 0 1-1.73 0Zm1.763-1.48a1.723 1.723 0 0 0-.436-.188v-.886c.39.07.75.227 1.059.45l-.623.624Zm-1.302-.203c-.162.039-.315.1-.456.182l-.627-.627a2.582 2.582 0 0 1 1.083-.437v.882Zm-.456 3.184c.14.081.294.143.456.182v.882a2.581 2.581 0 0 1-1.083-.437l.627-.627Zm1.322.167c.155-.043.301-.106.436-.188l.623.624a2.58 2.58 0 0 1-1.06.45v-.886Zm1.04-.807c.076-.133.135-.277.175-.428h.883a2.582 2.582 0 0 1-.432 1.054l-.626-.626Zm.175-1.294a1.719 1.719 0 0 0-.175-.428l.626-.626c.216.309.367.667.432 1.054h-.884Zm-3.78-1.088.623.624a1.717 1.717 0 0 0-.196.464h-.883c.067-.401.226-.771.456-1.088Zm-.456 1.954h.883c.043.165.11.322.196.464l-.623.623a2.581 2.581 0 0 1-.456-1.087Z"
        }
      ),
      /* @__PURE__ */ jsx242(
        "path",
        {
          fill: "#FCFCFC",
          d: "M21.639 11.007a5.607 5.607 0 0 0-1.62-3.948l-.917.918a4.327 4.327 0 1 1-6.148-.03l-.918-.917a5.627 5.627 0 0 0 2.442 9.39 1.44 1.44 0 0 0 .15 1.571l1.415-1.133 1.414 1.133a1.44 1.44 0 0 0 .143-1.586 5.627 5.627 0 0 0 4.039-5.398Z"
        }
      ),
      /* @__PURE__ */ jsx242("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Un_default = SvgUn;

// build/Us.tsx
import { jsx as jsx243, jsxs as jsxs243 } from "react/jsx-runtime";
var SvgUs = (props) => /* @__PURE__ */ jsxs243(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx243("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx243(
        "path",
        {
          fill: "#FCFCFC",
          d: "M31 3H1v2h30V3ZM31 7H1v2h30V7ZM31 15H1v2h30v-2ZM31 19H1v2h30v-2ZM31 11H1v2h30v-2Z"
        }
      ),
      /* @__PURE__ */ jsx243("path", { fill: "#2E52B2", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx243(
        "path",
        {
          fill: "#FCFCFC",
          d: "m6.85 5-.242.743h-.782l.632.46-.241.742.632-.459.632.46-.241-.744.632-.459H7.09L6.85 5ZM7.09 8.543 6.85 7.8l-.242.743h-.782l.632.46-.241.743.632-.46.632.46-.241-.744.632-.459H7.09ZM3.788 8.543 3.546 7.8l-.241.743h-.782l.633.46-.242.743.632-.46.632.46-.241-.744.632-.459h-.781ZM3.546 5l-.241.743h-.782l.633.46-.242.742.632-.459.632.46-.241-.744.632-.459h-.781L3.546 5ZM6.85 2.2l-.242.743h-.782l.632.46-.241.743.632-.46.632.46-.241-.744.632-.459H7.09L6.85 2.2ZM3.546 2.2l-.241.743h-.782l.633.46-.242.743.632-.46.632.46-.241-.744.632-.459h-.781L3.546 2.2ZM10.152 5l-.242.743H9.13l.632.46-.241.742.632-.459.632.46-.242-.744.633-.459h-.782L10.152 5ZM10.393 8.543l-.241-.743-.242.743H9.13l.632.46-.241.743.632-.46.632.46-.242-.744.633-.459h-.782ZM13.696 8.543l-.241-.743-.242.743h-.781l.632.46-.242.743.633-.46.631.46-.241-.744.632-.459h-.781ZM13.455 5l-.242.743h-.781l.632.46-.242.742.633-.459.631.46-.241-.744.632-.459h-.781L13.455 5ZM10.152 2.2l-.242.743H9.13l.632.46-.241.743.632-.46.632.46-.242-.744.633-.459h-.782l-.241-.743ZM13.455 2.2l-.242.743h-.781l.632.46-.242.743.633-.46.631.46-.241-.744.632-.459h-.781l-.241-.743Z"
        }
      ),
      /* @__PURE__ */ jsx243("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Us_default = SvgUs;

// build/Uy.tsx
import { jsx as jsx244, jsxs as jsxs244 } from "react/jsx-runtime";
var SvgUy = (props) => /* @__PURE__ */ jsxs244(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx244("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx244(
        "path",
        {
          fill: "#338AF3",
          d: "M31 1H1v2.857h30V1ZM31 6.714H1v2.858h30V6.714ZM31 12.429H1v2.857h30V12.43ZM31 18.143H1V21h30v-2.857Z"
        }
      ),
      /* @__PURE__ */ jsx244("path", { fill: "#FCFCFC", d: "M16 1H1v11.429h15V1Z" }),
      /* @__PURE__ */ jsx244(
        "path",
        {
          fill: "#FFDA44",
          d: "m12.25 6.714-1.532.72.816 1.485-1.664-.318-.211 1.68L8.5 9.046l-1.159 1.237-.21-1.681-1.665.318.816-1.484-1.532-.72 1.532-.722-.816-1.484 1.664.319.211-1.681L8.5 4.383l1.159-1.236.21 1.68 1.665-.318-.816 1.484 1.532.721Z"
        }
      ),
      /* @__PURE__ */ jsx244("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Uy_default = SvgUy;

// build/Uz.tsx
import { jsx as jsx245, jsxs as jsxs245 } from "react/jsx-runtime";
var SvgUz = (props) => /* @__PURE__ */ jsxs245(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx245("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx245("path", { fill: "#6DA544", d: "M31 14.913H1V21h30v-6.087Z" }),
      /* @__PURE__ */ jsx245("path", { fill: "#338AF3", d: "M31 1H1v6.124h30V1Z" }),
      /* @__PURE__ */ jsx245("path", { fill: "#FCFCFC", d: "M31 8.356H1v5.253h30V8.356Z" }),
      /* @__PURE__ */ jsx245("path", { fill: "#338AF3", d: "M31 1H1v6.124h30V1Z" }),
      /* @__PURE__ */ jsx245(
        "path",
        {
          fill: "#FCFCFC",
          d: "M12.055 4.062c0-.937.659-1.72 1.537-1.911a1.956 1.956 0 1 0 0 3.822 1.957 1.957 0 0 1-1.537-1.911ZM14.748 4.951l.133.408h.429l-.347.252.132.407-.347-.252-.346.252.132-.407-.347-.252h.43l.131-.408ZM16.118 4.951l.132.408h.429l-.347.252.132.407-.346-.252-.347.252.132-.407-.346-.252h.428l.133-.408ZM17.485 4.951l.132.408h.429l-.347.252.133.407-.347-.252-.347.252.133-.407-.347-.252h.428l.133-.408ZM18.854 4.951l.133.408h.428l-.347.252.133.407-.347-.252-.347.252.133-.407-.347-.252h.428l.133-.408ZM20.221 4.951l.133.408h.428l-.346.252.132.407-.347-.252-.347.252.133-.407-.347-.252h.429l.132-.408ZM16.118 3.528l.132.408h.429l-.347.252.132.407-.346-.252-.347.252.132-.407-.346-.252h.428l.133-.408ZM17.485 3.528l.132.408h.429l-.347.252.133.407-.347-.252-.347.252.133-.407-.347-.252h.428l.133-.408ZM18.854 3.528l.133.408h.428l-.347.252.133.407-.347-.252-.347.252.133-.407-.347-.252h.428l.133-.408ZM20.221 3.528l.133.408h.428l-.346.252.132.407-.347-.252-.347.252.133-.407-.347-.252h.429l.132-.408ZM17.485 2.105l.132.408h.429l-.347.252.133.407-.347-.252-.347.252.133-.407-.347-.252h.428l.133-.408ZM18.854 2.105l.133.408h.428l-.347.252.133.407-.347-.252-.347.252.133-.407-.347-.252h.428l.133-.408ZM20.221 2.105l.133.408h.428l-.346.252.132.407-.347-.252-.347.252.133-.407-.347-.252h.429l.132-.408Z"
        }
      ),
      /* @__PURE__ */ jsx245("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Uz_default = SvgUz;

// build/Va.tsx
import { jsx as jsx246, jsxs as jsxs246 } from "react/jsx-runtime";
var SvgVa = (props) => /* @__PURE__ */ jsxs246(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx246("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx246("path", { fill: "#FCFCFC", d: "M31 1H16v20h15V1Z" }),
      /* @__PURE__ */ jsx246(
        "path",
        {
          fill: "#ACABB1",
          d: "m19.83 9.701 1.879 2.486a1.305 1.305 0 1 0 .693-.524l-2.928-3.875-.694.525-1.04.786 1.048 1.388 1.041-.786Zm2.705 2.859a.435.435 0 1 1 .525.693.435.435 0 0 1-.525-.693Z"
        }
      ),
      /* @__PURE__ */ jsx246(
        "path",
        {
          fill: "#FFDA44",
          d: "m23.053 10.487 1.049-1.388-1.041-.786-.694-.524-2.929 3.874a1.304 1.304 0 1 0 .694.525l1.88-2.486 1.04.785Zm-3.663 2.682a.435.435 0 1 1-.693-.525.435.435 0 0 1 .694.525Z"
        }
      ),
      /* @__PURE__ */ jsx246("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Va_default = SvgVa;

// build/Vc.tsx
import { jsx as jsx247, jsxs as jsxs247 } from "react/jsx-runtime";
var SvgVc = (props) => /* @__PURE__ */ jsxs247(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx247("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx247("path", { fill: "#338AF3", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx247(
        "path",
        {
          fill: "#6DA544",
          d: "M31 1H21v20h10V1ZM13.554 12.63l-1.956-2.935 1.956-2.934 1.957 2.934-1.957 2.935ZM18.445 12.63l-1.957-2.935 1.957-2.934L20.4 9.695l-1.956 2.935ZM16 16.543l-1.957-2.935L16 10.674l1.956 2.934-1.957 2.935Z"
        }
      ),
      /* @__PURE__ */ jsx247("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Vc_default = SvgVc;

// build/Ve.tsx
import { jsx as jsx248, jsxs as jsxs248 } from "react/jsx-runtime";
var SvgVe = (props) => /* @__PURE__ */ jsxs248(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx248("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx248("path", { fill: "#0052B4", d: "M31 6.652H1v8.696h30V6.652Z" }),
      /* @__PURE__ */ jsx248(
        "path",
        {
          fill: "#FCFCFC",
          d: "m22.522 12.75-.47.367.204.561-.496-.334-.47.368.164-.574-.495-.334.597-.021.165-.574.204.561.597-.02ZM21.317 10.662l-.316.506.383.458-.579-.144-.317.506-.041-.596-.58-.144.554-.224-.042-.596.384.457.554-.223ZM19.47 9.112l-.123.585.517.298-.594.063-.125.584-.242-.546-.594.063.443-.4-.242-.546.517.299.444-.4ZM17.205 8.288l.083.591.588.104-.537.262.083.592-.415-.43-.537.262.28-.528-.414-.43.588.104.28-.527ZM14.794 8.288l.28.527.589-.103-.415.43.28.527-.536-.262-.415.43.083-.592-.537-.262.588-.104.083-.591ZM12.53 9.112l.444.4.517-.299-.243.546.444.4-.594-.063-.243.546-.124-.584-.594-.063.517-.298-.124-.585ZM10.683 10.662l.553.223.384-.457-.041.596.553.224-.58.144-.04.596-.317-.507-.58.145.384-.458-.316-.506ZM9.479 12.75l.597.02.204-.561.165.574.596.02-.495.335.165.574-.47-.368-.496.334.204-.561-.47-.368Z"
        }
      ),
      /* @__PURE__ */ jsx248("path", { fill: "#FFDA44", d: "M31 1H1v5.652h30V1Z" }),
      /* @__PURE__ */ jsx248("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ve_default = SvgVe;

// build/Vg.tsx
import { jsx as jsx249, jsxs as jsxs249 } from "react/jsx-runtime";
var SvgVg = (props) => /* @__PURE__ */ jsxs249(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx249("path", { fill: "#0052B4", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx249(
        "path",
        {
          fill: "#FCFCFC",
          d: "M16 1v6.875h-2.7l2.7 1.8V11h-1.326l-4.299-2.866V11h-3.75V8.134L2.325 11H1V9.675l2.7-1.8H1v-3.75h2.7L1 2.325V1h1.326l4.299 2.866V1h3.75v2.866L14.675 1H16Z"
        }
      ),
      /* @__PURE__ */ jsx249(
        "path",
        {
          fill: "#D80027",
          d: "M9.438 1H7.562v4.062H1v1.875h6.563V11h1.875V6.937H16V5.062H9.437V1Z"
        }
      ),
      /* @__PURE__ */ jsx249(
        "path",
        {
          fill: "#D80027",
          d: "M1 1v.884l3.362 2.241h1.325L1 1ZM16 1v.884l-3.362 2.241h-1.325L16 1Z"
        }
      ),
      /* @__PURE__ */ jsx249("path", { fill: "#2E52B2", d: "M16 2.325v1.8h-2.7l2.7-1.8Z" }),
      /* @__PURE__ */ jsx249(
        "path",
        {
          fill: "#D80027",
          d: "M1 1v.884l3.362 2.241h1.325L1 1ZM16 1v.884l-3.362 2.241h-1.325L16 1Z"
        }
      ),
      /* @__PURE__ */ jsx249("path", { fill: "#2E52B2", d: "M16 2.325v1.8h-2.7l2.7-1.8Z" }),
      /* @__PURE__ */ jsx249(
        "path",
        {
          fill: "#D80027",
          d: "M1 11v-.884l3.362-2.241h1.325L1 11ZM16 11v-.884l-3.362-2.241h-1.325L16 11Z"
        }
      ),
      /* @__PURE__ */ jsx249(
        "path",
        {
          fill: "#FFDA44",
          d: "m23.5 11.217-2.703 2.703a3.042 3.042 0 0 0 5.406 0L23.5 11.217Z"
        }
      ),
      /* @__PURE__ */ jsx249(
        "path",
        {
          fill: "#6DA544",
          d: "M20.457 6.435v4.782c0 2.33 3.043 3.044 3.043 3.044s3.044-.714 3.044-3.044V6.435h-6.087Z"
        }
      ),
      /* @__PURE__ */ jsx249("path", { fill: "#FCFCFC", d: "M24.152 8.608h-1.304v3.478h1.304V8.608Z" }),
      /* @__PURE__ */ jsx249(
        "path",
        {
          fill: "#A2001D",
          d: "M23.5 9.26a.652.652 0 1 0 0-1.304.652.652 0 0 0 0 1.304Z"
        }
      ),
      /* @__PURE__ */ jsx249(
        "path",
        {
          fill: "#FFDA44",
          d: "M22.196 7.304h-.87v.87h.87v-.87ZM22.196 9.26h-.87v.87h.87v-.87ZM22.196 11.217h-.87v.87h.87v-.87ZM25.674 7.304h-.87v.87h.87v-.87ZM25.674 9.26h-.87v.87h.87v-.87ZM25.674 11.217h-.87v.87h.87v-.87Z"
        }
      ),
      /* @__PURE__ */ jsx249("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Vg_default = SvgVg;

// build/Vi.tsx
import { jsx as jsx250, jsxs as jsxs250 } from "react/jsx-runtime";
var SvgVi = (props) => /* @__PURE__ */ jsxs250(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx250("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx250(
        "path",
        {
          fill: "#FFDA44",
          d: "M17.698 7.986a1.698 1.698 0 0 0-3.397 0h-3.736c0 .923.804 1.672 1.727 1.672h-.055c0 .924.748 1.672 1.672 1.672 0 .818.587 1.497 1.363 1.643l-.005.01h1.464l-.004-.01a1.672 1.672 0 0 0 1.363-1.643c.923 0 1.672-.748 1.672-1.672h-.056c.924 0 1.728-.749 1.728-1.672h-3.736Z"
        }
      ),
      /* @__PURE__ */ jsx250(
        "path",
        {
          fill: "#FFDA44",
          d: "m15.254 12.81-1.053 2.377a4.765 4.765 0 0 0 1.8.351c.637 0 1.244-.126 1.8-.351l-1.054-2.378h-1.493Z"
        }
      ),
      /* @__PURE__ */ jsx250(
        "path",
        {
          fill: "#FCFCFC",
          d: "M13.826 8.821v2.925C13.826 13.41 16 13.92 16 13.92s2.174-.51 2.174-2.174V8.821h-4.348Z"
        }
      ),
      /* @__PURE__ */ jsx250(
        "path",
        {
          fill: "#338AF3",
          d: "m8.425 11.07 1.176 3.288 1.163-3.288h.888l-1.696 4.348h-.71L7.537 11.07h.888ZM22.088 15.418V11.07h.845v4.348h-.845Z"
        }
      ),
      /* @__PURE__ */ jsx250(
        "path",
        {
          fill: "#D80027",
          d: "M14.695 9.766v3.545c.3.22.62.371.87.468V9.766h-.87ZM17.305 9.766v3.545c-.299.22-.62.371-.87.468V9.766h.87Z"
        }
      ),
      /* @__PURE__ */ jsx250("path", { fill: "#0052B4", d: "M18.174 8.82h-4.348v1.38h4.348V8.82Z" }),
      /* @__PURE__ */ jsx250("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Vi_default = SvgVi;

// build/Vn.tsx
import { jsx as jsx251, jsxs as jsxs251 } from "react/jsx-runtime";
var SvgVn = (props) => /* @__PURE__ */ jsxs251(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx251("path", { fill: "#D80027", d: "M12.522 1H1v20h30V1H12.522Z" }),
      /* @__PURE__ */ jsx251(
        "path",
        {
          fill: "#FFDA44",
          d: "m16 5.215 1.328 4.087h4.297l-3.477 2.526 1.329 4.087L16 13.389l-3.476 2.526 1.328-4.087-3.477-2.526h4.297L16 5.215Z"
        }
      ),
      /* @__PURE__ */ jsx251("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Vn_default = SvgVn;

// build/Vu.tsx
import { jsx as jsx252, jsxs as jsxs252 } from "react/jsx-runtime";
var SvgVu = (props) => /* @__PURE__ */ jsxs252(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx252("path", { fill: "#000", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx252("path", { fill: "#6DA544", d: "M31 11v10H1l12.608-10H31Z" }),
      /* @__PURE__ */ jsx252("path", { fill: "#D80027", d: "M31 1v10H13.608L1 1h30Z" }),
      /* @__PURE__ */ jsx252(
        "path",
        {
          fill: "#000",
          d: "M13.949 10.022 2.574 1h-1.05l12.198 9.674H31v-.652H13.949ZM1.524 21h1.05l11.375-9.022h17.05v-.652H13.723L1.524 21ZM1 1.416v.833L12.034 11 1 19.751v.833L13.084 11 1 1.416Z"
        }
      ),
      /* @__PURE__ */ jsx252(
        "path",
        {
          fill: "#FFDA44",
          d: "M1.525 1H1v.416L13.084 11 1 20.584V21h.525l12.197-9.674H31v-.652H13.722L1.525 1Z"
        }
      ),
      /* @__PURE__ */ jsx252(
        "path",
        {
          fill: "#FFDA44",
          d: "M4.733 13.132v-.838c.836 0 1.516-.68 1.516-1.516 0-.59-.481-1.072-1.072-1.072a.731.731 0 0 0-.731.73c0 .258.21.468.467.468a.264.264 0 0 0 .264-.264h.838c0 .607-.494 1.101-1.102 1.101-.72 0-1.305-.585-1.305-1.304a1.57 1.57 0 0 1 1.569-1.569c1.053 0 1.91.857 1.91 1.91a2.356 2.356 0 0 1-2.354 2.354Z"
        }
      ),
      /* @__PURE__ */ jsx252("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Vu_default = SvgVu;

// build/Wf.tsx
import { jsx as jsx253, jsxs as jsxs253 } from "react/jsx-runtime";
var SvgWf = (props) => /* @__PURE__ */ jsxs253(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx253("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx253("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx253("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx253("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Wf_default = SvgWf;

// build/Ws.tsx
import { jsx as jsx254, jsxs as jsxs254 } from "react/jsx-runtime";
var SvgWs = (props) => /* @__PURE__ */ jsxs254(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx254("path", { fill: "#D80027", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx254("path", { fill: "#0052B4", d: "M16 1H1v10h15V1Z" }),
      /* @__PURE__ */ jsx254(
        "path",
        {
          fill: "#FCFCFC",
          d: "m10.695 6.652.162.498h.524l-.424.308.162.498-.424-.308-.423.308.162-.498-.424-.308h.524l.161-.498ZM8.065 2.739l.27.83h.873l-.707.513.27.83-.706-.512-.707.513.27-.83-.706-.514h.873l.27-.83ZM10.674 3.608l.27.83h.873l-.706.514.27.83-.707-.513-.706.513.27-.83-.707-.513h.873l.27-.83ZM8.612 7.087l.27.83h.873l-.707.513.27.83-.706-.513-.707.514.27-.83-.706-.514h.873l.27-.83ZM6.327 4.913l.27.83h.872l-.706.513.27.83-.706-.513-.707.514.27-.83-.706-.514h.873l.27-.83Z"
        }
      ),
      /* @__PURE__ */ jsx254("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ws_default = SvgWs;

// build/Xz.tsx
import { jsx as jsx255, jsxs as jsxs255 } from "react/jsx-runtime";
var SvgXz = (props) => /* @__PURE__ */ jsxs255(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx255("path", { fill: "#FFDA44", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx255("path", { fill: "#D80027", d: "M29.696 2.304H2.305v17.392h27.391V2.304Z" }),
      /* @__PURE__ */ jsx255(
        "path",
        {
          fill: "#0052B4",
          d: "M22.686 19.695h7.01v-4.117L16 11.461l3.28 5.36 3.406 2.874ZM29.696 5.786 16 11.461h13.696V5.786ZM19.794 2.304 16 11.461l9.157-9.157h-5.363ZM12.205 2.304 16 11.461V2.304h-3.795ZM2.305 2.304v3.482L16 11.461 6.843 2.304H2.305ZM2.305 11.461v4.117L16 11.461H2.305Z"
        }
      ),
      /* @__PURE__ */ jsx255(
        "path",
        {
          fill: "#FFDA44",
          d: "m16.145 11.602 2.854 1.988a3.478 3.478 0 1 0-4.842.867l1.988-2.855Z"
        }
      ),
      /* @__PURE__ */ jsx255("path", { fill: "#FCFCFC", d: "M29.84 19.69H2.45l13.695-8.088L29.84 19.69Z" }),
      /* @__PURE__ */ jsx255(
        "path",
        {
          fill: "#FFDA44",
          d: "M17.522 16.608c0 .84-.681 1.087-1.522 1.087-.84 0-1.521-.246-1.521-1.087a1.522 1.522 0 1 1 3.043 0Z"
        }
      ),
      /* @__PURE__ */ jsx255("path", { fill: "#0052B4", d: "M17.522 16.608a1.522 1.522 0 0 1-3.043 0" }),
      /* @__PURE__ */ jsx255("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Xz_default = SvgXz;

// build/Ye.tsx
import { jsx as jsx256, jsxs as jsxs256 } from "react/jsx-runtime";
var SvgYe = (props) => /* @__PURE__ */ jsxs256(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx256("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx256("path", { fill: "#D80027", d: "M31 1H1v6.667h30V1Z" }),
      /* @__PURE__ */ jsx256("path", { fill: "#000", d: "M31 14.333H1V21h30v-6.667Z" }),
      /* @__PURE__ */ jsx256("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Ye_default = SvgYe;

// build/Yt.tsx
import { jsx as jsx257, jsxs as jsxs257 } from "react/jsx-runtime";
var SvgYt = (props) => /* @__PURE__ */ jsxs257(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx257("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx257("path", { fill: "#0052B4", d: "M11 1H1v20h10V1Z" }),
      /* @__PURE__ */ jsx257("path", { fill: "#D80027", d: "M31 1H21v20h10V1Z" }),
      /* @__PURE__ */ jsx257("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Yt_default = SvgYt;

// build/Za.tsx
import { jsx as jsx258, jsxs as jsxs258 } from "react/jsx-runtime";
var SvgZa = (props) => /* @__PURE__ */ jsxs258(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx258("path", { fill: "#FCFCFC", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx258("path", { fill: "#000", d: "M7.681 11 1 4.316v13.37L7.681 11Z" }),
      /* @__PURE__ */ jsx258(
        "path",
        {
          fill: "#FFDA44",
          d: "M10.445 11 1 1.549v2.767L7.681 11 1 17.686v2.762L10.445 11Z"
        }
      ),
      /* @__PURE__ */ jsx258(
        "path",
        {
          fill: "#6DA544",
          d: "M30.873 12.957c.003-.026.047-.052.127-.078V9.043H14.043L6 1H1v.549L10.445 11 1 20.448V21h5l8.043-8.043h16.83Z"
        }
      ),
      /* @__PURE__ */ jsx258("path", { fill: "#0052B4", d: "M30.484 14.913h-15.63L8.768 21H31v-6.087h-.517Z" }),
      /* @__PURE__ */ jsx258("path", { fill: "#D80027", d: "M30.484 7.087h.517V1H8.768l6.086 6.087h15.63Z" }),
      /* @__PURE__ */ jsx258("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Za_default = SvgZa;

// build/Zm.tsx
import { jsx as jsx259, jsxs as jsxs259 } from "react/jsx-runtime";
var SvgZm = (props) => /* @__PURE__ */ jsxs259(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx259("path", { fill: "#496E2D", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx259(
        "path",
        {
          fill: "#FF9811",
          d: "M29.75 7.454h-2.813a.938.938 0 0 0-1.875 0H22.25c0 .517.451.937.969.937h-.032c0 .518.42.938.938.938 0 .517.42.937.938.937h1.875c.517 0 .937-.42.937-.937.518 0 .938-.42.938-.938h-.032c.518 0 .969-.42.969-.937Z"
        }
      ),
      /* @__PURE__ */ jsx259("path", { fill: "#D80027", d: "M24.333 11H21v10h3.333V11Z" }),
      /* @__PURE__ */ jsx259("path", { fill: "#FF9811", d: "M31 11h-3.334v10h3.333V11Z" }),
      /* @__PURE__ */ jsx259("path", { fill: "#000", d: "M27.667 11h-3.333v10h3.333V11Z" }),
      /* @__PURE__ */ jsx259("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Zm_default = SvgZm;

// build/Zw.tsx
import { jsx as jsx260, jsxs as jsxs260 } from "react/jsx-runtime";
var SvgZw = (props) => /* @__PURE__ */ jsxs260(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    fill: "none",
    ...props,
    children: [
      /* @__PURE__ */ jsx260("path", { fill: "#000", d: "M31 1H1v20h30V1Z" }),
      /* @__PURE__ */ jsx260(
        "path",
        {
          fill: "#FFDA44",
          d: "M31 3.863H1v2.863h30V3.863ZM31 15.316H1v2.864h30v-2.864Z"
        }
      ),
      /* @__PURE__ */ jsx260("path", { fill: "#6DA544", d: "M31 1H1v2.863h30V1Z" }),
      /* @__PURE__ */ jsx260(
        "path",
        {
          fill: "#D80027",
          d: "M31 6.727H1V9.59h30V6.727ZM31 12.453H1v2.864h30v-2.864Z"
        }
      ),
      /* @__PURE__ */ jsx260("path", { fill: "#6DA544", d: "M31 18.18H1V21h30v-2.82Z" }),
      /* @__PURE__ */ jsx260("path", { fill: "#FCFCFC", d: "m17.23 11-10 10H1V1h6.23l10 10Z" }),
      /* @__PURE__ */ jsx260("path", { fill: "#000", d: "M16 11 6 21h1.23l10-10-10-10H6l10 10Z" }),
      /* @__PURE__ */ jsx260(
        "path",
        {
          fill: "#D80027",
          d: "m7.004 7.87.777 2.39h2.515L8.262 11.74l.777 2.391-2.035-1.478L4.97 14.13l.777-2.391-2.034-1.478h2.514l.777-2.392Z"
        }
      ),
      /* @__PURE__ */ jsx260(
        "path",
        {
          fill: "#FFDA44",
          d: "m9.142 11.195-2.025-.717s-.15-1.404-.159-1.451a.783.783 0 1 0-1.523.354l-.568.571h1.01c0 1.048-.782 1.048-.782 2.091l.434 1.044h2.608l.435-1.044c.043-.1.07-.203.08-.306.376-.152.49-.542.49-.542Z"
        }
      ),
      /* @__PURE__ */ jsx260("rect", { width: 31, height: 21, x: 0.5, y: 0.5, stroke: "#BBB", rx: 2.5 })
    ]
  }
);
var Zw_default = SvgZw;

// index.ts
import { countriesData as rawCountriesData } from "@boi/country-assets";
var allFlags = build_exports;
var countriesData = rawCountriesData.map((country) => {
  const componentName = country.code.charAt(0).toUpperCase() + country.code.slice(1).toLowerCase();
  const CountryFlagComponent = allFlags[componentName];
  return {
    ...country,
    component: CountryFlagComponent
  };
});
export {
  countriesData
};
